//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IFieldClient {
    /**
     * Consumes 1 Datetime to retrieve data for whole month.
     * @param dt (optional) 
     */
    getPurgePilotEntries(dt: Date | undefined): Observable<PurgePilotEntriesDTO[]>;
    /**
     * Consumes 1 Datetime to retrieve data for whole month.
     * @param dt (optional) 
     */
    getRecordTablesData(dt: Date | undefined): Observable<RecordTablesDTO[]>;
    flaringReport(area: string | undefined, dt: Date | undefined): Observable<FileResponse | null>;
    gasBalanceReport(dt: Date | undefined): Observable<FileResponse | null>;
    tGGSValues(startTime: Date | undefined): Observable<FileResponse | null>;
    getTotalVolumeMass(startTime: Date | undefined): Observable<FileResponse | null>;
    fieldTotals(startTime: Date | undefined): Observable<FieldTotal[]>;
    getLatestUserAction(startTime: Date | undefined, actionType: ActionTypeEnumDTO | undefined): Observable<string>;
    finalReportGasBalance(startTime: Date | undefined): Observable<FileResponse | null>;
    finalReportFlaringReport(startTime: Date | undefined, field: string | undefined): Observable<FileResponse | null>;
    fieldPurgePilots(startTime: Date | undefined): Observable<FileResponse | null>;
    setPurgePilotDays(fdInput: PurgePilotDTO[], startTime: Date | undefined): Observable<FileResponse | null>;
    confirmPurgePilotDays(fdInput: PurgePilotDTO[], startTime: Date | undefined): Observable<FileResponse | null>;
    addFieldRecord(fdInputDTO: RecordDTO): Observable<FileResponse | null>;
    pressureTemperatureGraph(dt: Date | undefined, location: string | undefined): Observable<PressureTemperatureGraphDTO>;
    addFieldRecord2(fdInputDTO: RecordOperatorDTO): Observable<FileResponse | null>;
    getOperatorTableNabor(date: Date | undefined): Observable<RecordOperatorDTO[]>;
    getOperatorTableSzhiganiye(date: Date | undefined): Observable<RecordOperatorDTO[]>;
    getOperatorPurgePilotSwitch(date: Date | undefined): Observable<RecordOperatorDTO[]>;
    changeFieldRecord(fdInputDTO: RecordDTO): Observable<FileResponse | null>;
    deleteFieldRecord(id: number | undefined, startTime: Date | null | undefined, userName: string | null | undefined): Observable<FileResponse | null>;
    pBFCC(timestamp: Date | undefined, isPBF: boolean | undefined): Observable<FileResponse | null>;
    getPBFCC(timestamp: Date | undefined): Observable<boolean>;
    confirmCalc(startTime: Date | undefined, gasType: string | undefined): Observable<FileResponse | null>;
    setMonthlyLeaksToNow(startTime: Date | undefined, gasType: string | undefined): Observable<FileResponse | null>;
    approveByChef(startTime: Date | undefined): Observable<FileResponse | null>;
    chemicalCompounds(startTime: Date | undefined): Observable<FileResponse | null>;
    setFieldToDryFlaredPE(gasBlowdownDTO: RecordBledFullyDTO): Observable<FileResponse | null>;
    setFieldToDryFlared(gasBlowdownDTO: RecordBledFullyDTO): Observable<FileResponse | null>;
    setBledFully(id: number | undefined, startTime: Date | undefined): Observable<FileResponse | null>;
    operatorChangeFieldRecord(fdInputDTO: OperatorRecordDTO): Observable<FileResponse | null>;
    operatorDeleteFieldRecord(id: number | undefined, startTime: Date | null | undefined): Observable<FileResponse | null>;
    operatorChangePurgePilotRecord(fdInputDTO: RecordOperatorDTO): Observable<FileResponse | null>;
    addFieldPermitTargetInput(fieldPermitTargetInputDTO: FieldPermitTargetInputDTO): Observable<FileResponse | null>;
    editFieldPermitTargetInput(permitTargetInputEditDTO: PermitTargetInputEditDTO): Observable<FileResponse | null>;
    deleteFieldPermitTargetInput(id: number | undefined): Observable<FileResponse | null>;
    addPerformanceMetricsPermitTargetInput(performanceMetricsPermitTargetInputDTO: PerformanceMetricsPermitTargetInputDTO): Observable<FileResponse | null>;
    deletePerformanceMetricsPermitTargetInput(id: number | undefined): Observable<FileResponse | null>;
    exportDryGas(dt: Date | undefined): Observable<FileResponse | null>;
    exportReservoirGas(dt: Date | undefined): Observable<FileResponse | null>;
    mSLocationsList(): Observable<FacilityLocationListDTO[]>;
    exportPurgePilot(dt: Date | undefined): Observable<FileResponse | null>;
    exportFuelGas(dt: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class FieldClient implements IFieldClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Consumes 1 Datetime to retrieve data for whole month.
     * @param dt (optional) 
     */
    getPurgePilotEntries(dt: Date | undefined): Observable<PurgePilotEntriesDTO[]> {
        let url_ = this.baseUrl + "/api/Field/PurgePilotEntries?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurgePilotEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurgePilotEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurgePilotEntriesDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurgePilotEntriesDTO[]>;
        }));
    }

    protected processGetPurgePilotEntries(response: HttpResponseBase): Observable<PurgePilotEntriesDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurgePilotEntriesDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Consumes 1 Datetime to retrieve data for whole month.
     * @param dt (optional) 
     */
    getRecordTablesData(dt: Date | undefined): Observable<RecordTablesDTO[]> {
        let url_ = this.baseUrl + "/api/Field/RecordsTablesData?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordTablesData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordTablesData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordTablesDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordTablesDTO[]>;
        }));
    }

    protected processGetRecordTablesData(response: HttpResponseBase): Observable<RecordTablesDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordTablesDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    flaringReport(area: string | undefined, dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/FlaringReports?";
        if (area === null)
            throw new Error("The parameter 'area' cannot be null.");
        else if (area !== undefined)
            url_ += "Area=" + encodeURIComponent("" + area) + "&";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFlaringReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlaringReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFlaringReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    gasBalanceReport(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/GasBalanceReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGasBalanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGasBalanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGasBalanceReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    tGGSValues(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/3ggsValues?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTGGSValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTGGSValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTGGSValues(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalVolumeMass(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/GetTotalVolumeAndMass?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalVolumeMass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalVolumeMass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetTotalVolumeMass(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fieldTotals(startTime: Date | undefined): Observable<FieldTotal[]> {
        let url_ = this.baseUrl + "/api/Field/FieldTotals?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldTotal[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldTotal[]>;
        }));
    }

    protected processFieldTotals(response: HttpResponseBase): Observable<FieldTotal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldTotal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestUserAction(startTime: Date | undefined, actionType: ActionTypeEnumDTO | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Field/LatestUserAction?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (actionType === null)
            throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined)
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestUserAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestUserAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLatestUserAction(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    finalReportGasBalance(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/FinalReportGasBalance?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalReportGasBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalReportGasBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFinalReportGasBalance(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    finalReportFlaringReport(startTime: Date | undefined, field: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/FinalReportFlaringReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "Field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalReportFlaringReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalReportFlaringReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFinalReportFlaringReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fieldPurgePilots(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/FieldPurgePilots?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldPurgePilots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldPurgePilots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFieldPurgePilots(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPurgePilotDays(fdInput: PurgePilotDTO[], startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/SetPurgePilotDays?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPurgePilotDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPurgePilotDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetPurgePilotDays(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmPurgePilotDays(fdInput: PurgePilotDTO[], startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ConfirmPurgePilotDays?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPurgePilotDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPurgePilotDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processConfirmPurgePilotDays(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFieldRecord(fdInputDTO: RecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/AddFieldRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFieldRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFieldRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddFieldRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pressureTemperatureGraph(dt: Date | undefined, location: string | undefined): Observable<PressureTemperatureGraphDTO> {
        let url_ = this.baseUrl + "/api/Field/PressureTemperatureGraph?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (location === null)
            throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPressureTemperatureGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPressureTemperatureGraph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PressureTemperatureGraphDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PressureTemperatureGraphDTO>;
        }));
    }

    protected processPressureTemperatureGraph(response: HttpResponseBase): Observable<PressureTemperatureGraphDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressureTemperatureGraphDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFieldRecord2(fdInputDTO: RecordOperatorDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/AddOperatorFieldRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFieldRecord2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFieldRecord2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddFieldRecord2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOperatorTableNabor(date: Date | undefined): Observable<RecordOperatorDTO[]> {
        let url_ = this.baseUrl + "/api/Field/GetOperatorTableNabor?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperatorTableNabor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperatorTableNabor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordOperatorDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordOperatorDTO[]>;
        }));
    }

    protected processGetOperatorTableNabor(response: HttpResponseBase): Observable<RecordOperatorDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordOperatorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOperatorTableSzhiganiye(date: Date | undefined): Observable<RecordOperatorDTO[]> {
        let url_ = this.baseUrl + "/api/Field/GetOperatorTableSzhiganiye?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperatorTableSzhiganiye(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperatorTableSzhiganiye(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordOperatorDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordOperatorDTO[]>;
        }));
    }

    protected processGetOperatorTableSzhiganiye(response: HttpResponseBase): Observable<RecordOperatorDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordOperatorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOperatorPurgePilotSwitch(date: Date | undefined): Observable<RecordOperatorDTO[]> {
        let url_ = this.baseUrl + "/api/Field/GetOperatorPurgePilotSwitch?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperatorPurgePilotSwitch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperatorPurgePilotSwitch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordOperatorDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordOperatorDTO[]>;
        }));
    }

    protected processGetOperatorPurgePilotSwitch(response: HttpResponseBase): Observable<RecordOperatorDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordOperatorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeFieldRecord(fdInputDTO: RecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ChangeFieldRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeFieldRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeFieldRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangeFieldRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFieldRecord(id: number | undefined, startTime: Date | null | undefined, userName: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/DeleteFieldRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFieldRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFieldRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteFieldRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pBFCC(timestamp: Date | undefined, isPBF: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/PBFCC?";
        if (timestamp === null)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent(timestamp ? "" + timestamp.toISOString() : "") + "&";
        if (isPBF === null)
            throw new Error("The parameter 'isPBF' cannot be null.");
        else if (isPBF !== undefined)
            url_ += "isPBF=" + encodeURIComponent("" + isPBF) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPBFCC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPBFCC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPBFCC(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPBFCC(timestamp: Date | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Field/PBFCC?";
        if (timestamp === null)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent(timestamp ? "" + timestamp.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPBFCC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPBFCC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetPBFCC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmCalc(startTime: Date | undefined, gasType: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ConfirmFieldCalc?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (gasType === null)
            throw new Error("The parameter 'gasType' cannot be null.");
        else if (gasType !== undefined)
            url_ += "gasType=" + encodeURIComponent("" + gasType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmCalc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmCalc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processConfirmCalc(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setMonthlyLeaksToNow(startTime: Date | undefined, gasType: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/SetMonthlyLeaksToNow?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (gasType === null)
            throw new Error("The parameter 'gasType' cannot be null.");
        else if (gasType !== undefined)
            url_ += "gasType=" + encodeURIComponent("" + gasType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMonthlyLeaksToNow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMonthlyLeaksToNow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetMonthlyLeaksToNow(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveByChef(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/Approve?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveByChef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveByChef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApproveByChef(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    chemicalCompounds(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/FieldLIMS?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChemicalCompounds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChemicalCompounds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChemicalCompounds(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFieldToDryFlaredPE(gasBlowdownDTO: RecordBledFullyDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/SetFieldToDryFlaredPE";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gasBlowdownDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFieldToDryFlaredPE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFieldToDryFlaredPE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetFieldToDryFlaredPE(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFieldToDryFlared(gasBlowdownDTO: RecordBledFullyDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/SetFieldToDryFlared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gasBlowdownDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFieldToDryFlared(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFieldToDryFlared(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetFieldToDryFlared(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setBledFully(id: number | undefined, startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/SetBledFully?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBledFully(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBledFully(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetBledFully(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    operatorChangeFieldRecord(fdInputDTO: OperatorRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/OperatorChangeFieldRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatorChangeFieldRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatorChangeFieldRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOperatorChangeFieldRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    operatorDeleteFieldRecord(id: number | undefined, startTime: Date | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/OperatorDeleteFieldRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatorDeleteFieldRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatorDeleteFieldRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOperatorDeleteFieldRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    operatorChangePurgePilotRecord(fdInputDTO: RecordOperatorDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/OperatorChangePurgePilotRecordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fdInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatorChangePurgePilotRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatorChangePurgePilotRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOperatorChangePurgePilotRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFieldPermitTargetInput(fieldPermitTargetInputDTO: FieldPermitTargetInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/AddFieldPermitTargetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fieldPermitTargetInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFieldPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFieldPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddFieldPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editFieldPermitTargetInput(permitTargetInputEditDTO: PermitTargetInputEditDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/EditFieldPermitTargetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permitTargetInputEditDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditFieldPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditFieldPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditFieldPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFieldPermitTargetInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/DeleteFieldPermitTargetInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFieldPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFieldPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteFieldPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPerformanceMetricsPermitTargetInput(performanceMetricsPermitTargetInputDTO: PerformanceMetricsPermitTargetInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/AddPerformanceMetricsPermitTargetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(performanceMetricsPermitTargetInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPerformanceMetricsPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPerformanceMetricsPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPerformanceMetricsPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePerformanceMetricsPermitTargetInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/DeletePerformanceMetricsPermitTargetInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePerformanceMetricsPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePerformanceMetricsPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePerformanceMetricsPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDryGas(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ExportDryGas?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDryGas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDryGas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportDryGas(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportReservoirGas(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ExportReservoirGas?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReservoirGas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReservoirGas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportReservoirGas(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mSLocationsList(): Observable<FacilityLocationListDTO[]> {
        let url_ = this.baseUrl + "/api/Field/MSLocationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMSLocationsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMSLocationsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityLocationListDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityLocationListDTO[]>;
        }));
    }

    protected processMSLocationsList(response: HttpResponseBase): Observable<FacilityLocationListDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacilityLocationListDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPurgePilot(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ExportPurgePilot?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPurgePilot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPurgePilot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportPurgePilot(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFuelGas(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Field/ExportFuelGas?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFuelGas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFuelGas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportFuelGas(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFD3GIClient {
    refreshStreams(): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    getDailyReport(date: Date | undefined): Observable<_3GIFDGetDailyReportDTO[]>;
}

@Injectable({
    providedIn: 'root'
})
export class FD3GIClient implements IFD3GIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshStreams(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GIFD/RefreshStreams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GIFD/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyReport(date: Date | undefined): Observable<_3GIFDGetDailyReportDTO[]> {
        let url_ = this.baseUrl + "/api/_3GIFD/GetDailyReport?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<_3GIFDGetDailyReportDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<_3GIFDGetDailyReportDTO[]>;
        }));
    }

    protected processGetDailyReport(response: HttpResponseBase): Observable<_3GIFDGetDailyReportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(_3GIFDGetDailyReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFD3GPClient {
    refreshStreams(): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    generateFlaringReport(startTime: Date | undefined): Observable<FileResponse | null>;
    getChemicalCompounds(): Observable<_3GPChemicalCompoundsDTO[]>;
    getDailyReport(date: Date | undefined, flareType: _3GPFDFlareType | null | undefined): Observable<_3GPFDGetDailyReportDTO[]>;
    getMonthlyReport(date: Date | undefined, flareType: _3GPFDFlareType | null | undefined): Observable<GetMonthlyReportDTO>;
    getDailyTotalTable(date: Date | undefined): Observable<GetDailyTotalTableDTO[]>;
    getAllStreams(screenType: _3GPFDScreenType | undefined): Observable<_3GPFDStreamDTO[]>;
    getInputHistory(flareType: _3GPFDFlareType | null | undefined, startTime: Date | undefined, endTime: Date | null | undefined, recordType: InputRecordType | null | undefined, isActive: boolean | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetInputHistoryDTO>;
    clearManualInput(streamInputId: number | undefined): Observable<FileResponse | null>;
    editInput(dto: EditInputDTO): Observable<FileResponse | null>;
    createFlaringInput(dto: _3GPFDStreamInputRecordDTO): Observable<FileResponse | null>;
    createLeakageInput(dto: _3GPFDStreamInputRecordDTO): Observable<FileResponse | null>;
    createConstantFlaringInput(dto: _3GPFDStreamInputRecordDTO): Observable<FileResponse | null>;
    getPermitInput(year: number | undefined, limit: PermitTargetInputType | undefined, inputType: _3GPFDPermitInputType | undefined): Observable<_3GPFDPermitInputsDTO>;
    createPermitInput(dto: _3GPFDPermitInputsDTO): Observable<FileResponse | null>;
    getFlareSwitcherHistory(startDate: Date | undefined, endDate: Date | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOf_3GPFDFlareSwitcherInputDTO>;
    getFlareSwitcherByDay(date: Date | undefined): Observable<_3GPGetFlareSwitcherByDayDTO>;
    createFlareSwitcherInput(dto: _3GPFDFlareSwitcherInputDTO): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class FD3GPClient implements IFD3GPClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshStreams(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/RefreshStreams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateFlaringReport(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/GenerateFlaringReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFlaringReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFlaringReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGenerateFlaringReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalCompounds(): Observable<_3GPChemicalCompoundsDTO[]> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetChemicalCompounds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCompounds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCompounds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<_3GPChemicalCompoundsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<_3GPChemicalCompoundsDTO[]>;
        }));
    }

    protected processGetChemicalCompounds(response: HttpResponseBase): Observable<_3GPChemicalCompoundsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(_3GPChemicalCompoundsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyReport(date: Date | undefined, flareType: _3GPFDFlareType | null | undefined): Observable<_3GPFDGetDailyReportDTO[]> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetDailyReport?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (flareType !== undefined && flareType !== null)
            url_ += "flareType=" + encodeURIComponent("" + flareType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<_3GPFDGetDailyReportDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<_3GPFDGetDailyReportDTO[]>;
        }));
    }

    protected processGetDailyReport(response: HttpResponseBase): Observable<_3GPFDGetDailyReportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(_3GPFDGetDailyReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyReport(date: Date | undefined, flareType: _3GPFDFlareType | null | undefined): Observable<GetMonthlyReportDTO> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetMonthlyReport?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (flareType !== undefined && flareType !== null)
            url_ += "flareType=" + encodeURIComponent("" + flareType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMonthlyReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMonthlyReportDTO>;
        }));
    }

    protected processGetMonthlyReport(response: HttpResponseBase): Observable<GetMonthlyReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMonthlyReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyTotalTable(date: Date | undefined): Observable<GetDailyTotalTableDTO[]> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetDailyTotalTable?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyTotalTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyTotalTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailyTotalTableDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailyTotalTableDTO[]>;
        }));
    }

    protected processGetDailyTotalTable(response: HttpResponseBase): Observable<GetDailyTotalTableDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDailyTotalTableDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllStreams(screenType: _3GPFDScreenType | undefined): Observable<_3GPFDStreamDTO[]> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetAllStreams?";
        if (screenType === null)
            throw new Error("The parameter 'screenType' cannot be null.");
        else if (screenType !== undefined)
            url_ += "screenType=" + encodeURIComponent("" + screenType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<_3GPFDStreamDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<_3GPFDStreamDTO[]>;
        }));
    }

    protected processGetAllStreams(response: HttpResponseBase): Observable<_3GPFDStreamDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(_3GPFDStreamDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInputHistory(flareType: _3GPFDFlareType | null | undefined, startTime: Date | undefined, endTime: Date | null | undefined, recordType: InputRecordType | null | undefined, isActive: boolean | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetInputHistoryDTO> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetInputHistory?";
        if (flareType !== undefined && flareType !== null)
            url_ += "flareType=" + encodeURIComponent("" + flareType) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (recordType !== undefined && recordType !== null)
            url_ += "recordType=" + encodeURIComponent("" + recordType) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInputHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInputHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfGetInputHistoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfGetInputHistoryDTO>;
        }));
    }

    protected processGetInputHistory(response: HttpResponseBase): Observable<PagedListOfGetInputHistoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfGetInputHistoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearManualInput(streamInputId: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/ClearManualInput?";
        if (streamInputId === null)
            throw new Error("The parameter 'streamInputId' cannot be null.");
        else if (streamInputId !== undefined)
            url_ += "streamInputId=" + encodeURIComponent("" + streamInputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearManualInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearManualInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processClearManualInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editInput(dto: EditInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/EditInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFlaringInput(dto: _3GPFDStreamInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/CreateFlaringInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFlaringInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFlaringInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateFlaringInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLeakageInput(dto: _3GPFDStreamInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/CreateLeakageInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeakageInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeakageInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateLeakageInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createConstantFlaringInput(dto: _3GPFDStreamInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/CreateConstantFlaringInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConstantFlaringInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConstantFlaringInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateConstantFlaringInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPermitInput(year: number | undefined, limit: PermitTargetInputType | undefined, inputType: _3GPFDPermitInputType | undefined): Observable<_3GPFDPermitInputsDTO> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetPermitInput?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (inputType === null)
            throw new Error("The parameter 'inputType' cannot be null.");
        else if (inputType !== undefined)
            url_ += "inputType=" + encodeURIComponent("" + inputType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermitInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermitInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<_3GPFDPermitInputsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<_3GPFDPermitInputsDTO>;
        }));
    }

    protected processGetPermitInput(response: HttpResponseBase): Observable<_3GPFDPermitInputsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = _3GPFDPermitInputsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPermitInput(dto: _3GPFDPermitInputsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/CreatePermitInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePermitInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePermitInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreatePermitInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlareSwitcherHistory(startDate: Date | undefined, endDate: Date | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOf_3GPFDFlareSwitcherInputDTO> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetFlareSwitcherHistory?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlareSwitcherHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlareSwitcherHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOf_3GPFDFlareSwitcherInputDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOf_3GPFDFlareSwitcherInputDTO>;
        }));
    }

    protected processGetFlareSwitcherHistory(response: HttpResponseBase): Observable<PagedListOf_3GPFDFlareSwitcherInputDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOf_3GPFDFlareSwitcherInputDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlareSwitcherByDay(date: Date | undefined): Observable<_3GPGetFlareSwitcherByDayDTO> {
        let url_ = this.baseUrl + "/api/_3GPFD/GetFlareSwitcherByDay?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlareSwitcherByDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlareSwitcherByDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<_3GPGetFlareSwitcherByDayDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<_3GPGetFlareSwitcherByDayDTO>;
        }));
    }

    protected processGetFlareSwitcherByDay(response: HttpResponseBase): Observable<_3GPGetFlareSwitcherByDayDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = _3GPGetFlareSwitcherByDayDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFlareSwitcherInput(dto: _3GPFDFlareSwitcherInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFD/CreateFlareSwitcherInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFlareSwitcherInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFlareSwitcherInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateFlareSwitcherInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFGD3GPClient {
    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    /**
     * Get GUR data by month
     * @param date (optional) 
     */
    getGUR(date: Date | undefined): Observable<Get3GPGURDTO[]>;
    getGURApprove(date: Date | undefined): Observable<GetGURApproveDTO>;
    approveGUR(approvedDate: Date | undefined): Observable<FileResponse | null>;
    exportGUR(date: Date | undefined): Observable<FileResponse | null>;
    overrideGUR(dto: Override3GPGURDTO[]): Observable<FileResponse | null>;
    overrideGUR2(calculatedStreamId: number | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class FGD3GPClient implements IFGD3GPClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFGD/RefreshStreams?";
        if (isDelta === null)
            throw new Error("The parameter 'isDelta' cannot be null.");
        else if (isDelta !== undefined)
            url_ += "isDelta=" + encodeURIComponent("" + isDelta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFGD/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get GUR data by month
     * @param date (optional) 
     */
    getGUR(date: Date | undefined): Observable<Get3GPGURDTO[]> {
        let url_ = this.baseUrl + "/api/_3GPFGD/GetGUR?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Get3GPGURDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Get3GPGURDTO[]>;
        }));
    }

    protected processGetGUR(response: HttpResponseBase): Observable<Get3GPGURDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Get3GPGURDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGURApprove(date: Date | undefined): Observable<GetGURApproveDTO> {
        let url_ = this.baseUrl + "/api/_3GPFGD/GetGURApprove?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGURApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGURApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGURApproveDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGURApproveDTO>;
        }));
    }

    protected processGetGURApprove(response: HttpResponseBase): Observable<GetGURApproveDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGURApproveDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveGUR(approvedDate: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFGD/ApproveGUR?";
        if (approvedDate === null)
            throw new Error("The parameter 'approvedDate' cannot be null.");
        else if (approvedDate !== undefined)
            url_ += "approvedDate=" + encodeURIComponent(approvedDate ? "" + approvedDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApproveGUR(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportGUR(date: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFGD/ExportGUR?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportGUR(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    overrideGUR(dto: Override3GPGURDTO[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFGD/OverrideGUR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOverrideGUR(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    overrideGUR2(calculatedStreamId: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/_3GPFGD/ResetOverrideGUR?";
        if (calculatedStreamId === null)
            throw new Error("The parameter 'calculatedStreamId' cannot be null.");
        else if (calculatedStreamId !== undefined)
            url_ += "calculatedStreamId=" + encodeURIComponent("" + calculatedStreamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideGUR2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideGUR2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOverrideGUR2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICommonClient {
    getDatesFrom2Years(): Observable<FileResponse | null>;
    getCurrentUser(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CommonClient implements ICommonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDatesFrom2Years(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Common/DateTime2years";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatesFrom2Years(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatesFrom2Years(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDatesFrom2Years(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUser(): Observable<string> {
        let url_ = this.baseUrl + "/api/Common/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IClient {
    syncChemicalCompoundsTable(isEcStreamDb: boolean | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class Client implements IClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    syncChemicalCompoundsTable(isEcStreamDb: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Common/SyncChemicalCompoundsTable?";
        if (isEcStreamDb === null)
            throw new Error("The parameter 'isEcStreamDb' cannot be null.");
        else if (isEcStreamDb !== undefined)
            url_ += "isEcStreamDb=" + encodeURIComponent("" + isEcStreamDb) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncChemicalCompoundsTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncChemicalCompoundsTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSyncChemicalCompoundsTable(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIntUsClient {
    getHeatersRecords(dt: Date | undefined): Observable<HeatersRecordsDTO[]>;
    getBoilersRecords(dt: Date | undefined): Observable<BoilerRecordsDTO[]>;
    getMetersRecords(dt: Date | undefined): Observable<MetersRecordsDTO[]>;
    getTotalTableRecords(dt: Date | undefined): Observable<TotalTableDTO>;
    getIBMOARecords(dt: Date | undefined): Observable<IBMOARecordsDTO>;
    getMonthlyReport(dt: Date | undefined): Observable<MonthlyReportDTO>;
    getYearlyReport(dt: Date | undefined): Observable<MonthlyReportDTO[]>;
    addHeatersRecord(recordDTO: HeatersRecordsDTO): Observable<FileResponse | null>;
    editHeatersRecord(recordDTO: HeatersRecordsDTO[]): Observable<FileResponse | null>;
    addBoilersRecord(recordDTO: BoilerRecordsDTO): Observable<FileResponse | null>;
    editBoilersRecord(recordDTO: BoilerRecordsDTO[]): Observable<FileResponse | null>;
    updateMotohoursBoilersRecord(recordDTO: BoilerRecordsDTO): Observable<FileResponse | null>;
    updateMotohoursHeatersRecord(recordDTO: HeatersRecordsDTO): Observable<FileResponse | null>;
    addMetersRecord(recordDTO: MetersRecordsDTO[]): Observable<FileResponse | null>;
    editMetersRecord(recordDTO: MetersRecordsDTO): Observable<FileResponse | null>;
    addIBMOARecord(recordDTO: IBMOARecordsDTO): Observable<FileResponse | null>;
    addReportComments(recordDTO: MonthlyReportCommentsDTO): Observable<FileResponse | null>;
    approveMonthlyReport(dt: Date | undefined): Observable<FileResponse | null>;
    getLatestApproveMonthly(startTime: Date | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class IntUsClient implements IIntUsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getHeatersRecords(dt: Date | undefined): Observable<HeatersRecordsDTO[]> {
        let url_ = this.baseUrl + "/api/InternalUsage/HeatersRecords?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeatersRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeatersRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HeatersRecordsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HeatersRecordsDTO[]>;
        }));
    }

    protected processGetHeatersRecords(response: HttpResponseBase): Observable<HeatersRecordsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HeatersRecordsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBoilersRecords(dt: Date | undefined): Observable<BoilerRecordsDTO[]> {
        let url_ = this.baseUrl + "/api/InternalUsage/BoilersRecords?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoilersRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoilersRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BoilerRecordsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BoilerRecordsDTO[]>;
        }));
    }

    protected processGetBoilersRecords(response: HttpResponseBase): Observable<BoilerRecordsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoilerRecordsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMetersRecords(dt: Date | undefined): Observable<MetersRecordsDTO[]> {
        let url_ = this.baseUrl + "/api/InternalUsage/MetersRecords?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMetersRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetersRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetersRecordsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetersRecordsDTO[]>;
        }));
    }

    protected processGetMetersRecords(response: HttpResponseBase): Observable<MetersRecordsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetersRecordsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalTableRecords(dt: Date | undefined): Observable<TotalTableDTO> {
        let url_ = this.baseUrl + "/api/InternalUsage/TotalTableRecords?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalTableRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalTableRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalTableDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalTableDTO>;
        }));
    }

    protected processGetTotalTableRecords(response: HttpResponseBase): Observable<TotalTableDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotalTableDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIBMOARecords(dt: Date | undefined): Observable<IBMOARecordsDTO> {
        let url_ = this.baseUrl + "/api/InternalUsage/IBMOARecords?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIBMOARecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIBMOARecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBMOARecordsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBMOARecordsDTO>;
        }));
    }

    protected processGetIBMOARecords(response: HttpResponseBase): Observable<IBMOARecordsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IBMOARecordsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyReport(dt: Date | undefined): Observable<MonthlyReportDTO> {
        let url_ = this.baseUrl + "/api/InternalUsage/MonthlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyReportDTO>;
        }));
    }

    protected processGetMonthlyReport(response: HttpResponseBase): Observable<MonthlyReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYearlyReport(dt: Date | undefined): Observable<MonthlyReportDTO[]> {
        let url_ = this.baseUrl + "/api/InternalUsage/YearlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyReportDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyReportDTO[]>;
        }));
    }

    protected processGetYearlyReport(response: HttpResponseBase): Observable<MonthlyReportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addHeatersRecord(recordDTO: HeatersRecordsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/HeatersRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddHeatersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddHeatersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddHeatersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editHeatersRecord(recordDTO: HeatersRecordsDTO[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/HeatersRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditHeatersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditHeatersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditHeatersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addBoilersRecord(recordDTO: BoilerRecordsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/BoilersRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBoilersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBoilersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddBoilersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editBoilersRecord(recordDTO: BoilerRecordsDTO[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/BoilersRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBoilersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBoilersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditBoilersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMotohoursBoilersRecord(recordDTO: BoilerRecordsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/BoilersRecordMotohours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMotohoursBoilersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMotohoursBoilersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateMotohoursBoilersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMotohoursHeatersRecord(recordDTO: HeatersRecordsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/HeatersRecordMotohours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMotohoursHeatersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMotohoursHeatersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateMotohoursHeatersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addMetersRecord(recordDTO: MetersRecordsDTO[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/MetersRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMetersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMetersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddMetersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editMetersRecord(recordDTO: MetersRecordsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/MetersRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditMetersRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditMetersRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditMetersRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addIBMOARecord(recordDTO: IBMOARecordsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/IBMOARecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIBMOARecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIBMOARecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddIBMOARecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addReportComments(recordDTO: MonthlyReportCommentsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/ReportComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReportComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReportComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddReportComments(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveMonthlyReport(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InternalUsage/ApproveMonthlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApproveMonthlyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestApproveMonthly(startTime: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/InternalUsage/ApproveMonthlyTimestamp?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestApproveMonthly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestApproveMonthly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLatestApproveMonthly(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IKTLFGDClient {
    refreshSynapseDataManually(date: Date | undefined): Observable<FileResponse | null>;
    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    getMonthlyRecords(startTime: Date | undefined): Observable<CalculatedStreamDTO[]>;
    isDailyRecordsExist(startTime: Date | undefined, isDailyReport: boolean | undefined): Observable<boolean>;
    getDailyRecordsAll(startTime: Date | undefined): Observable<CalculatedStreamDTO[]>;
    getDailyRecords(isDailyReport: boolean | undefined): Observable<Date>;
    /**
     * @deprecated
     */
    addManualRecord(recordDTO: DailyReportInputRecordDTO): Observable<FileResponse | null>;
    /**
     * @deprecated
     */
    addMonthlyManualRecord(recordDTO: MonthlyInputRecordDTO): Observable<FileResponse | null>;
    overrideManualRecord(recordDTO: KTLFGDOverrideRecordDTO): Observable<FileResponse | null>;
    updateOxidizersAndCNS(dto: UpdateOxidizersAndCNSDTO): Observable<FileResponse | null>;
    deleteOverrideRecord(streamId: number | undefined, startTime: Date | undefined, isDailyReport: boolean | undefined): Observable<FileResponse | null>;
    exportKTLFGDDailyReports(dt: Date | undefined): Observable<FileResponse | null>;
    exportKTLFGDMonthlyReports(dt: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class KTLFGDClient implements IKTLFGDClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshSynapseDataManually(date: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/RefreshSynapseDataManually?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshSynapseDataManually(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshSynapseDataManually(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshSynapseDataManually(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/RefreshStreams?";
        if (isDelta === null)
            throw new Error("The parameter 'isDelta' cannot be null.");
        else if (isDelta !== undefined)
            url_ += "isDelta=" + encodeURIComponent("" + isDelta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyRecords(startTime: Date | undefined): Observable<CalculatedStreamDTO[]> {
        let url_ = this.baseUrl + "/api/KTLFGD/MonthlyRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculatedStreamDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculatedStreamDTO[]>;
        }));
    }

    protected processGetMonthlyRecords(response: HttpResponseBase): Observable<CalculatedStreamDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculatedStreamDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isDailyRecordsExist(startTime: Date | undefined, isDailyReport: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/KTLFGD/IsDailyRecordExist?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (isDailyReport === null)
            throw new Error("The parameter 'isDailyReport' cannot be null.");
        else if (isDailyReport !== undefined)
            url_ += "isDailyReport=" + encodeURIComponent("" + isDailyReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDailyRecordsExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDailyRecordsExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDailyRecordsExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyRecordsAll(startTime: Date | undefined): Observable<CalculatedStreamDTO[]> {
        let url_ = this.baseUrl + "/api/KTLFGD/DailyRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyRecordsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyRecordsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculatedStreamDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculatedStreamDTO[]>;
        }));
    }

    protected processGetDailyRecordsAll(response: HttpResponseBase): Observable<CalculatedStreamDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculatedStreamDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyRecords(isDailyReport: boolean | undefined): Observable<Date> {
        let url_ = this.baseUrl + "/api/KTLFGD/GetInputLastUpdateDate?";
        if (isDailyReport === null)
            throw new Error("The parameter 'isDailyReport' cannot be null.");
        else if (isDailyReport !== undefined)
            url_ += "isDailyReport=" + encodeURIComponent("" + isDailyReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processGetDailyRecords(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    addManualRecord(recordDTO: DailyReportInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/ManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    addMonthlyManualRecord(recordDTO: MonthlyInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/MonthlyManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMonthlyManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMonthlyManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddMonthlyManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    overrideManualRecord(recordDTO: KTLFGDOverrideRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/OverrideManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOverrideManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOxidizersAndCNS(dto: UpdateOxidizersAndCNSDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/UpdateOxidizersAndCNS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOxidizersAndCNS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOxidizersAndCNS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateOxidizersAndCNS(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOverrideRecord(streamId: number | undefined, startTime: Date | undefined, isDailyReport: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/DeleteOverrideRecord?";
        if (streamId === null)
            throw new Error("The parameter 'streamId' cannot be null.");
        else if (streamId !== undefined)
            url_ += "streamId=" + encodeURIComponent("" + streamId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (isDailyReport === null)
            throw new Error("The parameter 'isDailyReport' cannot be null.");
        else if (isDailyReport !== undefined)
            url_ += "IsDailyReport=" + encodeURIComponent("" + isDailyReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOverrideRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOverrideRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteOverrideRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportKTLFGDDailyReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/ExportKTLFGDDailyReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportKTLFGDDailyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportKTLFGDDailyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportKTLFGDDailyReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportKTLFGDMonthlyReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGD/ExportKTLFGDMonthlyReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportKTLFGDMonthlyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportKTLFGDMonthlyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportKTLFGDMonthlyReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IKTLFGDECClient {
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class KTLFGDECClient implements IKTLFGDECClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLFGDEC/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IKTLSGPClient {
    refreshStreams(plant: Plant | undefined, isDelta: boolean | undefined): Observable<FileResponse | null>;
    compareStreamsAFandSQL(plant: Plant | undefined): Observable<FileResponse | null>;
    confirmDailyReport(startTime: Date | undefined): Observable<FileResponse | null>;
    confirmMonthlyReport(startTime: Date | undefined): Observable<FileResponse | null>;
    approveByChef(startTime: Date | undefined): Observable<FileResponse | null>;
    generateReports(startTime: Date | undefined): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    switchStream(id: number | undefined, startTime: Date | undefined, switchFrom: string | undefined, switchTo: string | undefined): Observable<FileResponse | null>;
    batchSwitchStream(dto: FlareSwitcherDTO): Observable<FileResponse | null>;
    batchSwitchStreamSGP(dto: SGPFlareSwitcherDTO): Observable<FileResponse | null>;
    getSGPFlareSwitcherHistory(startTime: Date | null | undefined, endTime: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetSGPFlareSwitcherDTO>;
    getAllSwitchableSGPStreams(startTime: Date | undefined): Observable<GetSwitchableStreamDTO[]>;
    facilityAndUnitMapping(): Observable<GetFacilityAndUnitMappingDTO[]>;
    switchedStreams(startTime: Date | undefined): Observable<FileResponse | null>;
    getFlareSwitcherHistory(startTime: Date | undefined, endTime: Date | undefined, facility: KTLTrains | null | undefined, unit: UnitList | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetFlareSwitcherDTO>;
    bypass(streamId: number | undefined, bypass: boolean | undefined, date: Date | undefined): Observable<string>;
    addManualRecord(record: InputRecordDTO): Observable<FileResponse | null>;
    testAddManualRecord(record: InputRecordDTO): Observable<FileResponse | null>;
    editManualRecord(record: InputRecordDTO): Observable<FileResponse | null>;
    editRecordDailyReport(record: DailyReportEditDTO): Observable<string>;
    commentsDailyReport(record: InputRecordDTO): Observable<FileResponse | null>;
    deleteManualRecord(id: number): Observable<FileResponse | null>;
    getDailyReport(dt: Date | undefined, flare: string | undefined): Observable<FileResponse | null>;
    getF205CalcDetails(starttime: Date | undefined, endtime: Date | undefined): Observable<F205TotalDTO>;
    getReportDaily(dt: Date | undefined, flare: string | undefined): Observable<DailyReportDTO>;
    getInputHistory(starttime: Date | null | undefined, endttime: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, inputType: InputRecordType | null | undefined, active: boolean | null | undefined, plant: Plant | undefined, flareName: string | null | undefined): Observable<PagedListOfInputHistoryDTO>;
    getChemicalCompoundsID(): Observable<ChemicalCompoundsDTO[]>;
    getChemicalCompoundsEquipment(unitName: UnitList | null | undefined, ktlTrain: TrainList | null | undefined): Observable<ChemicalCompoundsEquipmentDTO[]>;
    addChemicalCompoundsEquipment(dto: ChemicalCompoundsEquipmentDTO): Observable<ValueTupleOfIntegerAndString>;
    editChemicalCompoundsEquipment(dto: ChemicalCompoundsEquipmentDTO): Observable<ValueTupleOfIntegerAndString>;
    deleteChemicalCompoundsEquipment(id: number | undefined): Observable<ValueTupleOfIntegerAndString>;
    getMonthlyReport(dt: Date | undefined, flare: string | undefined): Observable<FileResponse | null>;
    getGasBalance(dt: Date | undefined, flare: string | undefined): Observable<KTLSGPGasBalanceDTO>;
    getChemicalCompounds(timeStamp: Date | undefined): Observable<ChemicalCompoundRecord[]>;
    getGUR(startTime: Date | undefined): Observable<GetGURDTO>;
    postGUR(input: GURInputRecordDTO): Observable<FileResponse | null>;
    addKTLSGPPermitTargetInput(kTLSGPPermitTargetInputDTO: KTLSGPPermitTargetInputDTO): Observable<FileResponse | null>;
    editKTLSGPPermitTargetInput(permitTargetInputEditDTO: PermitTargetInputEditDTO): Observable<FileResponse | null>;
    deleteAddKTLSGPPermitTargetInput(id: number | undefined): Observable<FileResponse | null>;
    monthlyReport(dt: Date | undefined): Observable<FileResponse | null>;
    setDefaltMW(id: number | undefined, mw: number | undefined): Observable<FileResponse | null>;
    getAllStreamMW(plant: Plant | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfKTLSGPStreamMWDTO>;
    getStreamBySearch(plant: Plant | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Observable<PagedListOfKTLSGPStreamMWDTO>;
    getAllStreams(plant: Plant | undefined): Observable<KTLSGPStreamDTO[]>;
    getDailyReportStreamDetails(dt: Date | undefined, streamId: number | undefined): Observable<CalculatedStreamInputRecordDTO>;
    monthlyReport2(dt: Date | undefined): Observable<FileResponse | null>;
    getKTLOperatorInput(dt: Date | null | undefined, unitName: UnitList | null | undefined, train: TrainList | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetKTLOperatorDTO>;
    createKTLOperatorInput(createKTLOperatorDTO: CreateKTLOperatorDTO): Observable<FileResponse | null>;
    editKTLOperatorInput(ktlOperatorDTOInputEditDTO: KTLOperatorDTO): Observable<FileResponse | null>;
    deleteKTLOperatorInput(id: number | undefined): Observable<FileResponse | null>;
    getSGPOperatorInput(dt: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetSGPOperatorDTO>;
    createSGPOperatorInput(createSGPOperatorDTO: SGPOperatorDTO): Observable<FileResponse | null>;
    deleteSGPOperatorInput(id: number | undefined): Observable<FileResponse | null>;
    getDiagnosticianScreenHistory(startTime: Date | undefined, facility: KTLTrains | null | undefined, unitType: UnitList | null | undefined, valveName: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetDiagnosticianScreenHistoryDTO>;
    getDiagnosticianScreenInputs(startTime: Date | undefined, facility: KTLTrains | null | undefined, unitType: UnitList | null | undefined): Observable<GetDiagnosticianScreenInputDTO[]>;
    createUpdateDiagnosticianScreenInput(createDiagnosticianInputDTO: CreateDiagnosticianInputDTO[]): Observable<FileResponse | null>;
    getDiagnosticianRelation(): Observable<DiagnosticianRelationFacilityDTO[]>;
    getLeakageScreenHistory(dateTime: Date | undefined, facility: KTLTrains | null | undefined, unit: UnitList | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfLeakageScreenDTO>;
    getLeakageScreenInput(startTime: Date | undefined, facility: KTLTrains | null | undefined, unitType: UnitList | null | undefined): Observable<LeakageScreenDTO[]>;
    createUpdateLeakageInput(leakageScreenDTOs: LeakageScreenDTO[]): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class KTLSGPClient implements IKTLSGPClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshStreams(plant: Plant | undefined, isDelta: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/RefreshStreams?";
        if (plant === null)
            throw new Error("The parameter 'plant' cannot be null.");
        else if (plant !== undefined)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        if (isDelta === null)
            throw new Error("The parameter 'isDelta' cannot be null.");
        else if (isDelta !== undefined)
            url_ += "isDelta=" + encodeURIComponent("" + isDelta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    compareStreamsAFandSQL(plant: Plant | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/CompareStreamsAFandSQL?";
        if (plant === null)
            throw new Error("The parameter 'plant' cannot be null.");
        else if (plant !== undefined)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompareStreamsAFandSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompareStreamsAFandSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompareStreamsAFandSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmDailyReport(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/ConfirmDailyReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processConfirmDailyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmMonthlyReport(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/ConfirmMonthlyReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processConfirmMonthlyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveByChef(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/Approve?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveByChef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveByChef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApproveByChef(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateReports(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/GenerateReports?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGenerateReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    switchStream(id: number | undefined, startTime: Date | undefined, switchFrom: string | undefined, switchTo: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/SwitchStream?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (switchFrom === null)
            throw new Error("The parameter 'switchFrom' cannot be null.");
        else if (switchFrom !== undefined)
            url_ += "SwitchFrom=" + encodeURIComponent("" + switchFrom) + "&";
        if (switchTo === null)
            throw new Error("The parameter 'switchTo' cannot be null.");
        else if (switchTo !== undefined)
            url_ += "SwitchTo=" + encodeURIComponent("" + switchTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSwitchStream(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchSwitchStream(dto: FlareSwitcherDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/BatchSwitchStream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchSwitchStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchSwitchStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processBatchSwitchStream(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchSwitchStreamSGP(dto: SGPFlareSwitcherDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/BatchSwitchStreamSGP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchSwitchStreamSGP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchSwitchStreamSGP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processBatchSwitchStreamSGP(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSGPFlareSwitcherHistory(startTime: Date | null | undefined, endTime: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetSGPFlareSwitcherDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetSGPFlareSwitcherHistory?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSGPFlareSwitcherHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSGPFlareSwitcherHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfGetSGPFlareSwitcherDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfGetSGPFlareSwitcherDTO>;
        }));
    }

    protected processGetSGPFlareSwitcherHistory(response: HttpResponseBase): Observable<PagedListOfGetSGPFlareSwitcherDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfGetSGPFlareSwitcherDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSwitchableSGPStreams(startTime: Date | undefined): Observable<GetSwitchableStreamDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetAllSwitchableSGPStreams?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSwitchableSGPStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSwitchableSGPStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSwitchableStreamDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSwitchableStreamDTO[]>;
        }));
    }

    protected processGetAllSwitchableSGPStreams(response: HttpResponseBase): Observable<GetSwitchableStreamDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSwitchableStreamDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    facilityAndUnitMapping(): Observable<GetFacilityAndUnitMappingDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/FacilityAndUnitMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFacilityAndUnitMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacilityAndUnitMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFacilityAndUnitMappingDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFacilityAndUnitMappingDTO[]>;
        }));
    }

    protected processFacilityAndUnitMapping(response: HttpResponseBase): Observable<GetFacilityAndUnitMappingDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFacilityAndUnitMappingDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    switchedStreams(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/SwitchedOnStreams?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchedStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchedStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSwitchedStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlareSwitcherHistory(startTime: Date | undefined, endTime: Date | undefined, facility: KTLTrains | null | undefined, unit: UnitList | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetFlareSwitcherDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetFlareSwitcherHistory?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (facility !== undefined && facility !== null)
            url_ += "facility=" + encodeURIComponent("" + facility) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlareSwitcherHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlareSwitcherHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfGetFlareSwitcherDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfGetFlareSwitcherDTO>;
        }));
    }

    protected processGetFlareSwitcherHistory(response: HttpResponseBase): Observable<PagedListOfGetFlareSwitcherDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfGetFlareSwitcherDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bypass(streamId: number | undefined, bypass: boolean | undefined, date: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/KTLSGP/Bypass?";
        if (streamId === null)
            throw new Error("The parameter 'streamId' cannot be null.");
        else if (streamId !== undefined)
            url_ += "streamId=" + encodeURIComponent("" + streamId) + "&";
        if (bypass === null)
            throw new Error("The parameter 'bypass' cannot be null.");
        else if (bypass !== undefined)
            url_ += "bypass=" + encodeURIComponent("" + bypass) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBypass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBypass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBypass(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualRecord(record: InputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/AddManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testAddManualRecord(record: InputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/TestAddManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestAddManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestAddManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTestAddManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editManualRecord(record: InputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/EditManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editRecordDailyReport(record: DailyReportEditDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/KTLSGP/EditRecordDailyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditRecordDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditRecordDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditRecordDailyReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commentsDailyReport(record: InputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/CommentsDailyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommentsDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommentsDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCommentsDailyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteManualRecord(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/DeleteManualRecord/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyReport(dt: Date | undefined, flare: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/DailyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (flare === null)
            throw new Error("The parameter 'flare' cannot be null.");
        else if (flare !== undefined)
            url_ += "flare=" + encodeURIComponent("" + flare) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDailyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getF205CalcDetails(starttime: Date | undefined, endtime: Date | undefined): Observable<F205TotalDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/F205KTL2Details?";
        if (starttime === null)
            throw new Error("The parameter 'starttime' cannot be null.");
        else if (starttime !== undefined)
            url_ += "starttime=" + encodeURIComponent(starttime ? "" + starttime.toISOString() : "") + "&";
        if (endtime === null)
            throw new Error("The parameter 'endtime' cannot be null.");
        else if (endtime !== undefined)
            url_ += "endtime=" + encodeURIComponent(endtime ? "" + endtime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetF205CalcDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetF205CalcDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<F205TotalDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<F205TotalDTO>;
        }));
    }

    protected processGetF205CalcDetails(response: HttpResponseBase): Observable<F205TotalDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = F205TotalDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportDaily(dt: Date | undefined, flare: string | undefined): Observable<DailyReportDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/DailyReporttV2?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (flare === null)
            throw new Error("The parameter 'flare' cannot be null.");
        else if (flare !== undefined)
            url_ += "flare=" + encodeURIComponent("" + flare) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDaily(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDaily(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyReportDTO>;
        }));
    }

    protected processGetReportDaily(response: HttpResponseBase): Observable<DailyReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DailyReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInputHistory(starttime: Date | null | undefined, endttime: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, inputType: InputRecordType | null | undefined, active: boolean | null | undefined, plant: Plant | undefined, flareName: string | null | undefined): Observable<PagedListOfInputHistoryDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/InputHistory?";
        if (starttime !== undefined && starttime !== null)
            url_ += "starttime=" + encodeURIComponent(starttime ? "" + starttime.toISOString() : "") + "&";
        if (endttime !== undefined && endttime !== null)
            url_ += "endttime=" + encodeURIComponent(endttime ? "" + endttime.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (inputType !== undefined && inputType !== null)
            url_ += "InputType=" + encodeURIComponent("" + inputType) + "&";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (plant === null)
            throw new Error("The parameter 'plant' cannot be null.");
        else if (plant !== undefined)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        if (flareName !== undefined && flareName !== null)
            url_ += "FlareName=" + encodeURIComponent("" + flareName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInputHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInputHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfInputHistoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfInputHistoryDTO>;
        }));
    }

    protected processGetInputHistory(response: HttpResponseBase): Observable<PagedListOfInputHistoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfInputHistoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalCompoundsID(): Observable<ChemicalCompoundsDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/ChemicalCompoundsID";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCompoundsID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCompoundsID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCompoundsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCompoundsDTO[]>;
        }));
    }

    protected processGetChemicalCompoundsID(response: HttpResponseBase): Observable<ChemicalCompoundsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalCompoundsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalCompoundsEquipment(unitName: UnitList | null | undefined, ktlTrain: TrainList | null | undefined): Observable<ChemicalCompoundsEquipmentDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/ChemicalCompoundsEquipment?";
        if (unitName !== undefined && unitName !== null)
            url_ += "unitName=" + encodeURIComponent("" + unitName) + "&";
        if (ktlTrain !== undefined && ktlTrain !== null)
            url_ += "ktlTrain=" + encodeURIComponent("" + ktlTrain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCompoundsEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCompoundsEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCompoundsEquipmentDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCompoundsEquipmentDTO[]>;
        }));
    }

    protected processGetChemicalCompoundsEquipment(response: HttpResponseBase): Observable<ChemicalCompoundsEquipmentDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalCompoundsEquipmentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addChemicalCompoundsEquipment(dto: ChemicalCompoundsEquipmentDTO): Observable<ValueTupleOfIntegerAndString> {
        let url_ = this.baseUrl + "/api/KTLSGP/ChemicalCompoundsEquipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddChemicalCompoundsEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddChemicalCompoundsEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIntegerAndString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIntegerAndString>;
        }));
    }

    protected processAddChemicalCompoundsEquipment(response: HttpResponseBase): Observable<ValueTupleOfIntegerAndString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIntegerAndString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editChemicalCompoundsEquipment(dto: ChemicalCompoundsEquipmentDTO): Observable<ValueTupleOfIntegerAndString> {
        let url_ = this.baseUrl + "/api/KTLSGP/ChemicalCompoundsEquipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditChemicalCompoundsEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditChemicalCompoundsEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIntegerAndString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIntegerAndString>;
        }));
    }

    protected processEditChemicalCompoundsEquipment(response: HttpResponseBase): Observable<ValueTupleOfIntegerAndString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIntegerAndString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteChemicalCompoundsEquipment(id: number | undefined): Observable<ValueTupleOfIntegerAndString> {
        let url_ = this.baseUrl + "/api/KTLSGP/ChemicalCompoundsEquipment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChemicalCompoundsEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChemicalCompoundsEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfIntegerAndString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfIntegerAndString>;
        }));
    }

    protected processDeleteChemicalCompoundsEquipment(response: HttpResponseBase): Observable<ValueTupleOfIntegerAndString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfIntegerAndString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyReport(dt: Date | undefined, flare: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/MonthlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (flare === null)
            throw new Error("The parameter 'flare' cannot be null.");
        else if (flare !== undefined)
            url_ += "flare=" + encodeURIComponent("" + flare) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetMonthlyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGasBalance(dt: Date | undefined, flare: string | undefined): Observable<KTLSGPGasBalanceDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GasBalance?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (flare === null)
            throw new Error("The parameter 'flare' cannot be null.");
        else if (flare !== undefined)
            url_ += "flare=" + encodeURIComponent("" + flare) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGasBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGasBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPGasBalanceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPGasBalanceDTO>;
        }));
    }

    protected processGetGasBalance(response: HttpResponseBase): Observable<KTLSGPGasBalanceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KTLSGPGasBalanceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalCompounds(timeStamp: Date | undefined): Observable<ChemicalCompoundRecord[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/LIMS?";
        if (timeStamp === null)
            throw new Error("The parameter 'timeStamp' cannot be null.");
        else if (timeStamp !== undefined)
            url_ += "timeStamp=" + encodeURIComponent(timeStamp ? "" + timeStamp.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCompounds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCompounds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCompoundRecord[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCompoundRecord[]>;
        }));
    }

    protected processGetChemicalCompounds(response: HttpResponseBase): Observable<ChemicalCompoundRecord[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalCompoundRecord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGUR(startTime: Date | undefined): Observable<GetGURDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GUR?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGURDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGURDTO>;
        }));
    }

    protected processGetGUR(response: HttpResponseBase): Observable<GetGURDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGURDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postGUR(input: GURInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/GUR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPostGUR(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addKTLSGPPermitTargetInput(kTLSGPPermitTargetInputDTO: KTLSGPPermitTargetInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/AddKTLSGPPermitTargetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kTLSGPPermitTargetInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddKTLSGPPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKTLSGPPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddKTLSGPPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editKTLSGPPermitTargetInput(permitTargetInputEditDTO: PermitTargetInputEditDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/EditKTLSGPPermitTargetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permitTargetInputEditDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditKTLSGPPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditKTLSGPPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditKTLSGPPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAddKTLSGPPermitTargetInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/DeleteAddKTLSGPPermitTargetInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAddKTLSGPPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAddKTLSGPPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteAddKTLSGPPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    monthlyReport(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetSGPMonthlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMonthlyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setDefaltMW(id: number | undefined, mw: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/SetDefaultMW?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (mw === null)
            throw new Error("The parameter 'mw' cannot be null.");
        else if (mw !== undefined)
            url_ += "mw=" + encodeURIComponent("" + mw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaltMW(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaltMW(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSetDefaltMW(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllStreamMW(plant: Plant | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfKTLSGPStreamMWDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetAllStreamMW?";
        if (plant !== undefined && plant !== null)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStreamMW(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStreamMW(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfKTLSGPStreamMWDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfKTLSGPStreamMWDTO>;
        }));
    }

    protected processGetAllStreamMW(response: HttpResponseBase): Observable<PagedListOfKTLSGPStreamMWDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfKTLSGPStreamMWDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStreamBySearch(plant: Plant | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, search: string | null | undefined): Observable<PagedListOfKTLSGPStreamMWDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetStreamBySearch?";
        if (plant !== undefined && plant !== null)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStreamBySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStreamBySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfKTLSGPStreamMWDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfKTLSGPStreamMWDTO>;
        }));
    }

    protected processGetStreamBySearch(response: HttpResponseBase): Observable<PagedListOfKTLSGPStreamMWDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfKTLSGPStreamMWDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllStreams(plant: Plant | undefined): Observable<KTLSGPStreamDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetAllStreams?";
        if (plant === null)
            throw new Error("The parameter 'plant' cannot be null.");
        else if (plant !== undefined)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPStreamDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPStreamDTO[]>;
        }));
    }

    protected processGetAllStreams(response: HttpResponseBase): Observable<KTLSGPStreamDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KTLSGPStreamDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyReportStreamDetails(dt: Date | undefined, streamId: number | undefined): Observable<CalculatedStreamInputRecordDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/DailyReportStreamDetails?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (streamId === null)
            throw new Error("The parameter 'streamId' cannot be null.");
        else if (streamId !== undefined)
            url_ += "streamId=" + encodeURIComponent("" + streamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReportStreamDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReportStreamDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculatedStreamInputRecordDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculatedStreamInputRecordDTO>;
        }));
    }

    protected processGetDailyReportStreamDetails(response: HttpResponseBase): Observable<CalculatedStreamInputRecordDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculatedStreamInputRecordDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    monthlyReport2(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetKTLMonthlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyReport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyReport2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMonthlyReport2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getKTLOperatorInput(dt: Date | null | undefined, unitName: UnitList | null | undefined, train: TrainList | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetKTLOperatorDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetKTLOperatorInput?";
        if (dt !== undefined && dt !== null)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (unitName !== undefined && unitName !== null)
            url_ += "unitName=" + encodeURIComponent("" + unitName) + "&";
        if (train !== undefined && train !== null)
            url_ += "train=" + encodeURIComponent("" + train) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKTLOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKTLOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfGetKTLOperatorDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfGetKTLOperatorDTO>;
        }));
    }

    protected processGetKTLOperatorInput(response: HttpResponseBase): Observable<PagedListOfGetKTLOperatorDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfGetKTLOperatorDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createKTLOperatorInput(createKTLOperatorDTO: CreateKTLOperatorDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/CreateKTLOperatorInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createKTLOperatorDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKTLOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKTLOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateKTLOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editKTLOperatorInput(ktlOperatorDTOInputEditDTO: KTLOperatorDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/EditKTLOperatorInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ktlOperatorDTOInputEditDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditKTLOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditKTLOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditKTLOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteKTLOperatorInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/DeleteKTLOperatorInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteKTLOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKTLOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteKTLOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSGPOperatorInput(dt: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetSGPOperatorDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetSGPOperatorInput?";
        if (dt !== undefined && dt !== null)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSGPOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSGPOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfGetSGPOperatorDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfGetSGPOperatorDTO>;
        }));
    }

    protected processGetSGPOperatorInput(response: HttpResponseBase): Observable<PagedListOfGetSGPOperatorDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfGetSGPOperatorDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSGPOperatorInput(createSGPOperatorDTO: SGPOperatorDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/CreateSGPOperatorInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSGPOperatorDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSGPOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSGPOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateSGPOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSGPOperatorInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/DeleteSGPOperatorInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSGPOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSGPOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteSGPOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDiagnosticianScreenHistory(startTime: Date | undefined, facility: KTLTrains | null | undefined, unitType: UnitList | null | undefined, valveName: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfGetDiagnosticianScreenHistoryDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetDiagnosticianScreenHistory?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (facility !== undefined && facility !== null)
            url_ += "facility=" + encodeURIComponent("" + facility) + "&";
        if (unitType !== undefined && unitType !== null)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&";
        if (valveName !== undefined && valveName !== null)
            url_ += "valveName=" + encodeURIComponent("" + valveName) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnosticianScreenHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnosticianScreenHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfGetDiagnosticianScreenHistoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfGetDiagnosticianScreenHistoryDTO>;
        }));
    }

    protected processGetDiagnosticianScreenHistory(response: HttpResponseBase): Observable<PagedListOfGetDiagnosticianScreenHistoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfGetDiagnosticianScreenHistoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDiagnosticianScreenInputs(startTime: Date | undefined, facility: KTLTrains | null | undefined, unitType: UnitList | null | undefined): Observable<GetDiagnosticianScreenInputDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetDiagnosticianScreenInputs?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (facility !== undefined && facility !== null)
            url_ += "facility=" + encodeURIComponent("" + facility) + "&";
        if (unitType !== undefined && unitType !== null)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnosticianScreenInputs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnosticianScreenInputs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDiagnosticianScreenInputDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDiagnosticianScreenInputDTO[]>;
        }));
    }

    protected processGetDiagnosticianScreenInputs(response: HttpResponseBase): Observable<GetDiagnosticianScreenInputDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDiagnosticianScreenInputDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUpdateDiagnosticianScreenInput(createDiagnosticianInputDTO: CreateDiagnosticianInputDTO[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/CreateUpdateDiagnosticianScreenInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDiagnosticianInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateDiagnosticianScreenInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateDiagnosticianScreenInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateUpdateDiagnosticianScreenInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDiagnosticianRelation(): Observable<DiagnosticianRelationFacilityDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetDiagnosticianRelation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnosticianRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnosticianRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiagnosticianRelationFacilityDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiagnosticianRelationFacilityDTO[]>;
        }));
    }

    protected processGetDiagnosticianRelation(response: HttpResponseBase): Observable<DiagnosticianRelationFacilityDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticianRelationFacilityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeakageScreenHistory(dateTime: Date | undefined, facility: KTLTrains | null | undefined, unit: UnitList | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfLeakageScreenDTO> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetLeakageScreenHistory?";
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toISOString() : "") + "&";
        if (facility !== undefined && facility !== null)
            url_ += "facility=" + encodeURIComponent("" + facility) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeakageScreenHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeakageScreenHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfLeakageScreenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfLeakageScreenDTO>;
        }));
    }

    protected processGetLeakageScreenHistory(response: HttpResponseBase): Observable<PagedListOfLeakageScreenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfLeakageScreenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeakageScreenInput(startTime: Date | undefined, facility: KTLTrains | null | undefined, unitType: UnitList | null | undefined): Observable<LeakageScreenDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGP/GetLeakageScreenInput?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (facility !== undefined && facility !== null)
            url_ += "facility=" + encodeURIComponent("" + facility) + "&";
        if (unitType !== undefined && unitType !== null)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeakageScreenInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeakageScreenInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeakageScreenDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeakageScreenDTO[]>;
        }));
    }

    protected processGetLeakageScreenInput(response: HttpResponseBase): Observable<LeakageScreenDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeakageScreenDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUpdateLeakageInput(leakageScreenDTOs: LeakageScreenDTO[]): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGP/CreateUpdateLeakageInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(leakageScreenDTOs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateLeakageInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateLeakageInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateUpdateLeakageInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IKTLSGPDataRecoveryClient {
    dailyRefreshAFToSQL(startTime: Date | null | undefined): Observable<FileResponse | null>;
    getDataRecoveryHistory(dt: Date | undefined): Observable<KTLSGPDataRecoveryInputDTO>;
    getDataRecoveryTagInputs(dt: Date | undefined, streamName: string | undefined, tagName: string | undefined): Observable<KTLSGPDataRecoveryValueDTO[]>;
    getDataRecoveryTagOptions(streamName: string | undefined): Observable<KTLSGPDataRecoveryTagDTO[]>;
    updateTagInputs(dto: UpdateTagInputsDTO): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class KTLSGPDataRecoveryClient implements IKTLSGPDataRecoveryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    dailyRefreshAFToSQL(startTime: Date | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGPDataRecovery/DailyRefreshAFToSQL?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDailyRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDailyRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDailyRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataRecoveryHistory(dt: Date | undefined): Observable<KTLSGPDataRecoveryInputDTO> {
        let url_ = this.baseUrl + "/api/KTLSGPDataRecovery/GetDataRecoveryHistory?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataRecoveryHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataRecoveryHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPDataRecoveryInputDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPDataRecoveryInputDTO>;
        }));
    }

    protected processGetDataRecoveryHistory(response: HttpResponseBase): Observable<KTLSGPDataRecoveryInputDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KTLSGPDataRecoveryInputDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataRecoveryTagInputs(dt: Date | undefined, streamName: string | undefined, tagName: string | undefined): Observable<KTLSGPDataRecoveryValueDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGPDataRecovery/GetDataRecoveryTagInputs?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (streamName === null)
            throw new Error("The parameter 'streamName' cannot be null.");
        else if (streamName !== undefined)
            url_ += "streamName=" + encodeURIComponent("" + streamName) + "&";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataRecoveryTagInputs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataRecoveryTagInputs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPDataRecoveryValueDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPDataRecoveryValueDTO[]>;
        }));
    }

    protected processGetDataRecoveryTagInputs(response: HttpResponseBase): Observable<KTLSGPDataRecoveryValueDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KTLSGPDataRecoveryValueDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataRecoveryTagOptions(streamName: string | undefined): Observable<KTLSGPDataRecoveryTagDTO[]> {
        let url_ = this.baseUrl + "/api/KTLSGPDataRecovery/GetDataRecoveryTagOptions?";
        if (streamName === null)
            throw new Error("The parameter 'streamName' cannot be null.");
        else if (streamName !== undefined)
            url_ += "streamName=" + encodeURIComponent("" + streamName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataRecoveryTagOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataRecoveryTagOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPDataRecoveryTagDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPDataRecoveryTagDTO[]>;
        }));
    }

    protected processGetDataRecoveryTagOptions(response: HttpResponseBase): Observable<KTLSGPDataRecoveryTagDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KTLSGPDataRecoveryTagDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTagInputs(dto: UpdateTagInputsDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGPDataRecovery/UpdateTagInputs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTagInputs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTagInputs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateTagInputs(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IKTLSGPECClient {
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class KTLSGPECClient implements IKTLSGPECClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/KTLSGPEC/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILPGClient {
    monthlyOperatorRecords(startTime: Date | undefined): Observable<LPGOperatorInputDTO[]>;
    addLPGOperatorInput(lPGOperatorInputDTO: LPGOperatorInputDTO): Observable<FileResponse | null>;
    editLPGOperatorInput(lPGOperatorInputEditDTO: LPGOperatorInputDTO): Observable<FileResponse | null>;
    deleteLPGOperatorInput(id: number | undefined): Observable<FileResponse | null>;
    monthlyPERecords(startTime: Date | undefined): Observable<LPGPEInputDTO[]>;
    addPEMonthlyInput(body: LPGMonthlyInputRecordDTO): Observable<FileResponse | null>;
    addLPGPEInput(lPGPEInputDTO: LPGPEInputDTO): Observable<FileResponse | null>;
    addLPGFlowmeterCalculationInput(lPGPEInputDTO: LPGPEInputDTO): Observable<FileResponse | null>;
    getCalculation(startTime: Date | undefined, endTime: Date | undefined, type: LPGFlowmeterCalculateType | undefined, avg: number | undefined, volume: number | undefined, mw: LPGStreamCCType | undefined): Observable<number>;
    editLPGPEInput(lPGPEInputEditDTO: LPGPEInputDTO): Observable<FileResponse | null>;
    deleteLPGPEInput(id: number | undefined): Observable<FileResponse | null>;
    /**
     * Consumes StartTime as the date for which Approve must be done.
     * @param startTime (optional) 
     */
    approveByChef(startTime: Date | undefined): Observable<FileResponse | null>;
    monthlyAnalystRecords(startTime: Date | undefined): Observable<LPGAnalystInputDTO[]>;
    addLPGAnalystInput(lPGAnalystInputDTO: LPGAnalystInputDTO): Observable<FileResponse | null>;
    editLPGAnalystInput(lPGAnalystInputEditDTO: LPGAnalystInputDTO): Observable<FileResponse | null>;
    deleteLPGAnalystInput(id: number | undefined): Observable<FileResponse | null>;
    dataForAnalyst(startTime: Date | undefined): Observable<LPGDataForAnalystDTO[]>;
    /**
     * Consumes StartTime as the date for which Approve action needs to be found.
     * @param startTime (optional) 
     */
    latestApprove(startTime: Date | undefined): Observable<string>;
    /**
     * returns json object with array of timestamp + value in each index.Timestamps can be sent in any timezone, it will convert to local (+5 UTC) under the hood
     * @param starttime (optional) 
     * @param endtime (optional) 
     * @param graphType (optional) 
     */
    getFlowmeterGraphs(starttime: Date | undefined, endtime: Date | undefined, graphType: LPGFlowmeterGraphTypes | undefined): Observable<LPGFlowmeterGraphDTO>;
    /**
     * Returns DTO of type LPGFuelGasFlaringReportDTO which contains timestamp and two objects of Monthly gas flaring report table and fuel gas flaring. Dt - represents any date inside the month, will return values starting from 1st day of the month up until EoM or Today - 1d
     * @param dt (optional) 
     */
    getFuelGasFlaring(dt: Date | undefined): Observable<LPGFuelGasFlaringReportDTO>;
    getFuelGasFlaringDefault(dt: Date | undefined): Observable<LPGFuelGasFlaringDefaultDTO>;
    getChemicalCompositions(startTime: Date | undefined): Observable<ChemicalCompoundRecord[]>;
    exportFlaringReports(dt: Date | undefined): Observable<FileResponse | null>;
    /**
     * StartTime is any date inside of the month that is needed to calculate.
     * @param startTime (optional) 
     */
    hardRefresh(startTime: Date | undefined): Observable<FileResponse | null>;
    /**
     * Consumes 1 Datetime - any date inside of the year. Will produce all rows for whole year. For Analyst and Bullets entry tables need to specify correct month in dt.
     * @param dt (optional) 
     */
    getLPGData(dt: Date | undefined): Observable<LPGDataDTO>;
    getFlaringReport(startTime: Date | undefined): Observable<LPGFlaringReportDTO[]>;
    getTargetPermitInputs(year: number | undefined): Observable<LPGTargetPermitInputDTO[]>;
    addTargetPermitInput(body: LPGTargetPermitInputDTO): Observable<FileResponse | null>;
    getFlowmeterCalculationData(starttime: Date | undefined, endtime: Date | undefined, days: number | undefined): Observable<LPGFlowmeterGraphDTO>;
    exportAnalystReports(dt: Date | undefined): Observable<FileResponse | null>;
    exportLPGDataReports(dt: Date | undefined): Observable<FileResponse | null>;
    exportFuelGasFlaringReports(dt: Date | undefined): Observable<FileResponse | null>;
    exportChemicalCompositionReports(dt: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class LPGClient implements ILPGClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    monthlyOperatorRecords(startTime: Date | undefined): Observable<LPGOperatorInputDTO[]> {
        let url_ = this.baseUrl + "/api/LPG/MonthlyOperatorRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyOperatorRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyOperatorRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGOperatorInputDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGOperatorInputDTO[]>;
        }));
    }

    protected processMonthlyOperatorRecords(response: HttpResponseBase): Observable<LPGOperatorInputDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LPGOperatorInputDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLPGOperatorInput(lPGOperatorInputDTO: LPGOperatorInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/AddLPGOperatorInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGOperatorInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLPGOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLPGOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddLPGOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editLPGOperatorInput(lPGOperatorInputEditDTO: LPGOperatorInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/EditLPGOperatorInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGOperatorInputEditDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLPGOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLPGOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditLPGOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLPGOperatorInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/DeleteLPGOperatorInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLPGOperatorInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLPGOperatorInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteLPGOperatorInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    monthlyPERecords(startTime: Date | undefined): Observable<LPGPEInputDTO[]> {
        let url_ = this.baseUrl + "/api/LPG/MonthlyPERecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyPERecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyPERecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGPEInputDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGPEInputDTO[]>;
        }));
    }

    protected processMonthlyPERecords(response: HttpResponseBase): Observable<LPGPEInputDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LPGPEInputDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPEMonthlyInput(body: LPGMonthlyInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/AddLPGPEMonthlyInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPEMonthlyInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPEMonthlyInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPEMonthlyInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLPGPEInput(lPGPEInputDTO: LPGPEInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/AddLPGPEInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGPEInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLPGPEInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLPGPEInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddLPGPEInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLPGFlowmeterCalculationInput(lPGPEInputDTO: LPGPEInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/AddLPGFlowmeterCalculationInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGPEInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLPGFlowmeterCalculationInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLPGFlowmeterCalculationInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddLPGFlowmeterCalculationInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCalculation(startTime: Date | undefined, endTime: Date | undefined, type: LPGFlowmeterCalculateType | undefined, avg: number | undefined, volume: number | undefined, mw: LPGStreamCCType | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/LPG/GetCalculation?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (avg === null)
            throw new Error("The parameter 'avg' cannot be null.");
        else if (avg !== undefined)
            url_ += "avg=" + encodeURIComponent("" + avg) + "&";
        if (volume === null)
            throw new Error("The parameter 'volume' cannot be null.");
        else if (volume !== undefined)
            url_ += "volume=" + encodeURIComponent("" + volume) + "&";
        if (mw === null)
            throw new Error("The parameter 'mw' cannot be null.");
        else if (mw !== undefined)
            url_ += "mw=" + encodeURIComponent("" + mw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCalculation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editLPGPEInput(lPGPEInputEditDTO: LPGPEInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/EditLPGPEInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGPEInputEditDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLPGPEInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLPGPEInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditLPGPEInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLPGPEInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/DeleteLPGPEInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLPGPEInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLPGPEInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteLPGPEInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Consumes StartTime as the date for which Approve must be done.
     * @param startTime (optional) 
     */
    approveByChef(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/Approve?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveByChef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveByChef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApproveByChef(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    monthlyAnalystRecords(startTime: Date | undefined): Observable<LPGAnalystInputDTO[]> {
        let url_ = this.baseUrl + "/api/LPG/MonthlyAnalystRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyAnalystRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyAnalystRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGAnalystInputDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGAnalystInputDTO[]>;
        }));
    }

    protected processMonthlyAnalystRecords(response: HttpResponseBase): Observable<LPGAnalystInputDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LPGAnalystInputDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLPGAnalystInput(lPGAnalystInputDTO: LPGAnalystInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/AddLPGAnalystInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGAnalystInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLPGAnalystInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLPGAnalystInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddLPGAnalystInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editLPGAnalystInput(lPGAnalystInputEditDTO: LPGAnalystInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/EditLPGAnalystInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lPGAnalystInputEditDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLPGAnalystInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLPGAnalystInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processEditLPGAnalystInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLPGAnalystInput(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/DeleteLPGAnalystInput?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLPGAnalystInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLPGAnalystInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteLPGAnalystInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dataForAnalyst(startTime: Date | undefined): Observable<LPGDataForAnalystDTO[]> {
        let url_ = this.baseUrl + "/api/LPG/LPGDataForAnalyst?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataForAnalyst(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataForAnalyst(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGDataForAnalystDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGDataForAnalystDTO[]>;
        }));
    }

    protected processDataForAnalyst(response: HttpResponseBase): Observable<LPGDataForAnalystDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LPGDataForAnalystDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Consumes StartTime as the date for which Approve action needs to be found.
     * @param startTime (optional) 
     */
    latestApprove(startTime: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/LPG/GetLatestApprove?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLatestApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLatestApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLatestApprove(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * returns json object with array of timestamp + value in each index.Timestamps can be sent in any timezone, it will convert to local (+5 UTC) under the hood
     * @param starttime (optional) 
     * @param endtime (optional) 
     * @param graphType (optional) 
     */
    getFlowmeterGraphs(starttime: Date | undefined, endtime: Date | undefined, graphType: LPGFlowmeterGraphTypes | undefined): Observable<LPGFlowmeterGraphDTO> {
        let url_ = this.baseUrl + "/api/LPG/Flowmeter?";
        if (starttime === null)
            throw new Error("The parameter 'starttime' cannot be null.");
        else if (starttime !== undefined)
            url_ += "starttime=" + encodeURIComponent(starttime ? "" + starttime.toISOString() : "") + "&";
        if (endtime === null)
            throw new Error("The parameter 'endtime' cannot be null.");
        else if (endtime !== undefined)
            url_ += "endtime=" + encodeURIComponent(endtime ? "" + endtime.toISOString() : "") + "&";
        if (graphType === null)
            throw new Error("The parameter 'graphType' cannot be null.");
        else if (graphType !== undefined)
            url_ += "graphType=" + encodeURIComponent("" + graphType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowmeterGraphs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowmeterGraphs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGFlowmeterGraphDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGFlowmeterGraphDTO>;
        }));
    }

    protected processGetFlowmeterGraphs(response: HttpResponseBase): Observable<LPGFlowmeterGraphDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LPGFlowmeterGraphDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns DTO of type LPGFuelGasFlaringReportDTO which contains timestamp and two objects of Monthly gas flaring report table and fuel gas flaring. Dt - represents any date inside the month, will return values starting from 1st day of the month up until EoM or Today - 1d
     * @param dt (optional) 
     */
    getFuelGasFlaring(dt: Date | undefined): Observable<LPGFuelGasFlaringReportDTO> {
        let url_ = this.baseUrl + "/api/LPG/FuelGasFlaring?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelGasFlaring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelGasFlaring(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGFuelGasFlaringReportDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGFuelGasFlaringReportDTO>;
        }));
    }

    protected processGetFuelGasFlaring(response: HttpResponseBase): Observable<LPGFuelGasFlaringReportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LPGFuelGasFlaringReportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFuelGasFlaringDefault(dt: Date | undefined): Observable<LPGFuelGasFlaringDefaultDTO> {
        let url_ = this.baseUrl + "/api/LPG/GetFuelGasFlaringDefault?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelGasFlaringDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelGasFlaringDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGFuelGasFlaringDefaultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGFuelGasFlaringDefaultDTO>;
        }));
    }

    protected processGetFuelGasFlaringDefault(response: HttpResponseBase): Observable<LPGFuelGasFlaringDefaultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LPGFuelGasFlaringDefaultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalCompositions(startTime: Date | undefined): Observable<ChemicalCompoundRecord[]> {
        let url_ = this.baseUrl + "/api/LPG/GetChemicalCompositions?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCompositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCompositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCompoundRecord[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCompoundRecord[]>;
        }));
    }

    protected processGetChemicalCompositions(response: HttpResponseBase): Observable<ChemicalCompoundRecord[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalCompoundRecord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFlaringReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/ExportFlaringReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFlaringReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFlaringReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportFlaringReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * StartTime is any date inside of the month that is needed to calculate.
     * @param startTime (optional) 
     */
    hardRefresh(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefresh(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Consumes 1 Datetime - any date inside of the year. Will produce all rows for whole year. For Analyst and Bullets entry tables need to specify correct month in dt.
     * @param dt (optional) 
     */
    getLPGData(dt: Date | undefined): Observable<LPGDataDTO> {
        let url_ = this.baseUrl + "/api/LPG/LPGData?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLPGData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLPGData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGDataDTO>;
        }));
    }

    protected processGetLPGData(response: HttpResponseBase): Observable<LPGDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LPGDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlaringReport(startTime: Date | undefined): Observable<LPGFlaringReportDTO[]> {
        let url_ = this.baseUrl + "/api/LPG/GetFlaringReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlaringReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlaringReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGFlaringReportDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGFlaringReportDTO[]>;
        }));
    }

    protected processGetFlaringReport(response: HttpResponseBase): Observable<LPGFlaringReportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LPGFlaringReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTargetPermitInputs(year: number | undefined): Observable<LPGTargetPermitInputDTO[]> {
        let url_ = this.baseUrl + "/api/LPG/GetLPGTargetPermit?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTargetPermitInputs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetPermitInputs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGTargetPermitInputDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGTargetPermitInputDTO[]>;
        }));
    }

    protected processGetTargetPermitInputs(response: HttpResponseBase): Observable<LPGTargetPermitInputDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LPGTargetPermitInputDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addTargetPermitInput(body: LPGTargetPermitInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/AddLPGTargetPermitInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTargetPermitInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTargetPermitInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddTargetPermitInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlowmeterCalculationData(starttime: Date | undefined, endtime: Date | undefined, days: number | undefined): Observable<LPGFlowmeterGraphDTO> {
        let url_ = this.baseUrl + "/api/LPG/GetLPGFlowmeterCalculationData?";
        if (starttime === null)
            throw new Error("The parameter 'starttime' cannot be null.");
        else if (starttime !== undefined)
            url_ += "starttime=" + encodeURIComponent(starttime ? "" + starttime.toISOString() : "") + "&";
        if (endtime === null)
            throw new Error("The parameter 'endtime' cannot be null.");
        else if (endtime !== undefined)
            url_ += "endtime=" + encodeURIComponent(endtime ? "" + endtime.toISOString() : "") + "&";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowmeterCalculationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowmeterCalculationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LPGFlowmeterGraphDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LPGFlowmeterGraphDTO>;
        }));
    }

    protected processGetFlowmeterCalculationData(response: HttpResponseBase): Observable<LPGFlowmeterGraphDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LPGFlowmeterGraphDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAnalystReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/ExportAnalystReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAnalystReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAnalystReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportAnalystReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLPGDataReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/ExportLPGDataReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLPGDataReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLPGDataReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLPGDataReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFuelGasFlaringReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/ExportFuelGasFlaringReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFuelGasFlaringReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFuelGasFlaringReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportFuelGasFlaringReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportChemicalCompositionReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LPG/ExportChemicalCompositionReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChemicalCompositionReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChemicalCompositionReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportChemicalCompositionReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISGIClient {
    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null>;
    addManualRecord(sGIInputRecordDTO: SGIInputRecordDTO): Observable<FileResponse | null>;
    addEditOverride(sGIInputRecordDTO: SGIEditOverrideDTO): Observable<FileResponse | null>;
    deleteEditOverride(sGIInputRecordDTO: SGIEditOverrideDTO): Observable<FileResponse | null>;
    addBlowdownRecord(sGIInputRecordDTO: SGIBlowdownInputRecordDTO): Observable<FileResponse | null>;
    getBlowdownRecords(from: Date | undefined, to: Date | undefined): Observable<SGIBlowdownInputRecordDTO[]>;
    deleteBlowdownRecord(id: number | undefined): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    eCHardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    getDailyReport(startTime: Date | undefined): Observable<FileResponse | null>;
    confirmDailyReport(startTime: Date | undefined): Observable<FileResponse | null>;
    approve(startTime: Date | undefined): Observable<FileResponse | null>;
    getLatestApprove(startTime: Date | undefined): Observable<string>;
    addSGIPermitTargetInput(sGIPermitTargetInputDTO: SGIPermitTargetInputDTO): Observable<FileResponse | null>;
    getSGIPermitTargetInput(year: number | undefined): Observable<SGIPermitTargetInputDTO[]>;
    getChemicalCompounds(startTime: Date | undefined): Observable<FileResponse | null>;
    monthlyReport(dt: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class SGIClient implements ISGIClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/RefreshStreams?";
        if (isDelta === null)
            throw new Error("The parameter 'isDelta' cannot be null.");
        else if (isDelta !== undefined)
            url_ += "isDelta=" + encodeURIComponent("" + isDelta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualRecord(sGIInputRecordDTO: SGIInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/ManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sGIInputRecordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEditOverride(sGIInputRecordDTO: SGIEditOverrideDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/EditOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sGIInputRecordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEditOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEditOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddEditOverride(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEditOverride(sGIInputRecordDTO: SGIEditOverrideDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/EditOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sGIInputRecordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEditOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEditOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteEditOverride(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addBlowdownRecord(sGIInputRecordDTO: SGIBlowdownInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/BlowdownRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sGIInputRecordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBlowdownRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBlowdownRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddBlowdownRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlowdownRecords(from: Date | undefined, to: Date | undefined): Observable<SGIBlowdownInputRecordDTO[]> {
        let url_ = this.baseUrl + "/api/SGI/BlowdownRecord?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlowdownRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlowdownRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SGIBlowdownInputRecordDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SGIBlowdownInputRecordDTO[]>;
        }));
    }

    protected processGetBlowdownRecords(response: HttpResponseBase): Observable<SGIBlowdownInputRecordDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SGIBlowdownInputRecordDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBlowdownRecord(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/BlowdownRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBlowdownRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBlowdownRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteBlowdownRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    eCHardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/ECHardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processECHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processECHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processECHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyReport(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/GetDailyReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDailyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmDailyReport(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/ConfirmDailyReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processConfirmDailyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approve(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/Approve?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestApprove(startTime: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SGI/ApproveTimestamp?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLatestApprove(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addSGIPermitTargetInput(sGIPermitTargetInputDTO: SGIPermitTargetInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/AddSGIPermitTargetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sGIPermitTargetInputDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSGIPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSGIPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddSGIPermitTargetInput(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSGIPermitTargetInput(year: number | undefined): Observable<SGIPermitTargetInputDTO[]> {
        let url_ = this.baseUrl + "/api/SGI/GetSGIPermitTargetInput?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSGIPermitTargetInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSGIPermitTargetInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SGIPermitTargetInputDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SGIPermitTargetInputDTO[]>;
        }));
    }

    protected processGetSGIPermitTargetInput(response: HttpResponseBase): Observable<SGIPermitTargetInputDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SGIPermitTargetInputDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChemicalCompounds(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/LIMS?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChemicalCompounds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChemicalCompounds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetChemicalCompounds(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    monthlyReport(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGI/GetSGIMonthlyReport?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMonthlyReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISGPFGDClient {
    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null>;
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<string>;
    getMonthlyRecords(startTime: Date | undefined): Observable<SGPFGDCalculatedDTO[]>;
    isDailyRecordsExist(startTime: Date | undefined): Observable<boolean>;
    getDailyRecords(startTime: Date | undefined): Observable<SGPFGDCalculatedDTO[]>;
    addManualRecord(recordDTO: SGPFGDInputRecordDTO): Observable<FileResponse | null>;
    overrideManualRecord(recordDTO: SGPFGDOverrideRecordDTO): Observable<FileResponse | null>;
    deleteOverrideRecord(streamId: number | undefined, startTime: Date | undefined): Observable<FileResponse | null>;
    getGUR(startTime: Date | undefined): Observable<GetGURDTO>;
    postGUR(input: GURInputRecordDTO): Observable<FileResponse | null>;
    exportSGPFGDDailyReports(dt: Date | undefined): Observable<FileResponse | null>;
    exportSGPFGDMonthlyReports(dt: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class SGPFGDClient implements ISGPFGDClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshStreams(isDelta: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/RefreshStreams?";
        if (isDelta === null)
            throw new Error("The parameter 'isDelta' cannot be null.");
        else if (isDelta !== undefined)
            url_ += "isDelta=" + encodeURIComponent("" + isDelta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStreams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRefreshStreams(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SGPFGD/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyRecords(startTime: Date | undefined): Observable<SGPFGDCalculatedDTO[]> {
        let url_ = this.baseUrl + "/api/SGPFGD/MonthlyRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SGPFGDCalculatedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SGPFGDCalculatedDTO[]>;
        }));
    }

    protected processGetMonthlyRecords(response: HttpResponseBase): Observable<SGPFGDCalculatedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SGPFGDCalculatedDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isDailyRecordsExist(startTime: Date | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/SGPFGD/IsDailyRecordsExist?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDailyRecordsExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDailyRecordsExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDailyRecordsExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDailyRecords(startTime: Date | undefined): Observable<SGPFGDCalculatedDTO[]> {
        let url_ = this.baseUrl + "/api/SGPFGD/DailyRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SGPFGDCalculatedDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SGPFGDCalculatedDTO[]>;
        }));
    }

    protected processGetDailyRecords(response: HttpResponseBase): Observable<SGPFGDCalculatedDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SGPFGDCalculatedDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualRecord(recordDTO: SGPFGDInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/ManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    overrideManualRecord(recordDTO: SGPFGDOverrideRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/OverrideManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processOverrideManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOverrideRecord(streamId: number | undefined, startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/DeleteOverrideRecord?";
        if (streamId === null)
            throw new Error("The parameter 'streamId' cannot be null.");
        else if (streamId !== undefined)
            url_ += "streamId=" + encodeURIComponent("" + streamId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOverrideRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOverrideRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteOverrideRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGUR(startTime: Date | undefined): Observable<GetGURDTO> {
        let url_ = this.baseUrl + "/api/SGPFGD/GUR?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGURDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGURDTO>;
        }));
    }

    protected processGetGUR(response: HttpResponseBase): Observable<GetGURDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGURDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postGUR(input: GURInputRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/GUR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostGUR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostGUR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPostGUR(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSGPFGDDailyReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/ExportSGPFGDDailyReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSGPFGDDailyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSGPFGDDailyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportSGPFGDDailyReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSGPFGDMonthlyReports(dt: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGD/ExportSGPFGDMonthlyReports?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSGPFGDMonthlyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSGPFGDMonthlyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportSGPFGDMonthlyReports(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISGPFGDECClient {
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class SGPFGDECClient implements ISGPFGDECClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SGPFGDEC/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISO2Client {
    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null>;
    getMonthlyRecords(startTime: Date | undefined): Observable<KTLSGPSO2CalculatedReportDTO[]>;
    addManualRecord(recordDTO: KTLSGPSO2RecordDTO): Observable<FileResponse | null>;
    getProjectedData(date: Date | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfKTLSGPSO2ProjectedDataInputDTO>;
    inputProjectedData(dto: KTLSGPSO2ProjectedDataInputDTO): Observable<FileResponse | null>;
    deleteProjectedData(id: number | undefined): Observable<FileResponse | null>;
    /**
     * returns json object with array of timestamp + value in each index for specific day.
     * @param dt (optional) 
     * @param streamType (optional) 
     * @param areaType (optional) 
     */
    getFlowmeterGraph(dt: Date | undefined, streamType: Plant | undefined, areaType: SO2StreamGroupChildrenTypes | undefined): Observable<SO2FlowmeterGraphDTO[]>;
    recalculation(record: KTLSGPSO2RecalculationRecordDTO): Observable<FileResponse | null>;
    getSO2RecalculationData(date: Date | undefined, train: SO2StreamGroupChildrenTypes | undefined): Observable<KTLSGPSO2RecalculationRecordDTO[]>;
    deleteSO2Recalculation(id: number): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class SO2Client implements ISO2Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hardRefreshAFToSQL(startTime: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SO2/HardRefreshAFToSQL?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardRefreshAFToSQL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardRefreshAFToSQL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processHardRefreshAFToSQL(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMonthlyRecords(startTime: Date | undefined): Observable<KTLSGPSO2CalculatedReportDTO[]> {
        let url_ = this.baseUrl + "/api/SO2/MonthlyRecords?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPSO2CalculatedReportDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPSO2CalculatedReportDTO[]>;
        }));
    }

    protected processGetMonthlyRecords(response: HttpResponseBase): Observable<KTLSGPSO2CalculatedReportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KTLSGPSO2CalculatedReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addManualRecord(recordDTO: KTLSGPSO2RecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SO2/ManualRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddManualRecord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectedData(date: Date | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<PagedListOfKTLSGPSO2ProjectedDataInputDTO> {
        let url_ = this.baseUrl + "/api/SO2/GetProjectedData?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfKTLSGPSO2ProjectedDataInputDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfKTLSGPSO2ProjectedDataInputDTO>;
        }));
    }

    protected processGetProjectedData(response: HttpResponseBase): Observable<PagedListOfKTLSGPSO2ProjectedDataInputDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfKTLSGPSO2ProjectedDataInputDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inputProjectedData(dto: KTLSGPSO2ProjectedDataInputDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SO2/InputProjectedData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInputProjectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInputProjectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processInputProjectedData(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProjectedData(id: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SO2/DeleteProjectedData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteProjectedData(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * returns json object with array of timestamp + value in each index for specific day.
     * @param dt (optional) 
     * @param streamType (optional) 
     * @param areaType (optional) 
     */
    getFlowmeterGraph(dt: Date | undefined, streamType: Plant | undefined, areaType: SO2StreamGroupChildrenTypes | undefined): Observable<SO2FlowmeterGraphDTO[]> {
        let url_ = this.baseUrl + "/api/SO2/SO2Flowmeter?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        if (streamType === null)
            throw new Error("The parameter 'streamType' cannot be null.");
        else if (streamType !== undefined)
            url_ += "streamType=" + encodeURIComponent("" + streamType) + "&";
        if (areaType === null)
            throw new Error("The parameter 'areaType' cannot be null.");
        else if (areaType !== undefined)
            url_ += "areaType=" + encodeURIComponent("" + areaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowmeterGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowmeterGraph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SO2FlowmeterGraphDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SO2FlowmeterGraphDTO[]>;
        }));
    }

    protected processGetFlowmeterGraph(response: HttpResponseBase): Observable<SO2FlowmeterGraphDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SO2FlowmeterGraphDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recalculation(record: KTLSGPSO2RecalculationRecordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SO2/SO2Recalculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRecalculation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSO2RecalculationData(date: Date | undefined, train: SO2StreamGroupChildrenTypes | undefined): Observable<KTLSGPSO2RecalculationRecordDTO[]> {
        let url_ = this.baseUrl + "/api/SO2/GetSO2RecalculationData?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (train === null)
            throw new Error("The parameter 'train' cannot be null.");
        else if (train !== undefined)
            url_ += "train=" + encodeURIComponent("" + train) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSO2RecalculationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSO2RecalculationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KTLSGPSO2RecalculationRecordDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KTLSGPSO2RecalculationRecordDTO[]>;
        }));
    }

    protected processGetSO2RecalculationData(response: HttpResponseBase): Observable<KTLSGPSO2RecalculationRecordDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KTLSGPSO2RecalculationRecordDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSO2Recalculation(id: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SO2/DeleteSO2Recalculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSO2Recalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSO2Recalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteSO2Recalculation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    getCurrentUser(): Observable<string>;
    getCurrentUser2(): Observable<string>;
    getCurrentUserGroups(): Observable<UserGroups[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentUser(): Observable<string> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUser2(): Observable<string> {
        let url_ = this.baseUrl + "/api/User/GetCurrentUser2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCurrentUser2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUserGroups(): Observable<UserGroups[]> {
        let url_ = this.baseUrl + "/api/User/GetUserGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserGroups[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserGroups[]>;
        }));
    }

    protected processGetCurrentUserGroups(response: HttpResponseBase): Observable<UserGroups[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class PurgePilotEntriesDTO implements IPurgePilotEntriesDTO {
    user!: string;
    startTime!: Date;
    logged!: Date;
    mwTengiz!: number;
    mwKorolev!: number;

    constructor(data?: IPurgePilotEntriesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.mwTengiz = _data["mwTengiz"] !== undefined ? _data["mwTengiz"] : <any>null;
            this.mwKorolev = _data["mwKorolev"] !== undefined ? _data["mwKorolev"] : <any>null;
        }
    }

    static fromJS(data: any): PurgePilotEntriesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PurgePilotEntriesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["mwTengiz"] = this.mwTengiz !== undefined ? this.mwTengiz : <any>null;
        data["mwKorolev"] = this.mwKorolev !== undefined ? this.mwKorolev : <any>null;
        return data;
    }
}

export interface IPurgePilotEntriesDTO {
    user: string;
    startTime: Date;
    logged: Date;
    mwTengiz: number;
    mwKorolev: number;
}

export class RecordTablesDTO implements IRecordTablesDTO {
    id!: number;
    referTo!: FieldArea;
    startTime!: Date;
    endTime?: Date | null;
    operatorOnlyStartTime!: Date;
    operatorOnlyEndTime?: Date | null;
    operatorInput!: boolean;
    isConfirmed!: boolean;
    findAutoInputs!: boolean;
    usedNitrogen!: boolean;
    p_With_Nitrogen_Initial?: number | null;
    p_With_Nitrogen_Final?: number | null;
    p_Nitrogen_Initial?: number | null;
    p_Nitrogen_Final?: number | null;
    facility!: string;
    reason!: string;
    category!: string;
    location!: string;
    mw!: number;
    length?: number | null;
    diameter?: number | null;
    pipeWall?: number | null;
    lineVolume?: number | null;
    p_Initial?: number | null;
    p_Initial_Timestamp?: Date | null;
    p_Final?: number | null;
    p_Final_Timestamp?: Date | null;
    t_Initial?: number | null;
    t_Initial_Timestamp?: Date | null;
    t_Final?: number | null;
    t_Final_Timestamp?: Date | null;
    z_Initial?: number | null;
    z_Final?: number | null;
    k1?: number | null;
    k2?: number | null;
    isBledFully!: boolean;
    volume!: number;
    mass!: number;
    mrmVolumes!: RecordVolumeDto;
    mrmMasses!: RecordMassDto;
    type!: FieldRecordManualType;
    user!: string;
    createdBy!: string;
    logged!: Date;

    constructor(data?: IRecordTablesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mrmVolumes = new RecordVolumeDto();
            this.mrmMasses = new RecordMassDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.referTo = _data["referTo"] !== undefined ? _data["referTo"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.operatorOnlyStartTime = _data["operatorOnlyStartTime"] ? new Date(_data["operatorOnlyStartTime"].toString()) : <any>null;
            this.operatorOnlyEndTime = _data["operatorOnlyEndTime"] ? new Date(_data["operatorOnlyEndTime"].toString()) : <any>null;
            this.operatorInput = _data["operatorInput"] !== undefined ? _data["operatorInput"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.findAutoInputs = _data["findAutoInputs"] !== undefined ? _data["findAutoInputs"] : <any>null;
            this.usedNitrogen = _data["usedNitrogen"] !== undefined ? _data["usedNitrogen"] : <any>null;
            this.p_With_Nitrogen_Initial = _data["p_With_Nitrogen_Initial"] !== undefined ? _data["p_With_Nitrogen_Initial"] : <any>null;
            this.p_With_Nitrogen_Final = _data["p_With_Nitrogen_Final"] !== undefined ? _data["p_With_Nitrogen_Final"] : <any>null;
            this.p_Nitrogen_Initial = _data["p_Nitrogen_Initial"] !== undefined ? _data["p_Nitrogen_Initial"] : <any>null;
            this.p_Nitrogen_Final = _data["p_Nitrogen_Final"] !== undefined ? _data["p_Nitrogen_Final"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.length = _data["length"] !== undefined ? _data["length"] : <any>null;
            this.diameter = _data["diameter"] !== undefined ? _data["diameter"] : <any>null;
            this.pipeWall = _data["pipeWall"] !== undefined ? _data["pipeWall"] : <any>null;
            this.lineVolume = _data["lineVolume"] !== undefined ? _data["lineVolume"] : <any>null;
            this.p_Initial = _data["p_Initial"] !== undefined ? _data["p_Initial"] : <any>null;
            this.p_Initial_Timestamp = _data["p_Initial_Timestamp"] ? new Date(_data["p_Initial_Timestamp"].toString()) : <any>null;
            this.p_Final = _data["p_Final"] !== undefined ? _data["p_Final"] : <any>null;
            this.p_Final_Timestamp = _data["p_Final_Timestamp"] ? new Date(_data["p_Final_Timestamp"].toString()) : <any>null;
            this.t_Initial = _data["t_Initial"] !== undefined ? _data["t_Initial"] : <any>null;
            this.t_Initial_Timestamp = _data["t_Initial_Timestamp"] ? new Date(_data["t_Initial_Timestamp"].toString()) : <any>null;
            this.t_Final = _data["t_Final"] !== undefined ? _data["t_Final"] : <any>null;
            this.t_Final_Timestamp = _data["t_Final_Timestamp"] ? new Date(_data["t_Final_Timestamp"].toString()) : <any>null;
            this.z_Initial = _data["z_Initial"] !== undefined ? _data["z_Initial"] : <any>null;
            this.z_Final = _data["z_Final"] !== undefined ? _data["z_Final"] : <any>null;
            this.k1 = _data["k1"] !== undefined ? _data["k1"] : <any>null;
            this.k2 = _data["k2"] !== undefined ? _data["k2"] : <any>null;
            this.isBledFully = _data["isBledFully"] !== undefined ? _data["isBledFully"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.mrmVolumes = _data["mrmVolumes"] ? RecordVolumeDto.fromJS(_data["mrmVolumes"]) : new RecordVolumeDto();
            this.mrmMasses = _data["mrmMasses"] ? RecordMassDto.fromJS(_data["mrmMasses"]) : new RecordMassDto();
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): RecordTablesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordTablesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["referTo"] = this.referTo !== undefined ? this.referTo : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["operatorOnlyStartTime"] = this.operatorOnlyStartTime ? this.operatorOnlyStartTime.toISOString() : <any>null;
        data["operatorOnlyEndTime"] = this.operatorOnlyEndTime ? this.operatorOnlyEndTime.toISOString() : <any>null;
        data["operatorInput"] = this.operatorInput !== undefined ? this.operatorInput : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["findAutoInputs"] = this.findAutoInputs !== undefined ? this.findAutoInputs : <any>null;
        data["usedNitrogen"] = this.usedNitrogen !== undefined ? this.usedNitrogen : <any>null;
        data["p_With_Nitrogen_Initial"] = this.p_With_Nitrogen_Initial !== undefined ? this.p_With_Nitrogen_Initial : <any>null;
        data["p_With_Nitrogen_Final"] = this.p_With_Nitrogen_Final !== undefined ? this.p_With_Nitrogen_Final : <any>null;
        data["p_Nitrogen_Initial"] = this.p_Nitrogen_Initial !== undefined ? this.p_Nitrogen_Initial : <any>null;
        data["p_Nitrogen_Final"] = this.p_Nitrogen_Final !== undefined ? this.p_Nitrogen_Final : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["diameter"] = this.diameter !== undefined ? this.diameter : <any>null;
        data["pipeWall"] = this.pipeWall !== undefined ? this.pipeWall : <any>null;
        data["lineVolume"] = this.lineVolume !== undefined ? this.lineVolume : <any>null;
        data["p_Initial"] = this.p_Initial !== undefined ? this.p_Initial : <any>null;
        data["p_Initial_Timestamp"] = this.p_Initial_Timestamp ? this.p_Initial_Timestamp.toISOString() : <any>null;
        data["p_Final"] = this.p_Final !== undefined ? this.p_Final : <any>null;
        data["p_Final_Timestamp"] = this.p_Final_Timestamp ? this.p_Final_Timestamp.toISOString() : <any>null;
        data["t_Initial"] = this.t_Initial !== undefined ? this.t_Initial : <any>null;
        data["t_Initial_Timestamp"] = this.t_Initial_Timestamp ? this.t_Initial_Timestamp.toISOString() : <any>null;
        data["t_Final"] = this.t_Final !== undefined ? this.t_Final : <any>null;
        data["t_Final_Timestamp"] = this.t_Final_Timestamp ? this.t_Final_Timestamp.toISOString() : <any>null;
        data["z_Initial"] = this.z_Initial !== undefined ? this.z_Initial : <any>null;
        data["z_Final"] = this.z_Final !== undefined ? this.z_Final : <any>null;
        data["k1"] = this.k1 !== undefined ? this.k1 : <any>null;
        data["k2"] = this.k2 !== undefined ? this.k2 : <any>null;
        data["isBledFully"] = this.isBledFully !== undefined ? this.isBledFully : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["mrmVolumes"] = this.mrmVolumes ? this.mrmVolumes.toJSON() : <any>null;
        data["mrmMasses"] = this.mrmMasses ? this.mrmMasses.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        return data;
    }
}

export interface IRecordTablesDTO {
    id: number;
    referTo: FieldArea;
    startTime: Date;
    endTime?: Date | null;
    operatorOnlyStartTime: Date;
    operatorOnlyEndTime?: Date | null;
    operatorInput: boolean;
    isConfirmed: boolean;
    findAutoInputs: boolean;
    usedNitrogen: boolean;
    p_With_Nitrogen_Initial?: number | null;
    p_With_Nitrogen_Final?: number | null;
    p_Nitrogen_Initial?: number | null;
    p_Nitrogen_Final?: number | null;
    facility: string;
    reason: string;
    category: string;
    location: string;
    mw: number;
    length?: number | null;
    diameter?: number | null;
    pipeWall?: number | null;
    lineVolume?: number | null;
    p_Initial?: number | null;
    p_Initial_Timestamp?: Date | null;
    p_Final?: number | null;
    p_Final_Timestamp?: Date | null;
    t_Initial?: number | null;
    t_Initial_Timestamp?: Date | null;
    t_Final?: number | null;
    t_Final_Timestamp?: Date | null;
    z_Initial?: number | null;
    z_Final?: number | null;
    k1?: number | null;
    k2?: number | null;
    isBledFully: boolean;
    volume: number;
    mass: number;
    mrmVolumes: RecordVolumeDto;
    mrmMasses: RecordMassDto;
    type: FieldRecordManualType;
    user: string;
    createdBy: string;
    logged: Date;
}

export enum FieldArea {
    Tengiz = 0,
    Korolev = 1,
}

export class RecordVolumeDto implements IRecordVolumeDto {
    tank1!: number;
    tank2!: number;
    tank3!: number;
    tank4!: number;

    constructor(data?: IRecordVolumeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tank1 = _data["tank1"] !== undefined ? _data["tank1"] : <any>null;
            this.tank2 = _data["tank2"] !== undefined ? _data["tank2"] : <any>null;
            this.tank3 = _data["tank3"] !== undefined ? _data["tank3"] : <any>null;
            this.tank4 = _data["tank4"] !== undefined ? _data["tank4"] : <any>null;
        }
    }

    static fromJS(data: any): RecordVolumeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordVolumeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tank1"] = this.tank1 !== undefined ? this.tank1 : <any>null;
        data["tank2"] = this.tank2 !== undefined ? this.tank2 : <any>null;
        data["tank3"] = this.tank3 !== undefined ? this.tank3 : <any>null;
        data["tank4"] = this.tank4 !== undefined ? this.tank4 : <any>null;
        return data;
    }
}

export interface IRecordVolumeDto {
    tank1: number;
    tank2: number;
    tank3: number;
    tank4: number;
}

export class RecordMassDto implements IRecordMassDto {
    tank1!: number;
    tank2!: number;
    tank3!: number;
    tank4!: number;

    constructor(data?: IRecordMassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tank1 = _data["tank1"] !== undefined ? _data["tank1"] : <any>null;
            this.tank2 = _data["tank2"] !== undefined ? _data["tank2"] : <any>null;
            this.tank3 = _data["tank3"] !== undefined ? _data["tank3"] : <any>null;
            this.tank4 = _data["tank4"] !== undefined ? _data["tank4"] : <any>null;
        }
    }

    static fromJS(data: any): RecordMassDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordMassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tank1"] = this.tank1 !== undefined ? this.tank1 : <any>null;
        data["tank2"] = this.tank2 !== undefined ? this.tank2 : <any>null;
        data["tank3"] = this.tank3 !== undefined ? this.tank3 : <any>null;
        data["tank4"] = this.tank4 !== undefined ? this.tank4 : <any>null;
        return data;
    }
}

export interface IRecordMassDto {
    tank1: number;
    tank2: number;
    tank3: number;
    tank4: number;
}

export enum FieldRecordManualType {
    DryGasUsage = 0,
    DryGasFlaring = 1,
    ReservoirGasFlaring = 2,
    DryGasMRM = 3,
    ReservoirMRM = 4,
    KorolevDry = 5,
    PurgePilotSwitch = 6,
    DryLeakageDaily = 9,
    ReservoirLeakageDaily = 10,
    DryVolumeFlaring = 11,
    ReservoirVolumeFlaring = 12,
    DryVolumeUsage = 13,
}

export class FieldTotal implements IFieldTotal {
    totalMass!: any;
    totalVolume!: any;
    type!: FieldTotalType;

    constructor(data?: IFieldTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): FieldTotal {
        data = typeof data === 'object' ? data : {};
        let result = new FieldTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IFieldTotal {
    totalMass: any;
    totalVolume: any;
    type: FieldTotalType;
}

export enum FieldTotalType {
    DryGasUsed = 0,
    DryGasFlared = 1,
    ReservoirGasFlared = 2,
    DryGasMRM = 3,
    ReservoirMRM = 4,
    DryGasUsedFGP = 5,
    DryGasFlaredFGP = 6,
    ReservoirGasFlaredFGP = 7,
    DryGasMRMFGP = 8,
    ReservoirMRMFGP = 9,
    DryGasUsedTengiz = 10,
    DryGasUsedKorolev = 11,
    DryGasFlaredTengiz = 12,
    DrygasFlaredKorolev = 13,
    ReservoirGasFlaredTengiz = 14,
    ReservoirGasFlaredKorolev = 15,
}

export enum ActionTypeEnumDTO {
    ConfirmFieldCalcDryGas = 0,
    ConfirmFieldCalcReservoirGas = 1,
    Approve = 2,
}

export class PurgePilotDTO implements IPurgePilotDTO {
    user?: string | null;
    referTo!: FieldArea;
    flareStack?: string | null;
    pilotFlowrate!: number;
    purgeFlowrate!: number;
    totalMassPilot!: number;
    totalVolumePilot!: number;
    totalMassPurge!: number;
    totalVolumePurge!: number;
    pilotDays1!: number;
    pilotDays2!: number;
    pilotDays3!: number;
    purgeDays1!: number;
    purgeDays2!: number;
    purgeDays3!: number;
    mw!: number;
    pilotFlowingHours!: number;
    purgeFlowingHours!: number;
    facility!: string;
    timeStamp!: Date;
    logged!: Date;

    constructor(data?: IPurgePilotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.referTo = _data["referTo"] !== undefined ? _data["referTo"] : <any>null;
            this.flareStack = _data["flareStack"] !== undefined ? _data["flareStack"] : <any>null;
            this.pilotFlowrate = _data["pilotFlowrate"] !== undefined ? _data["pilotFlowrate"] : <any>null;
            this.purgeFlowrate = _data["purgeFlowrate"] !== undefined ? _data["purgeFlowrate"] : <any>null;
            this.totalMassPilot = _data["totalMassPilot"] !== undefined ? _data["totalMassPilot"] : <any>null;
            this.totalVolumePilot = _data["totalVolumePilot"] !== undefined ? _data["totalVolumePilot"] : <any>null;
            this.totalMassPurge = _data["totalMassPurge"] !== undefined ? _data["totalMassPurge"] : <any>null;
            this.totalVolumePurge = _data["totalVolumePurge"] !== undefined ? _data["totalVolumePurge"] : <any>null;
            this.pilotDays1 = _data["pilotDays1"] !== undefined ? _data["pilotDays1"] : <any>null;
            this.pilotDays2 = _data["pilotDays2"] !== undefined ? _data["pilotDays2"] : <any>null;
            this.pilotDays3 = _data["pilotDays3"] !== undefined ? _data["pilotDays3"] : <any>null;
            this.purgeDays1 = _data["purgeDays1"] !== undefined ? _data["purgeDays1"] : <any>null;
            this.purgeDays2 = _data["purgeDays2"] !== undefined ? _data["purgeDays2"] : <any>null;
            this.purgeDays3 = _data["purgeDays3"] !== undefined ? _data["purgeDays3"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.pilotFlowingHours = _data["pilotFlowingHours"] !== undefined ? _data["pilotFlowingHours"] : <any>null;
            this.purgeFlowingHours = _data["purgeFlowingHours"] !== undefined ? _data["purgeFlowingHours"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PurgePilotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PurgePilotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["referTo"] = this.referTo !== undefined ? this.referTo : <any>null;
        data["flareStack"] = this.flareStack !== undefined ? this.flareStack : <any>null;
        data["pilotFlowrate"] = this.pilotFlowrate !== undefined ? this.pilotFlowrate : <any>null;
        data["purgeFlowrate"] = this.purgeFlowrate !== undefined ? this.purgeFlowrate : <any>null;
        data["totalMassPilot"] = this.totalMassPilot !== undefined ? this.totalMassPilot : <any>null;
        data["totalVolumePilot"] = this.totalVolumePilot !== undefined ? this.totalVolumePilot : <any>null;
        data["totalMassPurge"] = this.totalMassPurge !== undefined ? this.totalMassPurge : <any>null;
        data["totalVolumePurge"] = this.totalVolumePurge !== undefined ? this.totalVolumePurge : <any>null;
        data["pilotDays1"] = this.pilotDays1 !== undefined ? this.pilotDays1 : <any>null;
        data["pilotDays2"] = this.pilotDays2 !== undefined ? this.pilotDays2 : <any>null;
        data["pilotDays3"] = this.pilotDays3 !== undefined ? this.pilotDays3 : <any>null;
        data["purgeDays1"] = this.purgeDays1 !== undefined ? this.purgeDays1 : <any>null;
        data["purgeDays2"] = this.purgeDays2 !== undefined ? this.purgeDays2 : <any>null;
        data["purgeDays3"] = this.purgeDays3 !== undefined ? this.purgeDays3 : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["pilotFlowingHours"] = this.pilotFlowingHours !== undefined ? this.pilotFlowingHours : <any>null;
        data["purgeFlowingHours"] = this.purgeFlowingHours !== undefined ? this.purgeFlowingHours : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        return data;
    }
}

export interface IPurgePilotDTO {
    user?: string | null;
    referTo: FieldArea;
    flareStack?: string | null;
    pilotFlowrate: number;
    purgeFlowrate: number;
    totalMassPilot: number;
    totalVolumePilot: number;
    totalMassPurge: number;
    totalVolumePurge: number;
    pilotDays1: number;
    pilotDays2: number;
    pilotDays3: number;
    purgeDays1: number;
    purgeDays2: number;
    purgeDays3: number;
    mw: number;
    pilotFlowingHours: number;
    purgeFlowingHours: number;
    facility: string;
    timeStamp: Date;
    logged: Date;
}

export class RecordDTO implements IRecordDTO {
    id!: number;
    referTo!: FieldArea;
    startTime!: Date;
    endTime!: Date;
    isConfirmed!: boolean;
    operatorInput!: boolean;
    findAutoInputs!: boolean;
    facility?: string | null;
    gas?: string | null;
    purpose?: string | null;
    type!: FieldRecordManualType;
    reason?: string | null;
    category?: string | null;
    location?: string | null;
    lineVolume!: number;
    usedNitrogen!: boolean;
    p_Nitrogen_Initial!: number;
    p_Nitrogen_Final!: number;
    p_Initial!: number;
    p_Final!: number;
    t_Initial!: number;
    t_Final!: number;
    isBledFully!: boolean;
    volume!: number;
    isOverwriteVolume!: boolean;
    volumes!: RecordVolumeDto;
    masses!: RecordMassDto;
    properties!: { [key: string]: any; };

    constructor(data?: IRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.volumes = new RecordVolumeDto();
            this.masses = new RecordMassDto();
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.referTo = _data["referTo"] !== undefined ? _data["referTo"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.operatorInput = _data["operatorInput"] !== undefined ? _data["operatorInput"] : <any>null;
            this.findAutoInputs = _data["findAutoInputs"] !== undefined ? _data["findAutoInputs"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.gas = _data["gas"] !== undefined ? _data["gas"] : <any>null;
            this.purpose = _data["purpose"] !== undefined ? _data["purpose"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.lineVolume = _data["lineVolume"] !== undefined ? _data["lineVolume"] : <any>null;
            this.usedNitrogen = _data["usedNitrogen"] !== undefined ? _data["usedNitrogen"] : <any>null;
            this.p_Nitrogen_Initial = _data["p_Nitrogen_Initial"] !== undefined ? _data["p_Nitrogen_Initial"] : <any>null;
            this.p_Nitrogen_Final = _data["p_Nitrogen_Final"] !== undefined ? _data["p_Nitrogen_Final"] : <any>null;
            this.p_Initial = _data["p_Initial"] !== undefined ? _data["p_Initial"] : <any>null;
            this.p_Final = _data["p_Final"] !== undefined ? _data["p_Final"] : <any>null;
            this.t_Initial = _data["t_Initial"] !== undefined ? _data["t_Initial"] : <any>null;
            this.t_Final = _data["t_Final"] !== undefined ? _data["t_Final"] : <any>null;
            this.isBledFully = _data["isBledFully"] !== undefined ? _data["isBledFully"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.isOverwriteVolume = _data["isOverwriteVolume"] !== undefined ? _data["isOverwriteVolume"] : <any>null;
            this.volumes = _data["volumes"] ? RecordVolumeDto.fromJS(_data["volumes"]) : new RecordVolumeDto();
            this.masses = _data["masses"] ? RecordMassDto.fromJS(_data["masses"]) : new RecordMassDto();
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): RecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["referTo"] = this.referTo !== undefined ? this.referTo : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["operatorInput"] = this.operatorInput !== undefined ? this.operatorInput : <any>null;
        data["findAutoInputs"] = this.findAutoInputs !== undefined ? this.findAutoInputs : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["gas"] = this.gas !== undefined ? this.gas : <any>null;
        data["purpose"] = this.purpose !== undefined ? this.purpose : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["lineVolume"] = this.lineVolume !== undefined ? this.lineVolume : <any>null;
        data["usedNitrogen"] = this.usedNitrogen !== undefined ? this.usedNitrogen : <any>null;
        data["p_Nitrogen_Initial"] = this.p_Nitrogen_Initial !== undefined ? this.p_Nitrogen_Initial : <any>null;
        data["p_Nitrogen_Final"] = this.p_Nitrogen_Final !== undefined ? this.p_Nitrogen_Final : <any>null;
        data["p_Initial"] = this.p_Initial !== undefined ? this.p_Initial : <any>null;
        data["p_Final"] = this.p_Final !== undefined ? this.p_Final : <any>null;
        data["t_Initial"] = this.t_Initial !== undefined ? this.t_Initial : <any>null;
        data["t_Final"] = this.t_Final !== undefined ? this.t_Final : <any>null;
        data["isBledFully"] = this.isBledFully !== undefined ? this.isBledFully : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["isOverwriteVolume"] = this.isOverwriteVolume !== undefined ? this.isOverwriteVolume : <any>null;
        data["volumes"] = this.volumes ? this.volumes.toJSON() : <any>null;
        data["masses"] = this.masses ? this.masses.toJSON() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IRecordDTO {
    id: number;
    referTo: FieldArea;
    startTime: Date;
    endTime: Date;
    isConfirmed: boolean;
    operatorInput: boolean;
    findAutoInputs: boolean;
    facility?: string | null;
    gas?: string | null;
    purpose?: string | null;
    type: FieldRecordManualType;
    reason?: string | null;
    category?: string | null;
    location?: string | null;
    lineVolume: number;
    usedNitrogen: boolean;
    p_Nitrogen_Initial: number;
    p_Nitrogen_Final: number;
    p_Initial: number;
    p_Final: number;
    t_Initial: number;
    t_Final: number;
    isBledFully: boolean;
    volume: number;
    isOverwriteVolume: boolean;
    volumes: RecordVolumeDto;
    masses: RecordMassDto;
    properties: { [key: string]: any; };
}

export class PressureTemperatureGraphDTO implements IPressureTemperatureGraphDTO {
    title!: string;
    values!: PressureTemperatureGraphValuesDTO[];

    constructor(data?: IPressureTemperatureGraphDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(PressureTemperatureGraphValuesDTO.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): PressureTemperatureGraphDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureGraphDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPressureTemperatureGraphDTO {
    title: string;
    values: PressureTemperatureGraphValuesDTO[];
}

export class PressureTemperatureGraphValuesDTO implements IPressureTemperatureGraphValuesDTO {
    timespan!: Date;
    pressure!: number;
    temperature!: number;

    constructor(data?: IPressureTemperatureGraphValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timespan = _data["timespan"] ? new Date(_data["timespan"].toString()) : <any>null;
            this.pressure = _data["pressure"] !== undefined ? _data["pressure"] : <any>null;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): PressureTemperatureGraphValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PressureTemperatureGraphValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timespan"] = this.timespan ? this.timespan.toISOString() : <any>null;
        data["pressure"] = this.pressure !== undefined ? this.pressure : <any>null;
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        return data;
    }
}

export interface IPressureTemperatureGraphValuesDTO {
    timespan: Date;
    pressure: number;
    temperature: number;
}

export class RecordOperatorDTO implements IRecordOperatorDTO {
    id!: number;
    referTo!: FieldArea;
    operatorOnlyStartTime!: Date;
    operatorOnlyEndTime?: Date | null;
    startTime!: Date;
    endTime!: Date;
    operatorInput!: boolean;
    findAutoInputs!: boolean;
    facility!: string;
    gas?: string | null;
    purpose?: string | null;
    type!: FieldRecordManualType;
    isConfirmed!: boolean;
    reason!: string;
    category!: string;
    location!: string;
    usedNitrogen!: boolean;
    p_Nitrogen_Initial!: number;
    p_Nitrogen_Final!: number;
    p_Initial!: number;
    p_Final!: number;
    p_BledFully_Initial!: number;
    p_BledFully_Final!: number;
    isBledFully!: boolean;
    bledDate!: Date;
    comment?: string | null;
    createdBy?: string | null;
    user?: string | null;
    properties!: { [key: string]: any; };

    constructor(data?: IRecordOperatorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.referTo = _data["referTo"] !== undefined ? _data["referTo"] : <any>null;
            this.operatorOnlyStartTime = _data["operatorOnlyStartTime"] ? new Date(_data["operatorOnlyStartTime"].toString()) : <any>null;
            this.operatorOnlyEndTime = _data["operatorOnlyEndTime"] ? new Date(_data["operatorOnlyEndTime"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.operatorInput = _data["operatorInput"] !== undefined ? _data["operatorInput"] : <any>null;
            this.findAutoInputs = _data["findAutoInputs"] !== undefined ? _data["findAutoInputs"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.gas = _data["gas"] !== undefined ? _data["gas"] : <any>null;
            this.purpose = _data["purpose"] !== undefined ? _data["purpose"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.usedNitrogen = _data["usedNitrogen"] !== undefined ? _data["usedNitrogen"] : <any>null;
            this.p_Nitrogen_Initial = _data["p_Nitrogen_Initial"] !== undefined ? _data["p_Nitrogen_Initial"] : <any>null;
            this.p_Nitrogen_Final = _data["p_Nitrogen_Final"] !== undefined ? _data["p_Nitrogen_Final"] : <any>null;
            this.p_Initial = _data["p_Initial"] !== undefined ? _data["p_Initial"] : <any>null;
            this.p_Final = _data["p_Final"] !== undefined ? _data["p_Final"] : <any>null;
            this.p_BledFully_Initial = _data["p_BledFully_Initial"] !== undefined ? _data["p_BledFully_Initial"] : <any>null;
            this.p_BledFully_Final = _data["p_BledFully_Final"] !== undefined ? _data["p_BledFully_Final"] : <any>null;
            this.isBledFully = _data["isBledFully"] !== undefined ? _data["isBledFully"] : <any>null;
            this.bledDate = _data["bledDate"] ? new Date(_data["bledDate"].toString()) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): RecordOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordOperatorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["referTo"] = this.referTo !== undefined ? this.referTo : <any>null;
        data["operatorOnlyStartTime"] = this.operatorOnlyStartTime ? this.operatorOnlyStartTime.toISOString() : <any>null;
        data["operatorOnlyEndTime"] = this.operatorOnlyEndTime ? this.operatorOnlyEndTime.toISOString() : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["operatorInput"] = this.operatorInput !== undefined ? this.operatorInput : <any>null;
        data["findAutoInputs"] = this.findAutoInputs !== undefined ? this.findAutoInputs : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["gas"] = this.gas !== undefined ? this.gas : <any>null;
        data["purpose"] = this.purpose !== undefined ? this.purpose : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["usedNitrogen"] = this.usedNitrogen !== undefined ? this.usedNitrogen : <any>null;
        data["p_Nitrogen_Initial"] = this.p_Nitrogen_Initial !== undefined ? this.p_Nitrogen_Initial : <any>null;
        data["p_Nitrogen_Final"] = this.p_Nitrogen_Final !== undefined ? this.p_Nitrogen_Final : <any>null;
        data["p_Initial"] = this.p_Initial !== undefined ? this.p_Initial : <any>null;
        data["p_Final"] = this.p_Final !== undefined ? this.p_Final : <any>null;
        data["p_BledFully_Initial"] = this.p_BledFully_Initial !== undefined ? this.p_BledFully_Initial : <any>null;
        data["p_BledFully_Final"] = this.p_BledFully_Final !== undefined ? this.p_BledFully_Final : <any>null;
        data["isBledFully"] = this.isBledFully !== undefined ? this.isBledFully : <any>null;
        data["bledDate"] = this.bledDate ? this.bledDate.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IRecordOperatorDTO {
    id: number;
    referTo: FieldArea;
    operatorOnlyStartTime: Date;
    operatorOnlyEndTime?: Date | null;
    startTime: Date;
    endTime: Date;
    operatorInput: boolean;
    findAutoInputs: boolean;
    facility: string;
    gas?: string | null;
    purpose?: string | null;
    type: FieldRecordManualType;
    isConfirmed: boolean;
    reason: string;
    category: string;
    location: string;
    usedNitrogen: boolean;
    p_Nitrogen_Initial: number;
    p_Nitrogen_Final: number;
    p_Initial: number;
    p_Final: number;
    p_BledFully_Initial: number;
    p_BledFully_Final: number;
    isBledFully: boolean;
    bledDate: Date;
    comment?: string | null;
    createdBy?: string | null;
    user?: string | null;
    properties: { [key: string]: any; };
}

export class RecordBledFullyDTO implements IRecordBledFullyDTO {
    blowdownRecordId!: number;
    startTime!: Date;
    comment!: string;
    p_BledFully_Initial!: number;
    p_BledFully_Final!: number;

    constructor(data?: IRecordBledFullyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blowdownRecordId = _data["blowdownRecordId"] !== undefined ? _data["blowdownRecordId"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.p_BledFully_Initial = _data["p_BledFully_Initial"] !== undefined ? _data["p_BledFully_Initial"] : <any>null;
            this.p_BledFully_Final = _data["p_BledFully_Final"] !== undefined ? _data["p_BledFully_Final"] : <any>null;
        }
    }

    static fromJS(data: any): RecordBledFullyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordBledFullyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blowdownRecordId"] = this.blowdownRecordId !== undefined ? this.blowdownRecordId : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["p_BledFully_Initial"] = this.p_BledFully_Initial !== undefined ? this.p_BledFully_Initial : <any>null;
        data["p_BledFully_Final"] = this.p_BledFully_Final !== undefined ? this.p_BledFully_Final : <any>null;
        return data;
    }
}

export interface IRecordBledFullyDTO {
    blowdownRecordId: number;
    startTime: Date;
    comment: string;
    p_BledFully_Initial: number;
    p_BledFully_Final: number;
}

export class OperatorRecordDTO implements IOperatorRecordDTO {
    id!: number;
    startTime!: Date;
    reason?: string | null;
    lineVolume!: number;
    location?: string | null;
    properties!: { [key: string]: any; };

    constructor(data?: IOperatorRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.lineVolume = _data["lineVolume"] !== undefined ? _data["lineVolume"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): OperatorRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["lineVolume"] = this.lineVolume !== undefined ? this.lineVolume : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IOperatorRecordDTO {
    id: number;
    startTime: Date;
    reason?: string | null;
    lineVolume: number;
    location?: string | null;
    properties: { [key: string]: any; };
}

export class FieldPermitTargetInputDTO implements IFieldPermitTargetInputDTO {
    id!: number;
    startTime!: Date;
    endTime!: Date;
    inputType!: PermitTargetInputType;
    gasType?: GasType | null;
    volume!: number;
    areaType!: AreaType;
    msInput?: MSInputDTO | null;
    mrmInput?: MRMInputDTO | null;
    properties!: { [key: string]: any; };

    constructor(data?: IFieldPermitTargetInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.areaType = _data["areaType"] !== undefined ? _data["areaType"] : <any>null;
            this.msInput = _data["msInput"] ? MSInputDTO.fromJS(_data["msInput"]) : <any>null;
            this.mrmInput = _data["mrmInput"] ? MRMInputDTO.fromJS(_data["mrmInput"]) : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): FieldPermitTargetInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FieldPermitTargetInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["areaType"] = this.areaType !== undefined ? this.areaType : <any>null;
        data["msInput"] = this.msInput ? this.msInput.toJSON() : <any>null;
        data["mrmInput"] = this.mrmInput ? this.mrmInput.toJSON() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IFieldPermitTargetInputDTO {
    id: number;
    startTime: Date;
    endTime: Date;
    inputType: PermitTargetInputType;
    gasType?: GasType | null;
    volume: number;
    areaType: AreaType;
    msInput?: MSInputDTO | null;
    mrmInput?: MRMInputDTO | null;
    properties: { [key: string]: any; };
}

export enum PermitTargetInputType {
    Permit = 0,
    Target = 1,
}

export enum GasType {
    Dry = 0,
    Reservoir = 1,
}

export enum AreaType {
    Field = 0,
    MRM = 1,
}

export class MSInputDTO implements IMSInputDTO {
    mS15!: number;
    mS09!: number;
    mS14!: number;
    mS19!: number;
    mS08!: number;
    mS12!: number;
    mS05!: number;
    mS20!: number;
    mS17!: number;
    cfm!: number;
    mS21!: number;
    mS24!: number;
    mS26!: number;
    mS31!: number;
    mS33!: number;
    mS35!: number;
    mS52!: number;
    mS53!: number;
    mS54!: number;
    mS55!: number;
    kms!: number;

    constructor(data?: IMSInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mS15 = _data["mS15"] !== undefined ? _data["mS15"] : <any>null;
            this.mS09 = _data["mS09"] !== undefined ? _data["mS09"] : <any>null;
            this.mS14 = _data["mS14"] !== undefined ? _data["mS14"] : <any>null;
            this.mS19 = _data["mS19"] !== undefined ? _data["mS19"] : <any>null;
            this.mS08 = _data["mS08"] !== undefined ? _data["mS08"] : <any>null;
            this.mS12 = _data["mS12"] !== undefined ? _data["mS12"] : <any>null;
            this.mS05 = _data["mS05"] !== undefined ? _data["mS05"] : <any>null;
            this.mS20 = _data["mS20"] !== undefined ? _data["mS20"] : <any>null;
            this.mS17 = _data["mS17"] !== undefined ? _data["mS17"] : <any>null;
            this.cfm = _data["cfm"] !== undefined ? _data["cfm"] : <any>null;
            this.mS21 = _data["mS21"] !== undefined ? _data["mS21"] : <any>null;
            this.mS24 = _data["mS24"] !== undefined ? _data["mS24"] : <any>null;
            this.mS26 = _data["mS26"] !== undefined ? _data["mS26"] : <any>null;
            this.mS31 = _data["mS31"] !== undefined ? _data["mS31"] : <any>null;
            this.mS33 = _data["mS33"] !== undefined ? _data["mS33"] : <any>null;
            this.mS35 = _data["mS35"] !== undefined ? _data["mS35"] : <any>null;
            this.mS52 = _data["mS52"] !== undefined ? _data["mS52"] : <any>null;
            this.mS53 = _data["mS53"] !== undefined ? _data["mS53"] : <any>null;
            this.mS54 = _data["mS54"] !== undefined ? _data["mS54"] : <any>null;
            this.mS55 = _data["mS55"] !== undefined ? _data["mS55"] : <any>null;
            this.kms = _data["kms"] !== undefined ? _data["kms"] : <any>null;
        }
    }

    static fromJS(data: any): MSInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MSInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mS15"] = this.mS15 !== undefined ? this.mS15 : <any>null;
        data["mS09"] = this.mS09 !== undefined ? this.mS09 : <any>null;
        data["mS14"] = this.mS14 !== undefined ? this.mS14 : <any>null;
        data["mS19"] = this.mS19 !== undefined ? this.mS19 : <any>null;
        data["mS08"] = this.mS08 !== undefined ? this.mS08 : <any>null;
        data["mS12"] = this.mS12 !== undefined ? this.mS12 : <any>null;
        data["mS05"] = this.mS05 !== undefined ? this.mS05 : <any>null;
        data["mS20"] = this.mS20 !== undefined ? this.mS20 : <any>null;
        data["mS17"] = this.mS17 !== undefined ? this.mS17 : <any>null;
        data["cfm"] = this.cfm !== undefined ? this.cfm : <any>null;
        data["mS21"] = this.mS21 !== undefined ? this.mS21 : <any>null;
        data["mS24"] = this.mS24 !== undefined ? this.mS24 : <any>null;
        data["mS26"] = this.mS26 !== undefined ? this.mS26 : <any>null;
        data["mS31"] = this.mS31 !== undefined ? this.mS31 : <any>null;
        data["mS33"] = this.mS33 !== undefined ? this.mS33 : <any>null;
        data["mS35"] = this.mS35 !== undefined ? this.mS35 : <any>null;
        data["mS52"] = this.mS52 !== undefined ? this.mS52 : <any>null;
        data["mS53"] = this.mS53 !== undefined ? this.mS53 : <any>null;
        data["mS54"] = this.mS54 !== undefined ? this.mS54 : <any>null;
        data["mS55"] = this.mS55 !== undefined ? this.mS55 : <any>null;
        data["kms"] = this.kms !== undefined ? this.kms : <any>null;
        return data;
    }
}

export interface IMSInputDTO {
    mS15: number;
    mS09: number;
    mS14: number;
    mS19: number;
    mS08: number;
    mS12: number;
    mS05: number;
    mS20: number;
    mS17: number;
    cfm: number;
    mS21: number;
    mS24: number;
    mS26: number;
    mS31: number;
    mS33: number;
    mS35: number;
    mS52: number;
    mS53: number;
    mS54: number;
    mS55: number;
    kms: number;
}

export class MRMInputDTO implements IMRMInputDTO {
    hpFlare!: number;
    lpFlare!: number;
    evergreenBurner!: number;
    hpFlareBackUp!: number;
    lpFlareBackUp!: number;
    evergreenBurnerBackUp!: number;
    safetyFlare!: number;

    constructor(data?: IMRMInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hpFlare = _data["hpFlare"] !== undefined ? _data["hpFlare"] : <any>null;
            this.lpFlare = _data["lpFlare"] !== undefined ? _data["lpFlare"] : <any>null;
            this.evergreenBurner = _data["evergreenBurner"] !== undefined ? _data["evergreenBurner"] : <any>null;
            this.hpFlareBackUp = _data["hpFlareBackUp"] !== undefined ? _data["hpFlareBackUp"] : <any>null;
            this.lpFlareBackUp = _data["lpFlareBackUp"] !== undefined ? _data["lpFlareBackUp"] : <any>null;
            this.evergreenBurnerBackUp = _data["evergreenBurnerBackUp"] !== undefined ? _data["evergreenBurnerBackUp"] : <any>null;
            this.safetyFlare = _data["safetyFlare"] !== undefined ? _data["safetyFlare"] : <any>null;
        }
    }

    static fromJS(data: any): MRMInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MRMInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hpFlare"] = this.hpFlare !== undefined ? this.hpFlare : <any>null;
        data["lpFlare"] = this.lpFlare !== undefined ? this.lpFlare : <any>null;
        data["evergreenBurner"] = this.evergreenBurner !== undefined ? this.evergreenBurner : <any>null;
        data["hpFlareBackUp"] = this.hpFlareBackUp !== undefined ? this.hpFlareBackUp : <any>null;
        data["lpFlareBackUp"] = this.lpFlareBackUp !== undefined ? this.lpFlareBackUp : <any>null;
        data["evergreenBurnerBackUp"] = this.evergreenBurnerBackUp !== undefined ? this.evergreenBurnerBackUp : <any>null;
        data["safetyFlare"] = this.safetyFlare !== undefined ? this.safetyFlare : <any>null;
        return data;
    }
}

export interface IMRMInputDTO {
    hpFlare: number;
    lpFlare: number;
    evergreenBurner: number;
    hpFlareBackUp: number;
    lpFlareBackUp: number;
    evergreenBurnerBackUp: number;
    safetyFlare: number;
}

export class PermitTargetInputEditDTO implements IPermitTargetInputEditDTO {
    id!: number;
    volume!: number;

    constructor(data?: IPermitTargetInputEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
        }
    }

    static fromJS(data: any): PermitTargetInputEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermitTargetInputEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        return data;
    }
}

export interface IPermitTargetInputEditDTO {
    id: number;
    volume: number;
}

export class PerformanceMetricsPermitTargetInputDTO implements IPerformanceMetricsPermitTargetInputDTO {
    id!: number;
    startTime!: Date;
    inputType!: PermitTargetInputType;
    areaType!: AreaType;
    performanceMetricsMonths!: PerformanceMetricsMonthsInputDTO;
    properties!: { [key: string]: any; };

    constructor(data?: IPerformanceMetricsPermitTargetInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.performanceMetricsMonths = new PerformanceMetricsMonthsInputDTO();
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.areaType = _data["areaType"] !== undefined ? _data["areaType"] : <any>null;
            this.performanceMetricsMonths = _data["performanceMetricsMonths"] ? PerformanceMetricsMonthsInputDTO.fromJS(_data["performanceMetricsMonths"]) : new PerformanceMetricsMonthsInputDTO();
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): PerformanceMetricsPermitTargetInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceMetricsPermitTargetInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["areaType"] = this.areaType !== undefined ? this.areaType : <any>null;
        data["performanceMetricsMonths"] = this.performanceMetricsMonths ? this.performanceMetricsMonths.toJSON() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IPerformanceMetricsPermitTargetInputDTO {
    id: number;
    startTime: Date;
    inputType: PermitTargetInputType;
    areaType: AreaType;
    performanceMetricsMonths: PerformanceMetricsMonthsInputDTO;
    properties: { [key: string]: any; };
}

export class PerformanceMetricsMonthsInputDTO implements IPerformanceMetricsMonthsInputDTO {
    id!: number;
    jan!: number;
    feb!: number;
    mar!: number;
    apr!: number;
    may!: number;
    jun!: number;
    jul!: number;
    aug!: number;
    sep!: number;
    oct!: number;
    nov!: number;
    dec!: number;

    constructor(data?: IPerformanceMetricsMonthsInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.jan = _data["jan"] !== undefined ? _data["jan"] : <any>null;
            this.feb = _data["feb"] !== undefined ? _data["feb"] : <any>null;
            this.mar = _data["mar"] !== undefined ? _data["mar"] : <any>null;
            this.apr = _data["apr"] !== undefined ? _data["apr"] : <any>null;
            this.may = _data["may"] !== undefined ? _data["may"] : <any>null;
            this.jun = _data["jun"] !== undefined ? _data["jun"] : <any>null;
            this.jul = _data["jul"] !== undefined ? _data["jul"] : <any>null;
            this.aug = _data["aug"] !== undefined ? _data["aug"] : <any>null;
            this.sep = _data["sep"] !== undefined ? _data["sep"] : <any>null;
            this.oct = _data["oct"] !== undefined ? _data["oct"] : <any>null;
            this.nov = _data["nov"] !== undefined ? _data["nov"] : <any>null;
            this.dec = _data["dec"] !== undefined ? _data["dec"] : <any>null;
        }
    }

    static fromJS(data: any): PerformanceMetricsMonthsInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceMetricsMonthsInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["jan"] = this.jan !== undefined ? this.jan : <any>null;
        data["feb"] = this.feb !== undefined ? this.feb : <any>null;
        data["mar"] = this.mar !== undefined ? this.mar : <any>null;
        data["apr"] = this.apr !== undefined ? this.apr : <any>null;
        data["may"] = this.may !== undefined ? this.may : <any>null;
        data["jun"] = this.jun !== undefined ? this.jun : <any>null;
        data["jul"] = this.jul !== undefined ? this.jul : <any>null;
        data["aug"] = this.aug !== undefined ? this.aug : <any>null;
        data["sep"] = this.sep !== undefined ? this.sep : <any>null;
        data["oct"] = this.oct !== undefined ? this.oct : <any>null;
        data["nov"] = this.nov !== undefined ? this.nov : <any>null;
        data["dec"] = this.dec !== undefined ? this.dec : <any>null;
        return data;
    }
}

export interface IPerformanceMetricsMonthsInputDTO {
    id: number;
    jan: number;
    feb: number;
    mar: number;
    apr: number;
    may: number;
    jun: number;
    jul: number;
    aug: number;
    sep: number;
    oct: number;
    nov: number;
    dec: number;
}

export class FacilityLocationListDTO implements IFacilityLocationListDTO {
    area!: FieldArea;
    msList!: MSDTO[];

    constructor(data?: IFacilityLocationListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.msList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            if (Array.isArray(_data["msList"])) {
                this.msList = [] as any;
                for (let item of _data["msList"])
                    this.msList!.push(MSDTO.fromJS(item));
            }
            else {
                this.msList = <any>null;
            }
        }
    }

    static fromJS(data: any): FacilityLocationListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityLocationListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area !== undefined ? this.area : <any>null;
        if (Array.isArray(this.msList)) {
            data["msList"] = [];
            for (let item of this.msList)
                data["msList"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFacilityLocationListDTO {
    area: FieldArea;
    msList: MSDTO[];
}

export class MSDTO implements IMSDTO {
    name!: string;
    locations!: LocationDTO[];

    constructor(data?: IMSDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationDTO.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
        }
    }

    static fromJS(data: any): MSDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MSDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMSDTO {
    name: string;
    locations: LocationDTO[];
}

export class LocationDTO implements ILocationDTO {
    name!: string;

    constructor(data?: ILocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): LocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ILocationDTO {
    name: string;
}

export class _3GIFDGetDailyReportDTO implements I_3GIFDGetDailyReportDTO {
    dailyCalculatedStreams!: DailyCalculatedStreamDTO[];
    totalVolume!: number;
    totalMass!: number;

    constructor(data?: I_3GIFDGetDailyReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dailyCalculatedStreams = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailyCalculatedStreams"])) {
                this.dailyCalculatedStreams = [] as any;
                for (let item of _data["dailyCalculatedStreams"])
                    this.dailyCalculatedStreams!.push(DailyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.dailyCalculatedStreams = <any>null;
            }
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
        }
    }

    static fromJS(data: any): _3GIFDGetDailyReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GIFDGetDailyReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailyCalculatedStreams)) {
            data["dailyCalculatedStreams"] = [];
            for (let item of this.dailyCalculatedStreams)
                data["dailyCalculatedStreams"].push(item ? item.toJSON() : <any>null);
        }
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        return data;
    }
}

export interface I_3GIFDGetDailyReportDTO {
    dailyCalculatedStreams: DailyCalculatedStreamDTO[];
    totalVolume: number;
    totalMass: number;
}

export class DailyCalculatedStreamDTO implements IDailyCalculatedStreamDTO {
    streamId!: number;
    streamName!: string;
    calculateStreamId!: number;
    timeStamp!: Date;
    starTime!: Date;
    endTime!: Date;
    totalVolume?: number | null;
    totalMass?: number | null;
    runTime?: number | null;
    childStreams?: DailyCalculatedStreamDTO[] | null;

    constructor(data?: IDailyCalculatedStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.calculateStreamId = _data["calculateStreamId"] !== undefined ? _data["calculateStreamId"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.starTime = _data["starTime"] ? new Date(_data["starTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.runTime = _data["runTime"] !== undefined ? _data["runTime"] : <any>null;
            if (Array.isArray(_data["childStreams"])) {
                this.childStreams = [] as any;
                for (let item of _data["childStreams"])
                    this.childStreams!.push(DailyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.childStreams = <any>null;
            }
        }
    }

    static fromJS(data: any): DailyCalculatedStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyCalculatedStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["calculateStreamId"] = this.calculateStreamId !== undefined ? this.calculateStreamId : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["starTime"] = this.starTime ? this.starTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["runTime"] = this.runTime !== undefined ? this.runTime : <any>null;
        if (Array.isArray(this.childStreams)) {
            data["childStreams"] = [];
            for (let item of this.childStreams)
                data["childStreams"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IDailyCalculatedStreamDTO {
    streamId: number;
    streamName: string;
    calculateStreamId: number;
    timeStamp: Date;
    starTime: Date;
    endTime: Date;
    totalVolume?: number | null;
    totalMass?: number | null;
    runTime?: number | null;
    childStreams?: DailyCalculatedStreamDTO[] | null;
}

export class _3GPChemicalCompoundsDTO implements I_3GPChemicalCompoundsDTO {
    id!: number;
    afTableId!: number;
    gasType!: string;
    c1!: number;
    c2!: number;
    c3!: number;
    cO2!: number;
    cos!: number;
    h2O!: number;
    h2S!: number;
    iC4!: number;
    iC5!: number;
    n2!: number;
    nC4!: number;
    nC5!: number;
    o2!: number;
    c6!: number;
    cH3SH!: number;
    c2H5SH!: number;
    c3H7SH!: number;
    nC3H7SH!: number;
    nC4H9SH!: number;
    ammonia!: number;
    aceticAcid!: number;

    constructor(data?: I_3GPChemicalCompoundsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.afTableId = _data["afTableId"] !== undefined ? _data["afTableId"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.c6 = _data["c6"] !== undefined ? _data["c6"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c3H7SH = _data["c3H7SH"] !== undefined ? _data["c3H7SH"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4H9SH = _data["nC4H9SH"] !== undefined ? _data["nC4H9SH"] : <any>null;
            this.ammonia = _data["ammonia"] !== undefined ? _data["ammonia"] : <any>null;
            this.aceticAcid = _data["aceticAcid"] !== undefined ? _data["aceticAcid"] : <any>null;
        }
    }

    static fromJS(data: any): _3GPChemicalCompoundsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPChemicalCompoundsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["afTableId"] = this.afTableId !== undefined ? this.afTableId : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["c6"] = this.c6 !== undefined ? this.c6 : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c3H7SH"] = this.c3H7SH !== undefined ? this.c3H7SH : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4H9SH"] = this.nC4H9SH !== undefined ? this.nC4H9SH : <any>null;
        data["ammonia"] = this.ammonia !== undefined ? this.ammonia : <any>null;
        data["aceticAcid"] = this.aceticAcid !== undefined ? this.aceticAcid : <any>null;
        return data;
    }
}

export interface I_3GPChemicalCompoundsDTO {
    id: number;
    afTableId: number;
    gasType: string;
    c1: number;
    c2: number;
    c3: number;
    cO2: number;
    cos: number;
    h2O: number;
    h2S: number;
    iC4: number;
    iC5: number;
    n2: number;
    nC4: number;
    nC5: number;
    o2: number;
    c6: number;
    cH3SH: number;
    c2H5SH: number;
    c3H7SH: number;
    nC3H7SH: number;
    nC4H9SH: number;
    ammonia: number;
    aceticAcid: number;
}

export class _3GPFDGetDailyReportDTO implements I_3GPFDGetDailyReportDTO {
    gasType!: _3GPFDStreamGasType;
    dailyCalculatedStreams!: _3GPFDDailyCalculatedStreamDTO[];
    totalVolume!: number;
    totalMass!: number;

    constructor(data?: I_3GPFDGetDailyReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dailyCalculatedStreams = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            if (Array.isArray(_data["dailyCalculatedStreams"])) {
                this.dailyCalculatedStreams = [] as any;
                for (let item of _data["dailyCalculatedStreams"])
                    this.dailyCalculatedStreams!.push(_3GPFDDailyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.dailyCalculatedStreams = <any>null;
            }
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
        }
    }

    static fromJS(data: any): _3GPFDGetDailyReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPFDGetDailyReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        if (Array.isArray(this.dailyCalculatedStreams)) {
            data["dailyCalculatedStreams"] = [];
            for (let item of this.dailyCalculatedStreams)
                data["dailyCalculatedStreams"].push(item ? item.toJSON() : <any>null);
        }
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        return data;
    }
}

export interface I_3GPFDGetDailyReportDTO {
    gasType: _3GPFDStreamGasType;
    dailyCalculatedStreams: _3GPFDDailyCalculatedStreamDTO[];
    totalVolume: number;
    totalMass: number;
}

export enum _3GPFDStreamGasType {
    Fuel = 0,
    Propane = 1,
    Sour = 2,
    Acid = 3,
}

export class _3GPFDDailyCalculatedStreamDTO implements I_3GPFDDailyCalculatedStreamDTO {
    streamId!: number;
    streamName!: string;
    calculateStreamId!: number;
    timeStamp!: Date;
    starTime!: Date;
    endTime!: Date;
    totalVolume?: number | null;
    totalMass?: number | null;
    runTime?: number | null;
    flareType!: _3GPFDFlareType;
    childStreams?: _3GPFDDailyCalculatedStreamDTO[] | null;

    constructor(data?: I_3GPFDDailyCalculatedStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.calculateStreamId = _data["calculateStreamId"] !== undefined ? _data["calculateStreamId"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.starTime = _data["starTime"] ? new Date(_data["starTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.runTime = _data["runTime"] !== undefined ? _data["runTime"] : <any>null;
            this.flareType = _data["flareType"] !== undefined ? _data["flareType"] : <any>null;
            if (Array.isArray(_data["childStreams"])) {
                this.childStreams = [] as any;
                for (let item of _data["childStreams"])
                    this.childStreams!.push(_3GPFDDailyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.childStreams = <any>null;
            }
        }
    }

    static fromJS(data: any): _3GPFDDailyCalculatedStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPFDDailyCalculatedStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["calculateStreamId"] = this.calculateStreamId !== undefined ? this.calculateStreamId : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["starTime"] = this.starTime ? this.starTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["runTime"] = this.runTime !== undefined ? this.runTime : <any>null;
        data["flareType"] = this.flareType !== undefined ? this.flareType : <any>null;
        if (Array.isArray(this.childStreams)) {
            data["childStreams"] = [];
            for (let item of this.childStreams)
                data["childStreams"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface I_3GPFDDailyCalculatedStreamDTO {
    streamId: number;
    streamName: string;
    calculateStreamId: number;
    timeStamp: Date;
    starTime: Date;
    endTime: Date;
    totalVolume?: number | null;
    totalMass?: number | null;
    runTime?: number | null;
    flareType: _3GPFDFlareType;
    childStreams?: _3GPFDDailyCalculatedStreamDTO[] | null;
}

export enum _3GPFDFlareType {
    X1001_1A = 0,
    X1001_1B = 1,
    X1001_2A = 2,
    X1001_2B = 3,
    X1002_1 = 4,
    X1002_2 = 5,
    X201 = 6,
}

export class GetMonthlyReportDTO implements IGetMonthlyReportDTO {
    groupedMonthlyCalculatedStreams!: GroupedMonthlyCalculatedStreamDTO[];
    totalVolume!: number;
    totalMass!: number;

    constructor(data?: IGetMonthlyReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groupedMonthlyCalculatedStreams = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groupedMonthlyCalculatedStreams"])) {
                this.groupedMonthlyCalculatedStreams = [] as any;
                for (let item of _data["groupedMonthlyCalculatedStreams"])
                    this.groupedMonthlyCalculatedStreams!.push(GroupedMonthlyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.groupedMonthlyCalculatedStreams = <any>null;
            }
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
        }
    }

    static fromJS(data: any): GetMonthlyReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlyReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groupedMonthlyCalculatedStreams)) {
            data["groupedMonthlyCalculatedStreams"] = [];
            for (let item of this.groupedMonthlyCalculatedStreams)
                data["groupedMonthlyCalculatedStreams"].push(item ? item.toJSON() : <any>null);
        }
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        return data;
    }
}

export interface IGetMonthlyReportDTO {
    groupedMonthlyCalculatedStreams: GroupedMonthlyCalculatedStreamDTO[];
    totalVolume: number;
    totalMass: number;
}

export class GroupedMonthlyCalculatedStreamDTO implements IGroupedMonthlyCalculatedStreamDTO {
    gasType!: _3GPFDStreamGasType;
    monthlyCalculatedStreams!: MonthlyCalculatedStreamDTO[];

    constructor(data?: IGroupedMonthlyCalculatedStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.monthlyCalculatedStreams = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            if (Array.isArray(_data["monthlyCalculatedStreams"])) {
                this.monthlyCalculatedStreams = [] as any;
                for (let item of _data["monthlyCalculatedStreams"])
                    this.monthlyCalculatedStreams!.push(MonthlyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.monthlyCalculatedStreams = <any>null;
            }
        }
    }

    static fromJS(data: any): GroupedMonthlyCalculatedStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedMonthlyCalculatedStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        if (Array.isArray(this.monthlyCalculatedStreams)) {
            data["monthlyCalculatedStreams"] = [];
            for (let item of this.monthlyCalculatedStreams)
                data["monthlyCalculatedStreams"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IGroupedMonthlyCalculatedStreamDTO {
    gasType: _3GPFDStreamGasType;
    monthlyCalculatedStreams: MonthlyCalculatedStreamDTO[];
}

export class MonthlyCalculatedStreamDTO implements IMonthlyCalculatedStreamDTO {
    streamId!: number;
    streamName!: string;
    totalVolume?: number | null;
    totalMass?: number | null;
    flareType!: _3GPFDFlareType;
    childStreams?: MonthlyCalculatedStreamDTO[] | null;

    constructor(data?: IMonthlyCalculatedStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.flareType = _data["flareType"] !== undefined ? _data["flareType"] : <any>null;
            if (Array.isArray(_data["childStreams"])) {
                this.childStreams = [] as any;
                for (let item of _data["childStreams"])
                    this.childStreams!.push(MonthlyCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.childStreams = <any>null;
            }
        }
    }

    static fromJS(data: any): MonthlyCalculatedStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyCalculatedStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["flareType"] = this.flareType !== undefined ? this.flareType : <any>null;
        if (Array.isArray(this.childStreams)) {
            data["childStreams"] = [];
            for (let item of this.childStreams)
                data["childStreams"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMonthlyCalculatedStreamDTO {
    streamId: number;
    streamName: string;
    totalVolume?: number | null;
    totalMass?: number | null;
    flareType: _3GPFDFlareType;
    childStreams?: MonthlyCalculatedStreamDTO[] | null;
}

export class GetDailyTotalTableDTO implements IGetDailyTotalTableDTO {
    flareType!: _3GPFDFlareType;
    gasBalanceVolume!: number;
    flareFlowmeterVolume!: number;
    differenceVolume!: number;
    relativeErrorPercent!: number;

    constructor(data?: IGetDailyTotalTableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flareType = _data["flareType"] !== undefined ? _data["flareType"] : <any>null;
            this.gasBalanceVolume = _data["gasBalanceVolume"] !== undefined ? _data["gasBalanceVolume"] : <any>null;
            this.flareFlowmeterVolume = _data["flareFlowmeterVolume"] !== undefined ? _data["flareFlowmeterVolume"] : <any>null;
            this.differenceVolume = _data["differenceVolume"] !== undefined ? _data["differenceVolume"] : <any>null;
            this.relativeErrorPercent = _data["relativeErrorPercent"] !== undefined ? _data["relativeErrorPercent"] : <any>null;
        }
    }

    static fromJS(data: any): GetDailyTotalTableDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyTotalTableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flareType"] = this.flareType !== undefined ? this.flareType : <any>null;
        data["gasBalanceVolume"] = this.gasBalanceVolume !== undefined ? this.gasBalanceVolume : <any>null;
        data["flareFlowmeterVolume"] = this.flareFlowmeterVolume !== undefined ? this.flareFlowmeterVolume : <any>null;
        data["differenceVolume"] = this.differenceVolume !== undefined ? this.differenceVolume : <any>null;
        data["relativeErrorPercent"] = this.relativeErrorPercent !== undefined ? this.relativeErrorPercent : <any>null;
        return data;
    }
}

export interface IGetDailyTotalTableDTO {
    flareType: _3GPFDFlareType;
    gasBalanceVolume: number;
    flareFlowmeterVolume: number;
    differenceVolume: number;
    relativeErrorPercent: number;
}

export class _3GPFDStreamDTO implements I_3GPFDStreamDTO {
    streamId!: number;
    streamName!: string;
    gasType!: _3GPFDStreamGasType;
    flareType!: _3GPFDFlareType;
    ccId?: number | null;
    recordType!: _3GPFDStreamRecordType;
    isVolumeFirst!: boolean;
    isSwitchable!: boolean;
    defaultMW!: number;

    constructor(data?: I_3GPFDStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.flareType = _data["flareType"] !== undefined ? _data["flareType"] : <any>null;
            this.ccId = _data["ccId"] !== undefined ? _data["ccId"] : <any>null;
            this.recordType = _data["recordType"] !== undefined ? _data["recordType"] : <any>null;
            this.isVolumeFirst = _data["isVolumeFirst"] !== undefined ? _data["isVolumeFirst"] : <any>null;
            this.isSwitchable = _data["isSwitchable"] !== undefined ? _data["isSwitchable"] : <any>null;
            this.defaultMW = _data["defaultMW"] !== undefined ? _data["defaultMW"] : <any>null;
        }
    }

    static fromJS(data: any): _3GPFDStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPFDStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["flareType"] = this.flareType !== undefined ? this.flareType : <any>null;
        data["ccId"] = this.ccId !== undefined ? this.ccId : <any>null;
        data["recordType"] = this.recordType !== undefined ? this.recordType : <any>null;
        data["isVolumeFirst"] = this.isVolumeFirst !== undefined ? this.isVolumeFirst : <any>null;
        data["isSwitchable"] = this.isSwitchable !== undefined ? this.isSwitchable : <any>null;
        data["defaultMW"] = this.defaultMW !== undefined ? this.defaultMW : <any>null;
        return data;
    }
}

export interface I_3GPFDStreamDTO {
    streamId: number;
    streamName: string;
    gasType: _3GPFDStreamGasType;
    flareType: _3GPFDFlareType;
    ccId?: number | null;
    recordType: _3GPFDStreamRecordType;
    isVolumeFirst: boolean;
    isSwitchable: boolean;
    defaultMW: number;
}

export enum _3GPFDStreamRecordType {
    Flaring = 0,
    Leakage = 1,
    Constant = 2,
    Usage = 3,
    ManualFlaring = 4,
}

export enum _3GPFDScreenType {
    Flaring = 0,
    Leakage = 1,
    Constants = 2,
    Permits = 3,
    FlareSwitcher = 4,
}

export class PagedListOfGetInputHistoryDTO implements IPagedListOfGetInputHistoryDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: GetInputHistoryDTO[];

    constructor(data?: IPagedListOfGetInputHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetInputHistoryDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfGetInputHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetInputHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfGetInputHistoryDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: GetInputHistoryDTO[];
}

export class GetInputHistoryDTO implements IGetInputHistoryDTO {
    id!: number;
    inputRecordType!: InputRecordType;
    isActive!: boolean;
    gasType!: _3GPFDStreamGasType;
    name!: string;
    startTime!: Date;
    endTime?: Date | null;
    value!: number;
    isVolume!: boolean;
    inputCategory?: string | null;
    inputComment?: string | null;
    inputReason?: string | null;
    user!: string;
    logged?: Date | null;
    mw!: number;
    c1!: number;
    c2!: number;
    c2H5SH!: number;
    c3!: number;
    c4H9SH!: number;
    c6Plus!: number;
    cH3SH!: number;
    cO2!: number;
    cos!: number;
    h2O!: number;
    h2S!: number;
    iC3H7SH!: number;
    iC4!: number;
    iC5!: number;
    n2!: number;
    nC3H7SH!: number;
    nC4!: number;
    nC5!: number;
    o2!: number;
    ammonia!: number;
    aceticAcid!: number;

    constructor(data?: IGetInputHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inputRecordType = _data["inputRecordType"] !== undefined ? _data["inputRecordType"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.isVolume = _data["isVolume"] !== undefined ? _data["isVolume"] : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.c4H9SH = _data["c4H9SH"] !== undefined ? _data["c4H9SH"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.iC3H7SH = _data["iC3H7SH"] !== undefined ? _data["iC3H7SH"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.ammonia = _data["ammonia"] !== undefined ? _data["ammonia"] : <any>null;
            this.aceticAcid = _data["aceticAcid"] !== undefined ? _data["aceticAcid"] : <any>null;
        }
    }

    static fromJS(data: any): GetInputHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetInputHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inputRecordType"] = this.inputRecordType !== undefined ? this.inputRecordType : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["isVolume"] = this.isVolume !== undefined ? this.isVolume : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["c4H9SH"] = this.c4H9SH !== undefined ? this.c4H9SH : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["iC3H7SH"] = this.iC3H7SH !== undefined ? this.iC3H7SH : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["ammonia"] = this.ammonia !== undefined ? this.ammonia : <any>null;
        data["aceticAcid"] = this.aceticAcid !== undefined ? this.aceticAcid : <any>null;
        return data;
    }
}

export interface IGetInputHistoryDTO {
    id: number;
    inputRecordType: InputRecordType;
    isActive: boolean;
    gasType: _3GPFDStreamGasType;
    name: string;
    startTime: Date;
    endTime?: Date | null;
    value: number;
    isVolume: boolean;
    inputCategory?: string | null;
    inputComment?: string | null;
    inputReason?: string | null;
    user: string;
    logged?: Date | null;
    mw: number;
    c1: number;
    c2: number;
    c2H5SH: number;
    c3: number;
    c4H9SH: number;
    c6Plus: number;
    cH3SH: number;
    cO2: number;
    cos: number;
    h2O: number;
    h2S: number;
    iC3H7SH: number;
    iC4: number;
    iC5: number;
    n2: number;
    nC3H7SH: number;
    nC4: number;
    nC5: number;
    o2: number;
    ammonia: number;
    aceticAcid: number;
}

export enum InputRecordType {
    Flaring = 0,
    Leakage = 1,
    Constant = 2,
    Bypass = 3,
    Switching = 4,
    Target = 5,
    Permit = 6,
}

export class EditInputDTO implements IEditInputDTO {
    id!: number;
    value!: number;
    inputCategory?: string | null;
    inputComment?: string | null;
    inputReason?: string | null;
    mw!: number;
    c1!: number;
    c2!: number;
    c2H5SH!: number;
    c3!: number;
    c4H9SH!: number;
    c6Plus!: number;
    cH3SH!: number;
    cO2!: number;
    cos!: number;
    h2O!: number;
    h2S!: number;
    iC3H7SH!: number;
    iC4!: number;
    iC5!: number;
    n2!: number;
    nC3H7SH!: number;
    nC4!: number;
    nC5!: number;
    o2!: number;
    ammonia!: number;
    aceticAcid!: number;

    constructor(data?: IEditInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.c4H9SH = _data["c4H9SH"] !== undefined ? _data["c4H9SH"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.iC3H7SH = _data["iC3H7SH"] !== undefined ? _data["iC3H7SH"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.ammonia = _data["ammonia"] !== undefined ? _data["ammonia"] : <any>null;
            this.aceticAcid = _data["aceticAcid"] !== undefined ? _data["aceticAcid"] : <any>null;
        }
    }

    static fromJS(data: any): EditInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["c4H9SH"] = this.c4H9SH !== undefined ? this.c4H9SH : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["iC3H7SH"] = this.iC3H7SH !== undefined ? this.iC3H7SH : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["ammonia"] = this.ammonia !== undefined ? this.ammonia : <any>null;
        data["aceticAcid"] = this.aceticAcid !== undefined ? this.aceticAcid : <any>null;
        return data;
    }
}

export interface IEditInputDTO {
    id: number;
    value: number;
    inputCategory?: string | null;
    inputComment?: string | null;
    inputReason?: string | null;
    mw: number;
    c1: number;
    c2: number;
    c2H5SH: number;
    c3: number;
    c4H9SH: number;
    c6Plus: number;
    cH3SH: number;
    cO2: number;
    cos: number;
    h2O: number;
    h2S: number;
    iC3H7SH: number;
    iC4: number;
    iC5: number;
    n2: number;
    nC3H7SH: number;
    nC4: number;
    nC5: number;
    o2: number;
    ammonia: number;
    aceticAcid: number;
}

export class _3GPFDStreamInputRecordDTO implements I_3GPFDStreamInputRecordDTO {
    startTime!: Date;
    endTime?: Date | null;
    inputCategory?: string | null;
    inputComment?: string | null;
    inputReason?: string | null;
    totalValue!: number;
    ccSourceType!: CCSourceType;
    isCalculated!: boolean;
    streamId!: number;
    mw!: number;
    c1!: number;
    c2!: number;
    c2H5SH!: number;
    c3!: number;
    c4H9SH!: number;
    c6Plus!: number;
    cH3SH!: number;
    cO2!: number;
    cos!: number;
    h2O!: number;
    h2S!: number;
    iC3H7SH!: number;
    iC4!: number;
    iC5!: number;
    n2!: number;
    nC3H7SH!: number;
    nC4!: number;
    nC5!: number;
    o2!: number;
    ammonia!: number;
    aceticAcid!: number;

    constructor(data?: I_3GPFDStreamInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.totalValue = _data["totalValue"] !== undefined ? _data["totalValue"] : <any>null;
            this.ccSourceType = _data["ccSourceType"] !== undefined ? _data["ccSourceType"] : <any>null;
            this.isCalculated = _data["isCalculated"] !== undefined ? _data["isCalculated"] : <any>null;
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.c4H9SH = _data["c4H9SH"] !== undefined ? _data["c4H9SH"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.iC3H7SH = _data["iC3H7SH"] !== undefined ? _data["iC3H7SH"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.ammonia = _data["ammonia"] !== undefined ? _data["ammonia"] : <any>null;
            this.aceticAcid = _data["aceticAcid"] !== undefined ? _data["aceticAcid"] : <any>null;
        }
    }

    static fromJS(data: any): _3GPFDStreamInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPFDStreamInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["totalValue"] = this.totalValue !== undefined ? this.totalValue : <any>null;
        data["ccSourceType"] = this.ccSourceType !== undefined ? this.ccSourceType : <any>null;
        data["isCalculated"] = this.isCalculated !== undefined ? this.isCalculated : <any>null;
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["c4H9SH"] = this.c4H9SH !== undefined ? this.c4H9SH : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["iC3H7SH"] = this.iC3H7SH !== undefined ? this.iC3H7SH : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["ammonia"] = this.ammonia !== undefined ? this.ammonia : <any>null;
        data["aceticAcid"] = this.aceticAcid !== undefined ? this.aceticAcid : <any>null;
        return data;
    }
}

export interface I_3GPFDStreamInputRecordDTO {
    startTime: Date;
    endTime?: Date | null;
    inputCategory?: string | null;
    inputComment?: string | null;
    inputReason?: string | null;
    totalValue: number;
    ccSourceType: CCSourceType;
    isCalculated: boolean;
    streamId: number;
    mw: number;
    c1: number;
    c2: number;
    c2H5SH: number;
    c3: number;
    c4H9SH: number;
    c6Plus: number;
    cH3SH: number;
    cO2: number;
    cos: number;
    h2O: number;
    h2S: number;
    iC3H7SH: number;
    iC4: number;
    iC5: number;
    n2: number;
    nC3H7SH: number;
    nC4: number;
    nC5: number;
    o2: number;
    ammonia: number;
    aceticAcid: number;
}

export enum CCSourceType {
    KTL1 = 0,
    KTL2 = 1,
    KTL3 = 2,
    KTLAvg = 3,
    SGP = 4,
    Propane = 5,
    Butane = 6,
    IdDefault = 7,
    LibraryOrManual = 8,
    EquipmentOrManual = 9,
    PrevInput = 10,
    LimsPlusMw = 11,
    Manual = 12,
}

export class _3GPFDPermitInputsDTO implements I_3GPFDPermitInputsDTO {
    year!: number;
    limit!: PermitTargetInputType;
    inputType!: _3GPFDPermitInputType;
    inputValue!: _3GPFDPermitTargetInputValue;
    totalVolume!: number;
    january!: number;
    february!: number;
    march!: number;
    april!: number;
    may!: number;
    june!: number;
    july!: number;
    august!: number;
    september!: number;
    october!: number;
    november!: number;
    december!: number;

    constructor(data?: I_3GPFDPermitInputsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.inputValue = _data["inputValue"] !== undefined ? _data["inputValue"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.january = _data["january"] !== undefined ? _data["january"] : <any>null;
            this.february = _data["february"] !== undefined ? _data["february"] : <any>null;
            this.march = _data["march"] !== undefined ? _data["march"] : <any>null;
            this.april = _data["april"] !== undefined ? _data["april"] : <any>null;
            this.may = _data["may"] !== undefined ? _data["may"] : <any>null;
            this.june = _data["june"] !== undefined ? _data["june"] : <any>null;
            this.july = _data["july"] !== undefined ? _data["july"] : <any>null;
            this.august = _data["august"] !== undefined ? _data["august"] : <any>null;
            this.september = _data["september"] !== undefined ? _data["september"] : <any>null;
            this.october = _data["october"] !== undefined ? _data["october"] : <any>null;
            this.november = _data["november"] !== undefined ? _data["november"] : <any>null;
            this.december = _data["december"] !== undefined ? _data["december"] : <any>null;
        }
    }

    static fromJS(data: any): _3GPFDPermitInputsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPFDPermitInputsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["inputValue"] = this.inputValue !== undefined ? this.inputValue : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["january"] = this.january !== undefined ? this.january : <any>null;
        data["february"] = this.february !== undefined ? this.february : <any>null;
        data["march"] = this.march !== undefined ? this.march : <any>null;
        data["april"] = this.april !== undefined ? this.april : <any>null;
        data["may"] = this.may !== undefined ? this.may : <any>null;
        data["june"] = this.june !== undefined ? this.june : <any>null;
        data["july"] = this.july !== undefined ? this.july : <any>null;
        data["august"] = this.august !== undefined ? this.august : <any>null;
        data["september"] = this.september !== undefined ? this.september : <any>null;
        data["october"] = this.october !== undefined ? this.october : <any>null;
        data["november"] = this.november !== undefined ? this.november : <any>null;
        data["december"] = this.december !== undefined ? this.december : <any>null;
        return data;
    }
}

export interface I_3GPFDPermitInputsDTO {
    year: number;
    limit: PermitTargetInputType;
    inputType: _3GPFDPermitInputType;
    inputValue: _3GPFDPermitTargetInputValue;
    totalVolume: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
}

export enum _3GPFDPermitInputType {
    Category = 0,
    Total = 1,
    Flares = 2,
    GasType = 3,
    PermitCategory = 4,
    FlaringTotal = 5,
}

export enum _3GPFDPermitTargetInputValue {
    X1001_1A = 0,
    X1001_1B = 1,
    X1001_2A = 2,
    X1001_2B = 3,
    X1002_1 = 4,
    X1002_2 = 5,
    X201 = 6,
    V6 = 7,
    V7 = 8,
    V8 = 9,
    V9 = 11,
    Propane = 12,
    Sour = 13,
    Fuel = 14,
    Acid = 15,
    FlaringTotal = 16,
}

export class PagedListOf_3GPFDFlareSwitcherInputDTO implements IPagedListOf_3GPFDFlareSwitcherInputDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: _3GPFDFlareSwitcherInputDTO[];

    constructor(data?: IPagedListOf_3GPFDFlareSwitcherInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(_3GPFDFlareSwitcherInputDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOf_3GPFDFlareSwitcherInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOf_3GPFDFlareSwitcherInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOf_3GPFDFlareSwitcherInputDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: _3GPFDFlareSwitcherInputDTO[];
}

export class _3GPFDFlareSwitcherInputDTO implements I_3GPFDFlareSwitcherInputDTO {
    startDate!: Date;
    switchType!: _3GPFDSwitchType;
    flare!: _3GPFDFlareType;
    createdBy?: string | null;

    constructor(data?: I_3GPFDFlareSwitcherInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.switchType = _data["switchType"] !== undefined ? _data["switchType"] : <any>null;
            this.flare = _data["flare"] !== undefined ? _data["flare"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
        }
    }

    static fromJS(data: any): _3GPFDFlareSwitcherInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPFDFlareSwitcherInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["switchType"] = this.switchType !== undefined ? this.switchType : <any>null;
        data["flare"] = this.flare !== undefined ? this.flare : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        return data;
    }
}

export interface I_3GPFDFlareSwitcherInputDTO {
    startDate: Date;
    switchType: _3GPFDSwitchType;
    flare: _3GPFDFlareType;
    createdBy?: string | null;
}

export enum _3GPFDSwitchType {
    _3GP_HP_Flare_Header = 0,
    _3GP_LP_Flare_Header = 1,
    PBF_Reception_Flare_Header_purge = 2,
    LP_FG_to_Spent_Air = 3,
    Fuel_Gas_Warmup_for_GTG_1_5 = 4,
}

export class _3GPGetFlareSwitcherByDayDTO implements I_3GPGetFlareSwitcherByDayDTO {
    timeStamp!: Date;
    flareSwitcherSets!: FlareSwitcherSet[];

    constructor(data?: I_3GPGetFlareSwitcherByDayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.flareSwitcherSets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            if (Array.isArray(_data["flareSwitcherSets"])) {
                this.flareSwitcherSets = [] as any;
                for (let item of _data["flareSwitcherSets"])
                    this.flareSwitcherSets!.push(FlareSwitcherSet.fromJS(item));
            }
            else {
                this.flareSwitcherSets = <any>null;
            }
        }
    }

    static fromJS(data: any): _3GPGetFlareSwitcherByDayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new _3GPGetFlareSwitcherByDayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        if (Array.isArray(this.flareSwitcherSets)) {
            data["flareSwitcherSets"] = [];
            for (let item of this.flareSwitcherSets)
                data["flareSwitcherSets"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface I_3GPGetFlareSwitcherByDayDTO {
    timeStamp: Date;
    flareSwitcherSets: FlareSwitcherSet[];
}

export class FlareSwitcherSet implements IFlareSwitcherSet {
    flareSwitcherSetType!: _3GPFDSwitchType;
    currentFlare!: _3GPFDFlareType;
    flareOptions!: _3GPFDFlareType[];
    switchableStreams!: SwitchableStream[];

    constructor(data?: IFlareSwitcherSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.flareOptions = [];
            this.switchableStreams = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flareSwitcherSetType = _data["flareSwitcherSetType"] !== undefined ? _data["flareSwitcherSetType"] : <any>null;
            this.currentFlare = _data["currentFlare"] !== undefined ? _data["currentFlare"] : <any>null;
            if (Array.isArray(_data["flareOptions"])) {
                this.flareOptions = [] as any;
                for (let item of _data["flareOptions"])
                    this.flareOptions!.push(item);
            }
            else {
                this.flareOptions = <any>null;
            }
            if (Array.isArray(_data["switchableStreams"])) {
                this.switchableStreams = [] as any;
                for (let item of _data["switchableStreams"])
                    this.switchableStreams!.push(SwitchableStream.fromJS(item));
            }
            else {
                this.switchableStreams = <any>null;
            }
        }
    }

    static fromJS(data: any): FlareSwitcherSet {
        data = typeof data === 'object' ? data : {};
        let result = new FlareSwitcherSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flareSwitcherSetType"] = this.flareSwitcherSetType !== undefined ? this.flareSwitcherSetType : <any>null;
        data["currentFlare"] = this.currentFlare !== undefined ? this.currentFlare : <any>null;
        if (Array.isArray(this.flareOptions)) {
            data["flareOptions"] = [];
            for (let item of this.flareOptions)
                data["flareOptions"].push(item);
        }
        if (Array.isArray(this.switchableStreams)) {
            data["switchableStreams"] = [];
            for (let item of this.switchableStreams)
                data["switchableStreams"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFlareSwitcherSet {
    flareSwitcherSetType: _3GPFDSwitchType;
    currentFlare: _3GPFDFlareType;
    flareOptions: _3GPFDFlareType[];
    switchableStreams: SwitchableStream[];
}

export class SwitchableStream implements ISwitchableStream {
    streamName!: string;
    gasType!: _3GPFDStreamGasType;

    constructor(data?: ISwitchableStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
        }
    }

    static fromJS(data: any): SwitchableStream {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchableStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        return data;
    }
}

export interface ISwitchableStream {
    streamName: string;
    gasType: _3GPFDStreamGasType;
}

export class Get3GPGURDTO implements IGet3GPGURDTO {
    streamId!: number;
    reportName!: string;
    totalMonthlyValue!: number;
    isRunTime!: boolean;
    isEditable!: boolean;
    dailyGURDTOs!: DailyGURDTO[];

    constructor(data?: IGet3GPGURDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dailyGURDTOs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : <any>null;
            this.totalMonthlyValue = _data["totalMonthlyValue"] !== undefined ? _data["totalMonthlyValue"] : <any>null;
            this.isRunTime = _data["isRunTime"] !== undefined ? _data["isRunTime"] : <any>null;
            this.isEditable = _data["isEditable"] !== undefined ? _data["isEditable"] : <any>null;
            if (Array.isArray(_data["dailyGURDTOs"])) {
                this.dailyGURDTOs = [] as any;
                for (let item of _data["dailyGURDTOs"])
                    this.dailyGURDTOs!.push(DailyGURDTO.fromJS(item));
            }
            else {
                this.dailyGURDTOs = <any>null;
            }
        }
    }

    static fromJS(data: any): Get3GPGURDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Get3GPGURDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["reportName"] = this.reportName !== undefined ? this.reportName : <any>null;
        data["totalMonthlyValue"] = this.totalMonthlyValue !== undefined ? this.totalMonthlyValue : <any>null;
        data["isRunTime"] = this.isRunTime !== undefined ? this.isRunTime : <any>null;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : <any>null;
        if (Array.isArray(this.dailyGURDTOs)) {
            data["dailyGURDTOs"] = [];
            for (let item of this.dailyGURDTOs)
                data["dailyGURDTOs"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IGet3GPGURDTO {
    streamId: number;
    reportName: string;
    totalMonthlyValue: number;
    isRunTime: boolean;
    isEditable: boolean;
    dailyGURDTOs: DailyGURDTO[];
}

export class DailyGURDTO implements IDailyGURDTO {
    id!: number;
    date!: Date;
    originalValue!: number;
    overridedValue?: number | null;
    isModified!: boolean;
    isIssued!: boolean;
    status!: StreamStatuses;

    constructor(data?: IDailyGURDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.originalValue = _data["originalValue"] !== undefined ? _data["originalValue"] : <any>null;
            this.overridedValue = _data["overridedValue"] !== undefined ? _data["overridedValue"] : <any>null;
            this.isModified = _data["isModified"] !== undefined ? _data["isModified"] : <any>null;
            this.isIssued = _data["isIssued"] !== undefined ? _data["isIssued"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): DailyGURDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyGURDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["originalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
        data["overridedValue"] = this.overridedValue !== undefined ? this.overridedValue : <any>null;
        data["isModified"] = this.isModified !== undefined ? this.isModified : <any>null;
        data["isIssued"] = this.isIssued !== undefined ? this.isIssued : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IDailyGURDTO {
    id: number;
    date: Date;
    originalValue: number;
    overridedValue?: number | null;
    isModified: boolean;
    isIssued: boolean;
    status: StreamStatuses;
}

export enum StreamStatuses {
    Normal = 0,
    Modified = 1,
    Issue = 2,
}

export class GetGURApproveDTO implements IGetGURApproveDTO {
    approver!: string;
    logged!: Date;

    constructor(data?: IGetGURApproveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approver = _data["approver"] !== undefined ? _data["approver"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetGURApproveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetGURApproveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approver"] = this.approver !== undefined ? this.approver : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        return data;
    }
}

export interface IGetGURApproveDTO {
    approver: string;
    logged: Date;
}

export class Override3GPGURDTO implements IOverride3GPGURDTO {
    totalMass?: number | null;
    totalVolume?: number | null;
    runTime?: number | null;
    calculatedStreamId!: number;

    constructor(data?: IOverride3GPGURDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.runTime = _data["runTime"] !== undefined ? _data["runTime"] : <any>null;
            this.calculatedStreamId = _data["calculatedStreamId"] !== undefined ? _data["calculatedStreamId"] : <any>null;
        }
    }

    static fromJS(data: any): Override3GPGURDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Override3GPGURDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["runTime"] = this.runTime !== undefined ? this.runTime : <any>null;
        data["calculatedStreamId"] = this.calculatedStreamId !== undefined ? this.calculatedStreamId : <any>null;
        return data;
    }
}

export interface IOverride3GPGURDTO {
    totalMass?: number | null;
    totalVolume?: number | null;
    runTime?: number | null;
    calculatedStreamId: number;
}

export class HeatersRecordsDTO implements IHeatersRecordsDTO {
    equipment!: HeatersEquipment;
    logged?: Date | null;
    timestamp!: Date;
    motohours!: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    capacityNominal!: number;
    correlationCoeffficient!: number;
    capacityWorking!: number;
    energyProduced!: number;
    energyProducedMJ!: number;
    energyProducedKcal!: number;
    lowestHeatCombustion!: number;
    volumeGas!: number;
    volumeGasEfficiency!: number;
    volumeGas0CEfficiency!: number;
    efficiency!: number;
    isRecordCreated!: boolean;
    properties!: { [key: string]: any; };

    constructor(data?: IHeatersRecordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipment = _data["equipment"] !== undefined ? _data["equipment"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.motohours = _data["motohours"] !== undefined ? _data["motohours"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.capacityNominal = _data["capacityNominal"] !== undefined ? _data["capacityNominal"] : <any>null;
            this.correlationCoeffficient = _data["correlationCoeffficient"] !== undefined ? _data["correlationCoeffficient"] : <any>null;
            this.capacityWorking = _data["capacityWorking"] !== undefined ? _data["capacityWorking"] : <any>null;
            this.energyProduced = _data["energyProduced"] !== undefined ? _data["energyProduced"] : <any>null;
            this.energyProducedMJ = _data["energyProducedMJ"] !== undefined ? _data["energyProducedMJ"] : <any>null;
            this.energyProducedKcal = _data["energyProducedKcal"] !== undefined ? _data["energyProducedKcal"] : <any>null;
            this.lowestHeatCombustion = _data["lowestHeatCombustion"] !== undefined ? _data["lowestHeatCombustion"] : <any>null;
            this.volumeGas = _data["volumeGas"] !== undefined ? _data["volumeGas"] : <any>null;
            this.volumeGasEfficiency = _data["volumeGasEfficiency"] !== undefined ? _data["volumeGasEfficiency"] : <any>null;
            this.volumeGas0CEfficiency = _data["volumeGas0CEfficiency"] !== undefined ? _data["volumeGas0CEfficiency"] : <any>null;
            this.efficiency = _data["efficiency"] !== undefined ? _data["efficiency"] : <any>null;
            this.isRecordCreated = _data["isRecordCreated"] !== undefined ? _data["isRecordCreated"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): HeatersRecordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HeatersRecordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipment"] = this.equipment !== undefined ? this.equipment : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["motohours"] = this.motohours !== undefined ? this.motohours : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["capacityNominal"] = this.capacityNominal !== undefined ? this.capacityNominal : <any>null;
        data["correlationCoeffficient"] = this.correlationCoeffficient !== undefined ? this.correlationCoeffficient : <any>null;
        data["capacityWorking"] = this.capacityWorking !== undefined ? this.capacityWorking : <any>null;
        data["energyProduced"] = this.energyProduced !== undefined ? this.energyProduced : <any>null;
        data["energyProducedMJ"] = this.energyProducedMJ !== undefined ? this.energyProducedMJ : <any>null;
        data["energyProducedKcal"] = this.energyProducedKcal !== undefined ? this.energyProducedKcal : <any>null;
        data["lowestHeatCombustion"] = this.lowestHeatCombustion !== undefined ? this.lowestHeatCombustion : <any>null;
        data["volumeGas"] = this.volumeGas !== undefined ? this.volumeGas : <any>null;
        data["volumeGasEfficiency"] = this.volumeGasEfficiency !== undefined ? this.volumeGasEfficiency : <any>null;
        data["volumeGas0CEfficiency"] = this.volumeGas0CEfficiency !== undefined ? this.volumeGas0CEfficiency : <any>null;
        data["efficiency"] = this.efficiency !== undefined ? this.efficiency : <any>null;
        data["isRecordCreated"] = this.isRecordCreated !== undefined ? this.isRecordCreated : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IHeatersRecordsDTO {
    equipment: HeatersEquipment;
    logged?: Date | null;
    timestamp: Date;
    motohours: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    capacityNominal: number;
    correlationCoeffficient: number;
    capacityWorking: number;
    energyProduced: number;
    energyProducedMJ: number;
    energyProducedKcal: number;
    lowestHeatCombustion: number;
    volumeGas: number;
    volumeGasEfficiency: number;
    volumeGas0CEfficiency: number;
    efficiency: number;
    isRecordCreated: boolean;
    properties: { [key: string]: any; };
}

export enum HeatersEquipment {
    BK1 = 0,
    BK2 = 1,
    BK3 = 2,
    BK4 = 3,
    BK5 = 4,
    BK6 = 5,
    BK7 = 6,
    BK8 = 7,
    BKCeh = 8,
}

export class BoilerRecordsDTO implements IBoilerRecordsDTO {
    equipment!: BoilerEquipment;
    logged?: Date | null;
    timestamp!: Date;
    motohours!: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    capacityNominal!: number;
    correlationCoeffficient!: number;
    capacityWorking!: number;
    energyProduced!: number;
    energyProducedMJ!: number;
    energyProducedKcal!: number;
    lowestHeatCombustion!: number;
    volumeGas!: number;
    volumeGasEfficiency!: number;
    volumeGas0CEfficiency!: number;
    efficiency!: number;
    isRecordCreated!: boolean;
    properties!: { [key: string]: any; };

    constructor(data?: IBoilerRecordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipment = _data["equipment"] !== undefined ? _data["equipment"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.motohours = _data["motohours"] !== undefined ? _data["motohours"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.capacityNominal = _data["capacityNominal"] !== undefined ? _data["capacityNominal"] : <any>null;
            this.correlationCoeffficient = _data["correlationCoeffficient"] !== undefined ? _data["correlationCoeffficient"] : <any>null;
            this.capacityWorking = _data["capacityWorking"] !== undefined ? _data["capacityWorking"] : <any>null;
            this.energyProduced = _data["energyProduced"] !== undefined ? _data["energyProduced"] : <any>null;
            this.energyProducedMJ = _data["energyProducedMJ"] !== undefined ? _data["energyProducedMJ"] : <any>null;
            this.energyProducedKcal = _data["energyProducedKcal"] !== undefined ? _data["energyProducedKcal"] : <any>null;
            this.lowestHeatCombustion = _data["lowestHeatCombustion"] !== undefined ? _data["lowestHeatCombustion"] : <any>null;
            this.volumeGas = _data["volumeGas"] !== undefined ? _data["volumeGas"] : <any>null;
            this.volumeGasEfficiency = _data["volumeGasEfficiency"] !== undefined ? _data["volumeGasEfficiency"] : <any>null;
            this.volumeGas0CEfficiency = _data["volumeGas0CEfficiency"] !== undefined ? _data["volumeGas0CEfficiency"] : <any>null;
            this.efficiency = _data["efficiency"] !== undefined ? _data["efficiency"] : <any>null;
            this.isRecordCreated = _data["isRecordCreated"] !== undefined ? _data["isRecordCreated"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): BoilerRecordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BoilerRecordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipment"] = this.equipment !== undefined ? this.equipment : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["motohours"] = this.motohours !== undefined ? this.motohours : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["capacityNominal"] = this.capacityNominal !== undefined ? this.capacityNominal : <any>null;
        data["correlationCoeffficient"] = this.correlationCoeffficient !== undefined ? this.correlationCoeffficient : <any>null;
        data["capacityWorking"] = this.capacityWorking !== undefined ? this.capacityWorking : <any>null;
        data["energyProduced"] = this.energyProduced !== undefined ? this.energyProduced : <any>null;
        data["energyProducedMJ"] = this.energyProducedMJ !== undefined ? this.energyProducedMJ : <any>null;
        data["energyProducedKcal"] = this.energyProducedKcal !== undefined ? this.energyProducedKcal : <any>null;
        data["lowestHeatCombustion"] = this.lowestHeatCombustion !== undefined ? this.lowestHeatCombustion : <any>null;
        data["volumeGas"] = this.volumeGas !== undefined ? this.volumeGas : <any>null;
        data["volumeGasEfficiency"] = this.volumeGasEfficiency !== undefined ? this.volumeGasEfficiency : <any>null;
        data["volumeGas0CEfficiency"] = this.volumeGas0CEfficiency !== undefined ? this.volumeGas0CEfficiency : <any>null;
        data["efficiency"] = this.efficiency !== undefined ? this.efficiency : <any>null;
        data["isRecordCreated"] = this.isRecordCreated !== undefined ? this.isRecordCreated : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IBoilerRecordsDTO {
    equipment: BoilerEquipment;
    logged?: Date | null;
    timestamp: Date;
    motohours: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    capacityNominal: number;
    correlationCoeffficient: number;
    capacityWorking: number;
    energyProduced: number;
    energyProducedMJ: number;
    energyProducedKcal: number;
    lowestHeatCombustion: number;
    volumeGas: number;
    volumeGasEfficiency: number;
    volumeGas0CEfficiency: number;
    efficiency: number;
    isRecordCreated: boolean;
    properties: { [key: string]: any; };
}

export enum BoilerEquipment {
    BAY1 = 0,
    BAY2 = 1,
    BAY3 = 2,
    BAY4 = 3,
    ASX = 4,
    TCOVTK2 = 5,
    TCOVTK3 = 6,
    TCOVTK4 = 7,
    TCOVTK5 = 8,
    TCOVTK6 = 9,
    TCOVTK7 = 10,
    TCOVTK8 = 11,
    TCOVTK9 = 12,
    TCOVTK10 = 13,
    OLDIbTK1 = 14,
    OLDIbTK2 = 15,
    OLDIbTK3 = 16,
    OLDIbTK4 = 17,
    S825M1 = 18,
    S825M2 = 19,
    S825M3 = 20,
    S825M4 = 21,
    JASPI1 = 22,
    JASPI2 = 23,
    NA1 = 24,
    NA2 = 25,
    NA3 = 26,
}

export class MetersRecordsDTO implements IMetersRecordsDTO {
    equipment!: MetersEquipment;
    logged?: Date | null;
    timestamp!: Date;
    numberStartOfPeriod!: number;
    numberEndOfPeriod!: number;
    isTransitionWinter!: boolean;
    numberTransitionPeriod!: number;
    dateTransitionPeriod!: Date;
    createdBy?: string | null;
    updatedBy?: string | null;
    consumption!: number;
    additionalValue!: number;
    pressure!: number;
    temperature!: number;
    outputValue20C!: number;
    outputValue0C!: number;

    constructor(data?: IMetersRecordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipment = _data["equipment"] !== undefined ? _data["equipment"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.numberStartOfPeriod = _data["numberStartOfPeriod"] !== undefined ? _data["numberStartOfPeriod"] : <any>null;
            this.numberEndOfPeriod = _data["numberEndOfPeriod"] !== undefined ? _data["numberEndOfPeriod"] : <any>null;
            this.isTransitionWinter = _data["isTransitionWinter"] !== undefined ? _data["isTransitionWinter"] : <any>null;
            this.numberTransitionPeriod = _data["numberTransitionPeriod"] !== undefined ? _data["numberTransitionPeriod"] : <any>null;
            this.dateTransitionPeriod = _data["dateTransitionPeriod"] ? new Date(_data["dateTransitionPeriod"].toString()) : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.consumption = _data["consumption"] !== undefined ? _data["consumption"] : <any>null;
            this.additionalValue = _data["additionalValue"] !== undefined ? _data["additionalValue"] : <any>null;
            this.pressure = _data["pressure"] !== undefined ? _data["pressure"] : <any>null;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
            this.outputValue20C = _data["outputValue20C"] !== undefined ? _data["outputValue20C"] : <any>null;
            this.outputValue0C = _data["outputValue0C"] !== undefined ? _data["outputValue0C"] : <any>null;
        }
    }

    static fromJS(data: any): MetersRecordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MetersRecordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipment"] = this.equipment !== undefined ? this.equipment : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["numberStartOfPeriod"] = this.numberStartOfPeriod !== undefined ? this.numberStartOfPeriod : <any>null;
        data["numberEndOfPeriod"] = this.numberEndOfPeriod !== undefined ? this.numberEndOfPeriod : <any>null;
        data["isTransitionWinter"] = this.isTransitionWinter !== undefined ? this.isTransitionWinter : <any>null;
        data["numberTransitionPeriod"] = this.numberTransitionPeriod !== undefined ? this.numberTransitionPeriod : <any>null;
        data["dateTransitionPeriod"] = this.dateTransitionPeriod ? this.dateTransitionPeriod.toISOString() : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["consumption"] = this.consumption !== undefined ? this.consumption : <any>null;
        data["additionalValue"] = this.additionalValue !== undefined ? this.additionalValue : <any>null;
        data["pressure"] = this.pressure !== undefined ? this.pressure : <any>null;
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        data["outputValue20C"] = this.outputValue20C !== undefined ? this.outputValue20C : <any>null;
        data["outputValue0C"] = this.outputValue0C !== undefined ? this.outputValue0C : <any>null;
        return data;
    }
}

export interface IMetersRecordsDTO {
    equipment: MetersEquipment;
    logged?: Date | null;
    timestamp: Date;
    numberStartOfPeriod: number;
    numberEndOfPeriod: number;
    isTransitionWinter: boolean;
    numberTransitionPeriod: number;
    dateTransitionPeriod: Date;
    createdBy?: string | null;
    updatedBy?: string | null;
    consumption: number;
    additionalValue: number;
    pressure: number;
    temperature: number;
    outputValue20C: number;
    outputValue0C: number;
}

export enum MetersEquipment {
    RPN = 0,
    Korolev = 1,
    GTES144 = 2,
    PromBaza = 3,
    PosTCO = 4,
    PosShanyrak = 5,
    ZCHS = 6,
    NSS = 7,
    PosOrken = 8,
    BetonnyZavod = 9,
}

export class TotalTableDTO implements ITotalTableDTO {
    logged!: Date;
    timestamp!: Date;
    total20C!: number;
    total0C!: number;
    difference20C!: number;
    difference0C!: number;
    differencePerc20C!: number;
    differencePerc0C!: number;
    properties!: { [key: string]: any; };

    constructor(data?: ITotalTableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.total20C = _data["total20C"] !== undefined ? _data["total20C"] : <any>null;
            this.total0C = _data["total0C"] !== undefined ? _data["total0C"] : <any>null;
            this.difference20C = _data["difference20C"] !== undefined ? _data["difference20C"] : <any>null;
            this.difference0C = _data["difference0C"] !== undefined ? _data["difference0C"] : <any>null;
            this.differencePerc20C = _data["differencePerc20C"] !== undefined ? _data["differencePerc20C"] : <any>null;
            this.differencePerc0C = _data["differencePerc0C"] !== undefined ? _data["differencePerc0C"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): TotalTableDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TotalTableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["total20C"] = this.total20C !== undefined ? this.total20C : <any>null;
        data["total0C"] = this.total0C !== undefined ? this.total0C : <any>null;
        data["difference20C"] = this.difference20C !== undefined ? this.difference20C : <any>null;
        data["difference0C"] = this.difference0C !== undefined ? this.difference0C : <any>null;
        data["differencePerc20C"] = this.differencePerc20C !== undefined ? this.differencePerc20C : <any>null;
        data["differencePerc0C"] = this.differencePerc0C !== undefined ? this.differencePerc0C : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ITotalTableDTO {
    logged: Date;
    timestamp: Date;
    total20C: number;
    total0C: number;
    difference20C: number;
    difference0C: number;
    differencePerc20C: number;
    differencePerc0C: number;
    properties: { [key: string]: any; };
}

export class IBMOARecordsDTO implements IIBMOARecordsDTO {
    logged!: Date;
    timestamp!: Date;
    volumeGasYear!: number;
    motoHoursYear!: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    monthsRecords!: IBMOAMonthsRows[];
    properties!: { [key: string]: any; };

    constructor(data?: IIBMOARecordsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.monthsRecords = [];
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.volumeGasYear = _data["volumeGasYear"] !== undefined ? _data["volumeGasYear"] : <any>null;
            this.motoHoursYear = _data["motoHoursYear"] !== undefined ? _data["motoHoursYear"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            if (Array.isArray(_data["monthsRecords"])) {
                this.monthsRecords = [] as any;
                for (let item of _data["monthsRecords"])
                    this.monthsRecords!.push(IBMOAMonthsRows.fromJS(item));
            }
            else {
                this.monthsRecords = <any>null;
            }
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): IBMOARecordsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IBMOARecordsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["volumeGasYear"] = this.volumeGasYear !== undefined ? this.volumeGasYear : <any>null;
        data["motoHoursYear"] = this.motoHoursYear !== undefined ? this.motoHoursYear : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        if (Array.isArray(this.monthsRecords)) {
            data["monthsRecords"] = [];
            for (let item of this.monthsRecords)
                data["monthsRecords"].push(item ? item.toJSON() : <any>null);
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IIBMOARecordsDTO {
    logged: Date;
    timestamp: Date;
    volumeGasYear: number;
    motoHoursYear: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    monthsRecords: IBMOAMonthsRows[];
    properties: { [key: string]: any; };
}

export class IBMOAMonthsRows implements IIBMOAMonthsRows {
    dateMonth!: Date;
    daysOfMonth!: number;
    volumeGas20C!: number;
    volumeGas0C!: number;

    constructor(data?: IIBMOAMonthsRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateMonth = _data["dateMonth"] ? new Date(_data["dateMonth"].toString()) : <any>null;
            this.daysOfMonth = _data["daysOfMonth"] !== undefined ? _data["daysOfMonth"] : <any>null;
            this.volumeGas20C = _data["volumeGas20C"] !== undefined ? _data["volumeGas20C"] : <any>null;
            this.volumeGas0C = _data["volumeGas0C"] !== undefined ? _data["volumeGas0C"] : <any>null;
        }
    }

    static fromJS(data: any): IBMOAMonthsRows {
        data = typeof data === 'object' ? data : {};
        let result = new IBMOAMonthsRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateMonth"] = this.dateMonth ? this.dateMonth.toISOString() : <any>null;
        data["daysOfMonth"] = this.daysOfMonth !== undefined ? this.daysOfMonth : <any>null;
        data["volumeGas20C"] = this.volumeGas20C !== undefined ? this.volumeGas20C : <any>null;
        data["volumeGas0C"] = this.volumeGas0C !== undefined ? this.volumeGas0C : <any>null;
        return data;
    }
}

export interface IIBMOAMonthsRows {
    dateMonth: Date;
    daysOfMonth: number;
    volumeGas20C: number;
    volumeGas0C: number;
}

export class MonthlyReportDTO implements IMonthlyReportDTO {
    logged!: Date;
    timestamp!: Date;
    rpnReservoirPark20!: number;
    rpnReservoirPark0!: number;
    rpnReservoirParkComment!: string;
    korolev20!: number;
    korolev0!: number;
    korolevComment!: string;
    gteS14420!: number;
    gteS1440!: number;
    gteS144Comment!: string;
    prombaza20!: number;
    prombaza0!: number;
    prombazaComment!: string;
    promTCO20!: number;
    promTCO0!: number;
    promTCComment!: string;
    posShanyrak20!: number;
    posShanyrak0!: number;
    posShanyrakComment!: string;
    posOrken20!: number;
    posOrken0!: number;
    posOrkenComment!: string;
    kotelnayaPromBazi20!: number;
    kotelnayaPromBazi0!: number;
    kotelnayaPromBaziComment!: string;
    kotelnayaIBMOA20!: number;
    kotelnayaIBMOA0!: number;
    kotelnayaIBMOAComment!: string;
    estakada20!: number;
    estakada0!: number;
    estakadaComment!: string;
    tovarniPark20!: number;
    tovarniPark0!: number;
    tovarniParkComment!: string;
    bazaBureniya20!: number;
    bazaBureniya0!: number;
    bazaBureniyaComment!: string;
    betonnyZavod20!: number;
    betonnyZavod0!: number;
    betonnyZavodComment!: string;
    properties!: { [key: string]: any; };

    constructor(data?: IMonthlyReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.rpnReservoirPark20 = _data["rpnReservoirPark20"] !== undefined ? _data["rpnReservoirPark20"] : <any>null;
            this.rpnReservoirPark0 = _data["rpnReservoirPark0"] !== undefined ? _data["rpnReservoirPark0"] : <any>null;
            this.rpnReservoirParkComment = _data["rpnReservoirParkComment"] !== undefined ? _data["rpnReservoirParkComment"] : <any>null;
            this.korolev20 = _data["korolev20"] !== undefined ? _data["korolev20"] : <any>null;
            this.korolev0 = _data["korolev0"] !== undefined ? _data["korolev0"] : <any>null;
            this.korolevComment = _data["korolevComment"] !== undefined ? _data["korolevComment"] : <any>null;
            this.gteS14420 = _data["gteS14420"] !== undefined ? _data["gteS14420"] : <any>null;
            this.gteS1440 = _data["gteS1440"] !== undefined ? _data["gteS1440"] : <any>null;
            this.gteS144Comment = _data["gteS144Comment"] !== undefined ? _data["gteS144Comment"] : <any>null;
            this.prombaza20 = _data["prombaza20"] !== undefined ? _data["prombaza20"] : <any>null;
            this.prombaza0 = _data["prombaza0"] !== undefined ? _data["prombaza0"] : <any>null;
            this.prombazaComment = _data["prombazaComment"] !== undefined ? _data["prombazaComment"] : <any>null;
            this.promTCO20 = _data["promTCO20"] !== undefined ? _data["promTCO20"] : <any>null;
            this.promTCO0 = _data["promTCO0"] !== undefined ? _data["promTCO0"] : <any>null;
            this.promTCComment = _data["promTCComment"] !== undefined ? _data["promTCComment"] : <any>null;
            this.posShanyrak20 = _data["posShanyrak20"] !== undefined ? _data["posShanyrak20"] : <any>null;
            this.posShanyrak0 = _data["posShanyrak0"] !== undefined ? _data["posShanyrak0"] : <any>null;
            this.posShanyrakComment = _data["posShanyrakComment"] !== undefined ? _data["posShanyrakComment"] : <any>null;
            this.posOrken20 = _data["posOrken20"] !== undefined ? _data["posOrken20"] : <any>null;
            this.posOrken0 = _data["posOrken0"] !== undefined ? _data["posOrken0"] : <any>null;
            this.posOrkenComment = _data["posOrkenComment"] !== undefined ? _data["posOrkenComment"] : <any>null;
            this.kotelnayaPromBazi20 = _data["kotelnayaPromBazi20"] !== undefined ? _data["kotelnayaPromBazi20"] : <any>null;
            this.kotelnayaPromBazi0 = _data["kotelnayaPromBazi0"] !== undefined ? _data["kotelnayaPromBazi0"] : <any>null;
            this.kotelnayaPromBaziComment = _data["kotelnayaPromBaziComment"] !== undefined ? _data["kotelnayaPromBaziComment"] : <any>null;
            this.kotelnayaIBMOA20 = _data["kotelnayaIBMOA20"] !== undefined ? _data["kotelnayaIBMOA20"] : <any>null;
            this.kotelnayaIBMOA0 = _data["kotelnayaIBMOA0"] !== undefined ? _data["kotelnayaIBMOA0"] : <any>null;
            this.kotelnayaIBMOAComment = _data["kotelnayaIBMOAComment"] !== undefined ? _data["kotelnayaIBMOAComment"] : <any>null;
            this.estakada20 = _data["estakada20"] !== undefined ? _data["estakada20"] : <any>null;
            this.estakada0 = _data["estakada0"] !== undefined ? _data["estakada0"] : <any>null;
            this.estakadaComment = _data["estakadaComment"] !== undefined ? _data["estakadaComment"] : <any>null;
            this.tovarniPark20 = _data["tovarniPark20"] !== undefined ? _data["tovarniPark20"] : <any>null;
            this.tovarniPark0 = _data["tovarniPark0"] !== undefined ? _data["tovarniPark0"] : <any>null;
            this.tovarniParkComment = _data["tovarniParkComment"] !== undefined ? _data["tovarniParkComment"] : <any>null;
            this.bazaBureniya20 = _data["bazaBureniya20"] !== undefined ? _data["bazaBureniya20"] : <any>null;
            this.bazaBureniya0 = _data["bazaBureniya0"] !== undefined ? _data["bazaBureniya0"] : <any>null;
            this.bazaBureniyaComment = _data["bazaBureniyaComment"] !== undefined ? _data["bazaBureniyaComment"] : <any>null;
            this.betonnyZavod20 = _data["betonnyZavod20"] !== undefined ? _data["betonnyZavod20"] : <any>null;
            this.betonnyZavod0 = _data["betonnyZavod0"] !== undefined ? _data["betonnyZavod0"] : <any>null;
            this.betonnyZavodComment = _data["betonnyZavodComment"] !== undefined ? _data["betonnyZavodComment"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): MonthlyReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["rpnReservoirPark20"] = this.rpnReservoirPark20 !== undefined ? this.rpnReservoirPark20 : <any>null;
        data["rpnReservoirPark0"] = this.rpnReservoirPark0 !== undefined ? this.rpnReservoirPark0 : <any>null;
        data["rpnReservoirParkComment"] = this.rpnReservoirParkComment !== undefined ? this.rpnReservoirParkComment : <any>null;
        data["korolev20"] = this.korolev20 !== undefined ? this.korolev20 : <any>null;
        data["korolev0"] = this.korolev0 !== undefined ? this.korolev0 : <any>null;
        data["korolevComment"] = this.korolevComment !== undefined ? this.korolevComment : <any>null;
        data["gteS14420"] = this.gteS14420 !== undefined ? this.gteS14420 : <any>null;
        data["gteS1440"] = this.gteS1440 !== undefined ? this.gteS1440 : <any>null;
        data["gteS144Comment"] = this.gteS144Comment !== undefined ? this.gteS144Comment : <any>null;
        data["prombaza20"] = this.prombaza20 !== undefined ? this.prombaza20 : <any>null;
        data["prombaza0"] = this.prombaza0 !== undefined ? this.prombaza0 : <any>null;
        data["prombazaComment"] = this.prombazaComment !== undefined ? this.prombazaComment : <any>null;
        data["promTCO20"] = this.promTCO20 !== undefined ? this.promTCO20 : <any>null;
        data["promTCO0"] = this.promTCO0 !== undefined ? this.promTCO0 : <any>null;
        data["promTCComment"] = this.promTCComment !== undefined ? this.promTCComment : <any>null;
        data["posShanyrak20"] = this.posShanyrak20 !== undefined ? this.posShanyrak20 : <any>null;
        data["posShanyrak0"] = this.posShanyrak0 !== undefined ? this.posShanyrak0 : <any>null;
        data["posShanyrakComment"] = this.posShanyrakComment !== undefined ? this.posShanyrakComment : <any>null;
        data["posOrken20"] = this.posOrken20 !== undefined ? this.posOrken20 : <any>null;
        data["posOrken0"] = this.posOrken0 !== undefined ? this.posOrken0 : <any>null;
        data["posOrkenComment"] = this.posOrkenComment !== undefined ? this.posOrkenComment : <any>null;
        data["kotelnayaPromBazi20"] = this.kotelnayaPromBazi20 !== undefined ? this.kotelnayaPromBazi20 : <any>null;
        data["kotelnayaPromBazi0"] = this.kotelnayaPromBazi0 !== undefined ? this.kotelnayaPromBazi0 : <any>null;
        data["kotelnayaPromBaziComment"] = this.kotelnayaPromBaziComment !== undefined ? this.kotelnayaPromBaziComment : <any>null;
        data["kotelnayaIBMOA20"] = this.kotelnayaIBMOA20 !== undefined ? this.kotelnayaIBMOA20 : <any>null;
        data["kotelnayaIBMOA0"] = this.kotelnayaIBMOA0 !== undefined ? this.kotelnayaIBMOA0 : <any>null;
        data["kotelnayaIBMOAComment"] = this.kotelnayaIBMOAComment !== undefined ? this.kotelnayaIBMOAComment : <any>null;
        data["estakada20"] = this.estakada20 !== undefined ? this.estakada20 : <any>null;
        data["estakada0"] = this.estakada0 !== undefined ? this.estakada0 : <any>null;
        data["estakadaComment"] = this.estakadaComment !== undefined ? this.estakadaComment : <any>null;
        data["tovarniPark20"] = this.tovarniPark20 !== undefined ? this.tovarniPark20 : <any>null;
        data["tovarniPark0"] = this.tovarniPark0 !== undefined ? this.tovarniPark0 : <any>null;
        data["tovarniParkComment"] = this.tovarniParkComment !== undefined ? this.tovarniParkComment : <any>null;
        data["bazaBureniya20"] = this.bazaBureniya20 !== undefined ? this.bazaBureniya20 : <any>null;
        data["bazaBureniya0"] = this.bazaBureniya0 !== undefined ? this.bazaBureniya0 : <any>null;
        data["bazaBureniyaComment"] = this.bazaBureniyaComment !== undefined ? this.bazaBureniyaComment : <any>null;
        data["betonnyZavod20"] = this.betonnyZavod20 !== undefined ? this.betonnyZavod20 : <any>null;
        data["betonnyZavod0"] = this.betonnyZavod0 !== undefined ? this.betonnyZavod0 : <any>null;
        data["betonnyZavodComment"] = this.betonnyZavodComment !== undefined ? this.betonnyZavodComment : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IMonthlyReportDTO {
    logged: Date;
    timestamp: Date;
    rpnReservoirPark20: number;
    rpnReservoirPark0: number;
    rpnReservoirParkComment: string;
    korolev20: number;
    korolev0: number;
    korolevComment: string;
    gteS14420: number;
    gteS1440: number;
    gteS144Comment: string;
    prombaza20: number;
    prombaza0: number;
    prombazaComment: string;
    promTCO20: number;
    promTCO0: number;
    promTCComment: string;
    posShanyrak20: number;
    posShanyrak0: number;
    posShanyrakComment: string;
    posOrken20: number;
    posOrken0: number;
    posOrkenComment: string;
    kotelnayaPromBazi20: number;
    kotelnayaPromBazi0: number;
    kotelnayaPromBaziComment: string;
    kotelnayaIBMOA20: number;
    kotelnayaIBMOA0: number;
    kotelnayaIBMOAComment: string;
    estakada20: number;
    estakada0: number;
    estakadaComment: string;
    tovarniPark20: number;
    tovarniPark0: number;
    tovarniParkComment: string;
    bazaBureniya20: number;
    bazaBureniya0: number;
    bazaBureniyaComment: string;
    betonnyZavod20: number;
    betonnyZavod0: number;
    betonnyZavodComment: string;
    properties: { [key: string]: any; };
}

export class MonthlyReportCommentsDTO implements IMonthlyReportCommentsDTO {
    logged!: Date;
    timestamp!: Date;
    rowType!: MonthlyReportRowType;
    comment!: string;
    properties!: { [key: string]: any; };

    constructor(data?: IMonthlyReportCommentsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.rowType = _data["rowType"] !== undefined ? _data["rowType"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): MonthlyReportCommentsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyReportCommentsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["rowType"] = this.rowType !== undefined ? this.rowType : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IMonthlyReportCommentsDTO {
    logged: Date;
    timestamp: Date;
    rowType: MonthlyReportRowType;
    comment: string;
    properties: { [key: string]: any; };
}

export enum MonthlyReportRowType {
    RPN = 0,
    Korolev = 1,
    GTES = 2,
    PromBaza = 3,
    PosTCO = 4,
    PosShanyrak = 5,
    KotelnayaPrombazi = 6,
    KotelnayaIBMOA = 7,
    Estakada = 8,
    Park = 9,
    BazaBurenya = 10,
    PosOrken = 11,
    BetonnyZavod = 12,
}

export class CalculatedStreamDTO implements ICalculatedStreamDTO {
    timeStamp!: Date;
    isApproved!: boolean;
    isConfirmed!: boolean;
    totalMass!: number;
    totalVolume!: number;
    elementName!: string;
    streamId!: number;
    type!: KTLFGDStreamType;
    order!: number;
    status!: StreamStatuses;
    isOxidizersAndCNSFieldChecked?: boolean | null;

    constructor(data?: ICalculatedStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.isOxidizersAndCNSFieldChecked = _data["isOxidizersAndCNSFieldChecked"] !== undefined ? _data["isOxidizersAndCNSFieldChecked"] : <any>null;
        }
    }

    static fromJS(data: any): CalculatedStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["isOxidizersAndCNSFieldChecked"] = this.isOxidizersAndCNSFieldChecked !== undefined ? this.isOxidizersAndCNSFieldChecked : <any>null;
        return data;
    }
}

export interface ICalculatedStreamDTO {
    timeStamp: Date;
    isApproved: boolean;
    isConfirmed: boolean;
    totalMass: number;
    totalVolume: number;
    elementName: string;
    streamId: number;
    type: KTLFGDStreamType;
    order: number;
    status: StreamStatuses;
    isOxidizersAndCNSFieldChecked?: boolean | null;
}

export enum KTLFGDStreamType {
    Calculates = 0,
    DailyInputs = 1,
    Flarings = 2,
    FromPreviousMonthBalance = 3,
    SalesGas = 4,
}

export class DailyReportInputRecordDTO implements IDailyReportInputRecordDTO {
    id!: number;
    crudeProductionMass!: number;
    propaneProductionMass!: number;
    butaneProductionMass!: number;
    kulsaryCustodyTransferVolumeKsmCube!: number;
    sulphurMass!: number;
    fuelGasToCNS!: boolean;
    y1504A!: boolean;
    y1504B!: boolean;
    startTime!: Date;
    synapseTimestep?: Date | null;

    constructor(data?: IDailyReportInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.crudeProductionMass = _data["crudeProductionMass"] !== undefined ? _data["crudeProductionMass"] : <any>null;
            this.propaneProductionMass = _data["propaneProductionMass"] !== undefined ? _data["propaneProductionMass"] : <any>null;
            this.butaneProductionMass = _data["butaneProductionMass"] !== undefined ? _data["butaneProductionMass"] : <any>null;
            this.kulsaryCustodyTransferVolumeKsmCube = _data["kulsaryCustodyTransferVolumeKsmCube"] !== undefined ? _data["kulsaryCustodyTransferVolumeKsmCube"] : <any>null;
            this.sulphurMass = _data["sulphurMass"] !== undefined ? _data["sulphurMass"] : <any>null;
            this.fuelGasToCNS = _data["fuelGasToCNS"] !== undefined ? _data["fuelGasToCNS"] : <any>null;
            this.y1504A = _data["y1504A"] !== undefined ? _data["y1504A"] : <any>null;
            this.y1504B = _data["y1504B"] !== undefined ? _data["y1504B"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.synapseTimestep = _data["synapseTimestep"] ? new Date(_data["synapseTimestep"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DailyReportInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyReportInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["crudeProductionMass"] = this.crudeProductionMass !== undefined ? this.crudeProductionMass : <any>null;
        data["propaneProductionMass"] = this.propaneProductionMass !== undefined ? this.propaneProductionMass : <any>null;
        data["butaneProductionMass"] = this.butaneProductionMass !== undefined ? this.butaneProductionMass : <any>null;
        data["kulsaryCustodyTransferVolumeKsmCube"] = this.kulsaryCustodyTransferVolumeKsmCube !== undefined ? this.kulsaryCustodyTransferVolumeKsmCube : <any>null;
        data["sulphurMass"] = this.sulphurMass !== undefined ? this.sulphurMass : <any>null;
        data["fuelGasToCNS"] = this.fuelGasToCNS !== undefined ? this.fuelGasToCNS : <any>null;
        data["y1504A"] = this.y1504A !== undefined ? this.y1504A : <any>null;
        data["y1504B"] = this.y1504B !== undefined ? this.y1504B : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["synapseTimestep"] = this.synapseTimestep ? this.synapseTimestep.toISOString() : <any>null;
        return data;
    }
}

export interface IDailyReportInputRecordDTO {
    id: number;
    crudeProductionMass: number;
    propaneProductionMass: number;
    butaneProductionMass: number;
    kulsaryCustodyTransferVolumeKsmCube: number;
    sulphurMass: number;
    fuelGasToCNS: boolean;
    y1504A: boolean;
    y1504B: boolean;
    startTime: Date;
    synapseTimestep?: Date | null;
}

export class MonthlyInputRecordDTO implements IMonthlyInputRecordDTO {
    id!: number;
    additionalCompanyUse!: number;
    customerUse!: number;
    fuelGasToKTLandOldBoilerHouse!: number;
    dryGasToU800DMCTr5!: number;
    startTime!: Date;
    synapseTimestep?: Date | null;

    constructor(data?: IMonthlyInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.additionalCompanyUse = _data["additionalCompanyUse"] !== undefined ? _data["additionalCompanyUse"] : <any>null;
            this.customerUse = _data["customerUse"] !== undefined ? _data["customerUse"] : <any>null;
            this.fuelGasToKTLandOldBoilerHouse = _data["fuelGasToKTLandOldBoilerHouse"] !== undefined ? _data["fuelGasToKTLandOldBoilerHouse"] : <any>null;
            this.dryGasToU800DMCTr5 = _data["dryGasToU800DMCTr5"] !== undefined ? _data["dryGasToU800DMCTr5"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.synapseTimestep = _data["synapseTimestep"] ? new Date(_data["synapseTimestep"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): MonthlyInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["additionalCompanyUse"] = this.additionalCompanyUse !== undefined ? this.additionalCompanyUse : <any>null;
        data["customerUse"] = this.customerUse !== undefined ? this.customerUse : <any>null;
        data["fuelGasToKTLandOldBoilerHouse"] = this.fuelGasToKTLandOldBoilerHouse !== undefined ? this.fuelGasToKTLandOldBoilerHouse : <any>null;
        data["dryGasToU800DMCTr5"] = this.dryGasToU800DMCTr5 !== undefined ? this.dryGasToU800DMCTr5 : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["synapseTimestep"] = this.synapseTimestep ? this.synapseTimestep.toISOString() : <any>null;
        return data;
    }
}

export interface IMonthlyInputRecordDTO {
    id: number;
    additionalCompanyUse: number;
    customerUse: number;
    fuelGasToKTLandOldBoilerHouse: number;
    dryGasToU800DMCTr5: number;
    startTime: Date;
    synapseTimestep?: Date | null;
}

export class KTLFGDOverrideRecordDTO implements IKTLFGDOverrideRecordDTO {
    streamId!: number;
    startTime!: Date;
    value!: number;
    type!: KTLFGDValueType;
    isDailyReport!: boolean;
    properties!: { [key: string]: any; };

    constructor(data?: IKTLFGDOverrideRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.isDailyReport = _data["isDailyReport"] !== undefined ? _data["isDailyReport"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): KTLFGDOverrideRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLFGDOverrideRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["isDailyReport"] = this.isDailyReport !== undefined ? this.isDailyReport : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IKTLFGDOverrideRecordDTO {
    streamId: number;
    startTime: Date;
    value: number;
    type: KTLFGDValueType;
    isDailyReport: boolean;
    properties: { [key: string]: any; };
}

export enum KTLFGDValueType {
    Volume = 0,
    Mass = 1,
}

export class UpdateOxidizersAndCNSDTO implements IUpdateOxidizersAndCNSDTO {
    fuelGasToCNS?: boolean | null;
    y1504A?: boolean | null;
    y1504B?: boolean | null;
    isSkipRefreshAFToSQL!: boolean;
    startTime!: Date;

    constructor(data?: IUpdateOxidizersAndCNSDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelGasToCNS = _data["fuelGasToCNS"] !== undefined ? _data["fuelGasToCNS"] : <any>null;
            this.y1504A = _data["y1504A"] !== undefined ? _data["y1504A"] : <any>null;
            this.y1504B = _data["y1504B"] !== undefined ? _data["y1504B"] : <any>null;
            this.isSkipRefreshAFToSQL = _data["isSkipRefreshAFToSQL"] !== undefined ? _data["isSkipRefreshAFToSQL"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UpdateOxidizersAndCNSDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOxidizersAndCNSDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelGasToCNS"] = this.fuelGasToCNS !== undefined ? this.fuelGasToCNS : <any>null;
        data["y1504A"] = this.y1504A !== undefined ? this.y1504A : <any>null;
        data["y1504B"] = this.y1504B !== undefined ? this.y1504B : <any>null;
        data["isSkipRefreshAFToSQL"] = this.isSkipRefreshAFToSQL !== undefined ? this.isSkipRefreshAFToSQL : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        return data;
    }
}

export interface IUpdateOxidizersAndCNSDTO {
    fuelGasToCNS?: boolean | null;
    y1504A?: boolean | null;
    y1504B?: boolean | null;
    isSkipRefreshAFToSQL: boolean;
    startTime: Date;
}

export enum Plant {
    KTL = 0,
    SGP = 1,
}

export class FlareSwitcherDTO implements IFlareSwitcherDTO {
    unitType!: UnitList;
    facility!: KTLTrains;
    startTime!: Date;
    flare!: string;

    constructor(data?: IFlareSwitcherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"] !== undefined ? _data["unitType"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.flare = _data["flare"] !== undefined ? _data["flare"] : <any>null;
        }
    }

    static fromJS(data: any): FlareSwitcherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FlareSwitcherDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType !== undefined ? this.unitType : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["flare"] = this.flare !== undefined ? this.flare : <any>null;
        return data;
    }
}

export interface IFlareSwitcherDTO {
    unitType: UnitList;
    facility: KTLTrains;
    startTime: Date;
    flare: string;
}

export enum UnitList {
    U200 = 0,
    U300 = 1,
    U700 = 2,
    U800 = 3,
    DMC1AND2 = 4,
    U400AND500 = 5,
    FiveSixHundred = 6,
    GTS = 7,
    U1700 = 8,
}

export enum KTLTrains {
    KTL1 = 0,
    KTL2 = 1,
    KTL1andKTL2 = 2,
    SGP = 3,
}

export class SGPFlareSwitcherDTO implements ISGPFlareSwitcherDTO {
    startTime!: Date;
    flare!: SGPFlareType;

    constructor(data?: ISGPFlareSwitcherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.flare = _data["flare"] !== undefined ? _data["flare"] : <any>null;
        }
    }

    static fromJS(data: any): SGPFlareSwitcherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGPFlareSwitcherDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["flare"] = this.flare !== undefined ? this.flare : <any>null;
        return data;
    }
}

export interface ISGPFlareSwitcherDTO {
    startTime: Date;
    flare: SGPFlareType;
}

export enum SGPFlareType {
    LP = 0,
    LPReserve = 1,
}

export class PagedListOfGetSGPFlareSwitcherDTO implements IPagedListOfGetSGPFlareSwitcherDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: GetSGPFlareSwitcherDTO[];

    constructor(data?: IPagedListOfGetSGPFlareSwitcherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSGPFlareSwitcherDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfGetSGPFlareSwitcherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetSGPFlareSwitcherDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfGetSGPFlareSwitcherDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: GetSGPFlareSwitcherDTO[];
}

export class GetSGPFlareSwitcherDTO implements IGetSGPFlareSwitcherDTO {
    startTime?: Date | null;
    flareName!: string;

    constructor(data?: IGetSGPFlareSwitcherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.flareName = _data["flareName"] !== undefined ? _data["flareName"] : <any>null;
        }
    }

    static fromJS(data: any): GetSGPFlareSwitcherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetSGPFlareSwitcherDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["flareName"] = this.flareName !== undefined ? this.flareName : <any>null;
        return data;
    }
}

export interface IGetSGPFlareSwitcherDTO {
    startTime?: Date | null;
    flareName: string;
}

export class GetSwitchableStreamDTO implements IGetSwitchableStreamDTO {
    whichFlareIsOn!: string;
    parentStreamGasType!: string;
    childStreamNames!: string[];

    constructor(data?: IGetSwitchableStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.childStreamNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.whichFlareIsOn = _data["whichFlareIsOn"] !== undefined ? _data["whichFlareIsOn"] : <any>null;
            this.parentStreamGasType = _data["parentStreamGasType"] !== undefined ? _data["parentStreamGasType"] : <any>null;
            if (Array.isArray(_data["childStreamNames"])) {
                this.childStreamNames = [] as any;
                for (let item of _data["childStreamNames"])
                    this.childStreamNames!.push(item);
            }
            else {
                this.childStreamNames = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSwitchableStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetSwitchableStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["whichFlareIsOn"] = this.whichFlareIsOn !== undefined ? this.whichFlareIsOn : <any>null;
        data["parentStreamGasType"] = this.parentStreamGasType !== undefined ? this.parentStreamGasType : <any>null;
        if (Array.isArray(this.childStreamNames)) {
            data["childStreamNames"] = [];
            for (let item of this.childStreamNames)
                data["childStreamNames"].push(item);
        }
        return data;
    }
}

export interface IGetSwitchableStreamDTO {
    whichFlareIsOn: string;
    parentStreamGasType: string;
    childStreamNames: string[];
}

export class GetFacilityAndUnitMappingDTO implements IGetFacilityAndUnitMappingDTO {
    facility!: KTLTrains;
    unitFlareMap!: UnitAndFlareMappingDTO[];

    constructor(data?: IGetFacilityAndUnitMappingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.unitFlareMap = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            if (Array.isArray(_data["unitFlareMap"])) {
                this.unitFlareMap = [] as any;
                for (let item of _data["unitFlareMap"])
                    this.unitFlareMap!.push(UnitAndFlareMappingDTO.fromJS(item));
            }
            else {
                this.unitFlareMap = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFacilityAndUnitMappingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetFacilityAndUnitMappingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        if (Array.isArray(this.unitFlareMap)) {
            data["unitFlareMap"] = [];
            for (let item of this.unitFlareMap)
                data["unitFlareMap"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IGetFacilityAndUnitMappingDTO {
    facility: KTLTrains;
    unitFlareMap: UnitAndFlareMappingDTO[];
}

export class UnitAndFlareMappingDTO implements IUnitAndFlareMappingDTO {
    unitType!: UnitList;
    flare!: string[];

    constructor(data?: IUnitAndFlareMappingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.flare = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitType = _data["unitType"] !== undefined ? _data["unitType"] : <any>null;
            if (Array.isArray(_data["flare"])) {
                this.flare = [] as any;
                for (let item of _data["flare"])
                    this.flare!.push(item);
            }
            else {
                this.flare = <any>null;
            }
        }
    }

    static fromJS(data: any): UnitAndFlareMappingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnitAndFlareMappingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType !== undefined ? this.unitType : <any>null;
        if (Array.isArray(this.flare)) {
            data["flare"] = [];
            for (let item of this.flare)
                data["flare"].push(item);
        }
        return data;
    }
}

export interface IUnitAndFlareMappingDTO {
    unitType: UnitList;
    flare: string[];
}

export class PagedListOfGetFlareSwitcherDTO implements IPagedListOfGetFlareSwitcherDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: GetFlareSwitcherDTO[];

    constructor(data?: IPagedListOfGetFlareSwitcherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFlareSwitcherDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfGetFlareSwitcherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetFlareSwitcherDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfGetFlareSwitcherDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: GetFlareSwitcherDTO[];
}

export class GetFlareSwitcherDTO extends FlareSwitcherDTO implements IGetFlareSwitcherDTO {
    logged?: Date | null;
    loggedBy!: string;

    constructor(data?: IGetFlareSwitcherDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.loggedBy = _data["loggedBy"] !== undefined ? _data["loggedBy"] : <any>null;
        }
    }

    static override fromJS(data: any): GetFlareSwitcherDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlareSwitcherDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["loggedBy"] = this.loggedBy !== undefined ? this.loggedBy : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFlareSwitcherDTO extends IFlareSwitcherDTO {
    logged?: Date | null;
    loggedBy: string;
}

export class ChemicalCompounds implements IChemicalCompounds {
    mw!: number;
    c1!: number;
    c2!: number;
    c2H5SH!: number;
    c3!: number;
    c4H9SH!: number;
    c6Plus!: number;
    cH3SH!: number;
    cO2!: number;
    cos!: number;
    h2O!: number;
    h2S!: number;
    iC3H7SH!: number;
    iC4!: number;
    iC5!: number;
    n2!: number;
    h2!: number;
    he!: number;
    nC3H7SH!: number;
    nC4!: number;
    nC5!: number;
    o2!: number;
    co!: number;

    constructor(data?: IChemicalCompounds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.c4H9SH = _data["c4H9SH"] !== undefined ? _data["c4H9SH"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.iC3H7SH = _data["iC3H7SH"] !== undefined ? _data["iC3H7SH"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.h2 = _data["h2"] !== undefined ? _data["h2"] : <any>null;
            this.he = _data["he"] !== undefined ? _data["he"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.co = _data["co"] !== undefined ? _data["co"] : <any>null;
        }
    }

    static fromJS(data: any): ChemicalCompounds {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCompounds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["c4H9SH"] = this.c4H9SH !== undefined ? this.c4H9SH : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["iC3H7SH"] = this.iC3H7SH !== undefined ? this.iC3H7SH : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["h2"] = this.h2 !== undefined ? this.h2 : <any>null;
        data["he"] = this.he !== undefined ? this.he : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["co"] = this.co !== undefined ? this.co : <any>null;
        return data;
    }
}

export interface IChemicalCompounds {
    mw: number;
    c1: number;
    c2: number;
    c2H5SH: number;
    c3: number;
    c4H9SH: number;
    c6Plus: number;
    cH3SH: number;
    cO2: number;
    cos: number;
    h2O: number;
    h2S: number;
    iC3H7SH: number;
    iC4: number;
    iC5: number;
    n2: number;
    h2: number;
    he: number;
    nC3H7SH: number;
    nC4: number;
    nC5: number;
    o2: number;
    co: number;
}

export class ChemicalCompoundKTLSGP extends ChemicalCompounds implements IChemicalCompoundKTLSGP {
    c2H5SSC2H5!: number;
    c3H7SSC3H7!: number;
    cH3SSCH3!: number;
    c4H9SSC4H9!: number;

    constructor(data?: IChemicalCompoundKTLSGP) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.c2H5SSC2H5 = _data["c2H5SSC2H5"] !== undefined ? _data["c2H5SSC2H5"] : <any>null;
            this.c3H7SSC3H7 = _data["c3H7SSC3H7"] !== undefined ? _data["c3H7SSC3H7"] : <any>null;
            this.cH3SSCH3 = _data["cH3SSCH3"] !== undefined ? _data["cH3SSCH3"] : <any>null;
            this.c4H9SSC4H9 = _data["c4H9SSC4H9"] !== undefined ? _data["c4H9SSC4H9"] : <any>null;
        }
    }

    static override fromJS(data: any): ChemicalCompoundKTLSGP {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCompoundKTLSGP();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c2H5SSC2H5"] = this.c2H5SSC2H5 !== undefined ? this.c2H5SSC2H5 : <any>null;
        data["c3H7SSC3H7"] = this.c3H7SSC3H7 !== undefined ? this.c3H7SSC3H7 : <any>null;
        data["cH3SSCH3"] = this.cH3SSCH3 !== undefined ? this.cH3SSCH3 : <any>null;
        data["c4H9SSC4H9"] = this.c4H9SSC4H9 !== undefined ? this.c4H9SSC4H9 : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IChemicalCompoundKTLSGP extends IChemicalCompounds {
    c2H5SSC2H5: number;
    c3H7SSC3H7: number;
    cH3SSCH3: number;
    c4H9SSC4H9: number;
}

export class InputRecordDTO extends ChemicalCompoundKTLSGP implements IInputRecordDTO {
    id!: number;
    inputType!: InputRecordType;
    streamid?: string | null;
    startTime!: Date;
    endTime?: Date | null;
    inputCategory!: string;
    inputComment!: string;
    inputReason!: string;
    totalVolume!: number;
    totalMass!: number;
    isUsingCC!: number;
    isPermitForm!: boolean;
    permitInput!: boolean;
    gasType?: string | null;
    plant?: string | null;
    flare?: string | null;
    editType?: string | null;
    ccType?: string | null;
    properties!: { [key: string]: any; };

    constructor(data?: IInputRecordDTO) {
        super(data);
        if (!data) {
            this.properties = {};
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.streamid = _data["streamid"] !== undefined ? _data["streamid"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.isUsingCC = _data["isUsingCC"] !== undefined ? _data["isUsingCC"] : <any>null;
            this.isPermitForm = _data["isPermitForm"] !== undefined ? _data["isPermitForm"] : <any>null;
            this.permitInput = _data["permitInput"] !== undefined ? _data["permitInput"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.plant = _data["plant"] !== undefined ? _data["plant"] : <any>null;
            this.flare = _data["flare"] !== undefined ? _data["flare"] : <any>null;
            this.editType = _data["editType"] !== undefined ? _data["editType"] : <any>null;
            this.ccType = _data["ccType"] !== undefined ? _data["ccType"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static override fromJS(data: any): InputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InputRecordDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["streamid"] = this.streamid !== undefined ? this.streamid : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["isUsingCC"] = this.isUsingCC !== undefined ? this.isUsingCC : <any>null;
        data["isPermitForm"] = this.isPermitForm !== undefined ? this.isPermitForm : <any>null;
        data["permitInput"] = this.permitInput !== undefined ? this.permitInput : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["plant"] = this.plant !== undefined ? this.plant : <any>null;
        data["flare"] = this.flare !== undefined ? this.flare : <any>null;
        data["editType"] = this.editType !== undefined ? this.editType : <any>null;
        data["ccType"] = this.ccType !== undefined ? this.ccType : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInputRecordDTO extends IChemicalCompoundKTLSGP {
    id: number;
    inputType: InputRecordType;
    streamid?: string | null;
    startTime: Date;
    endTime?: Date | null;
    inputCategory: string;
    inputComment: string;
    inputReason: string;
    totalVolume: number;
    totalMass: number;
    isUsingCC: number;
    isPermitForm: boolean;
    permitInput: boolean;
    gasType?: string | null;
    plant?: string | null;
    flare?: string | null;
    editType?: string | null;
    ccType?: string | null;
    properties: { [key: string]: any; };
}

export class DailyReportEditDTO implements IDailyReportEditDTO {
    streamId!: number;
    date!: Date;
    volume!: number;
    category!: string;
    reason!: string;
    comment!: string;

    constructor(data?: IDailyReportEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): DailyReportEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyReportEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IDailyReportEditDTO {
    streamId: number;
    date: Date;
    volume: number;
    category: string;
    reason: string;
    comment: string;
}

export class F205TotalDTO implements IF205TotalDTO {
    startTime!: Date;
    endTime!: Date;
    f205_1!: F205DTO;
    f205_2!: F205DTO;
    f205_3!: F205DTO;
    f205_4!: F205DTO;
    f205_5!: F205DTO;

    constructor(data?: IF205TotalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.f205_1 = new F205DTO();
            this.f205_2 = new F205DTO();
            this.f205_3 = new F205DTO();
            this.f205_4 = new F205DTO();
            this.f205_5 = new F205DTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.f205_1 = _data["f205_1"] ? F205DTO.fromJS(_data["f205_1"]) : new F205DTO();
            this.f205_2 = _data["f205_2"] ? F205DTO.fromJS(_data["f205_2"]) : new F205DTO();
            this.f205_3 = _data["f205_3"] ? F205DTO.fromJS(_data["f205_3"]) : new F205DTO();
            this.f205_4 = _data["f205_4"] ? F205DTO.fromJS(_data["f205_4"]) : new F205DTO();
            this.f205_5 = _data["f205_5"] ? F205DTO.fromJS(_data["f205_5"]) : new F205DTO();
        }
    }

    static fromJS(data: any): F205TotalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new F205TotalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["f205_1"] = this.f205_1 ? this.f205_1.toJSON() : <any>null;
        data["f205_2"] = this.f205_2 ? this.f205_2.toJSON() : <any>null;
        data["f205_3"] = this.f205_3 ? this.f205_3.toJSON() : <any>null;
        data["f205_4"] = this.f205_4 ? this.f205_4.toJSON() : <any>null;
        data["f205_5"] = this.f205_5 ? this.f205_5.toJSON() : <any>null;
        return data;
    }
}

export interface IF205TotalDTO {
    startTime: Date;
    endTime: Date;
    f205_1: F205DTO;
    f205_2: F205DTO;
    f205_3: F205DTO;
    f205_4: F205DTO;
    f205_5: F205DTO;
}

export class F205DTO implements IF205DTO {
    name!: string;
    stableCount!: number;
    unstableCount!: number;
    totalCount!: number;
    stableDeltaL!: number[];
    unstableDeltaL!: F205UnstableDTO[];
    stableCalc!: F205CalcDTO;
    unstableCalc!: F205CalcDTO;
    totalCalc!: F205TotalCalcDTO;

    constructor(data?: IF205DTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stableDeltaL = [];
            this.unstableDeltaL = [];
            this.stableCalc = new F205CalcDTO();
            this.unstableCalc = new F205CalcDTO();
            this.totalCalc = new F205TotalCalcDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.stableCount = _data["stableCount"] !== undefined ? _data["stableCount"] : <any>null;
            this.unstableCount = _data["unstableCount"] !== undefined ? _data["unstableCount"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            if (Array.isArray(_data["stableDeltaL"])) {
                this.stableDeltaL = [] as any;
                for (let item of _data["stableDeltaL"])
                    this.stableDeltaL!.push(item);
            }
            else {
                this.stableDeltaL = <any>null;
            }
            if (Array.isArray(_data["unstableDeltaL"])) {
                this.unstableDeltaL = [] as any;
                for (let item of _data["unstableDeltaL"])
                    this.unstableDeltaL!.push(F205UnstableDTO.fromJS(item));
            }
            else {
                this.unstableDeltaL = <any>null;
            }
            this.stableCalc = _data["stableCalc"] ? F205CalcDTO.fromJS(_data["stableCalc"]) : new F205CalcDTO();
            this.unstableCalc = _data["unstableCalc"] ? F205CalcDTO.fromJS(_data["unstableCalc"]) : new F205CalcDTO();
            this.totalCalc = _data["totalCalc"] ? F205TotalCalcDTO.fromJS(_data["totalCalc"]) : new F205TotalCalcDTO();
        }
    }

    static fromJS(data: any): F205DTO {
        data = typeof data === 'object' ? data : {};
        let result = new F205DTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["stableCount"] = this.stableCount !== undefined ? this.stableCount : <any>null;
        data["unstableCount"] = this.unstableCount !== undefined ? this.unstableCount : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        if (Array.isArray(this.stableDeltaL)) {
            data["stableDeltaL"] = [];
            for (let item of this.stableDeltaL)
                data["stableDeltaL"].push(item);
        }
        if (Array.isArray(this.unstableDeltaL)) {
            data["unstableDeltaL"] = [];
            for (let item of this.unstableDeltaL)
                data["unstableDeltaL"].push(item ? item.toJSON() : <any>null);
        }
        data["stableCalc"] = this.stableCalc ? this.stableCalc.toJSON() : <any>null;
        data["unstableCalc"] = this.unstableCalc ? this.unstableCalc.toJSON() : <any>null;
        data["totalCalc"] = this.totalCalc ? this.totalCalc.toJSON() : <any>null;
        return data;
    }
}

export interface IF205DTO {
    name: string;
    stableCount: number;
    unstableCount: number;
    totalCount: number;
    stableDeltaL: number[];
    unstableDeltaL: F205UnstableDTO[];
    stableCalc: F205CalcDTO;
    unstableCalc: F205CalcDTO;
    totalCalc: F205TotalCalcDTO;
}

export class F205UnstableDTO implements IF205UnstableDTO {
    value!: number;
    timeStamp!: Date;

    constructor(data?: IF205UnstableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): F205UnstableDTO {
        data = typeof data === 'object' ? data : {};
        let result = new F205UnstableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        return data;
    }
}

export interface IF205UnstableDTO {
    value: number;
    timeStamp: Date;
}

export class F205CalcDTO implements IF205CalcDTO {
    lDelta!: number;
    pAverage!: number;
    tAverage!: number;
    insideDiameter!: number;
    tangent!: number;
    l1minusL2!: number;
    l2minusBottomLine!: number;
    intermediateVals!: number[];
    heightOfLiquid!: number;
    cylindricalVolume!: number;
    numsOpenings!: number;
    headVolume!: number;
    volumeLiquid!: number;

    constructor(data?: IF205CalcDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.intermediateVals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lDelta = _data["lDelta"] !== undefined ? _data["lDelta"] : <any>null;
            this.pAverage = _data["pAverage"] !== undefined ? _data["pAverage"] : <any>null;
            this.tAverage = _data["tAverage"] !== undefined ? _data["tAverage"] : <any>null;
            this.insideDiameter = _data["insideDiameter"] !== undefined ? _data["insideDiameter"] : <any>null;
            this.tangent = _data["tangent"] !== undefined ? _data["tangent"] : <any>null;
            this.l1minusL2 = _data["l1minusL2"] !== undefined ? _data["l1minusL2"] : <any>null;
            this.l2minusBottomLine = _data["l2minusBottomLine"] !== undefined ? _data["l2minusBottomLine"] : <any>null;
            if (Array.isArray(_data["intermediateVals"])) {
                this.intermediateVals = [] as any;
                for (let item of _data["intermediateVals"])
                    this.intermediateVals!.push(item);
            }
            else {
                this.intermediateVals = <any>null;
            }
            this.heightOfLiquid = _data["heightOfLiquid"] !== undefined ? _data["heightOfLiquid"] : <any>null;
            this.cylindricalVolume = _data["cylindricalVolume"] !== undefined ? _data["cylindricalVolume"] : <any>null;
            this.numsOpenings = _data["numsOpenings"] !== undefined ? _data["numsOpenings"] : <any>null;
            this.headVolume = _data["headVolume"] !== undefined ? _data["headVolume"] : <any>null;
            this.volumeLiquid = _data["volumeLiquid"] !== undefined ? _data["volumeLiquid"] : <any>null;
        }
    }

    static fromJS(data: any): F205CalcDTO {
        data = typeof data === 'object' ? data : {};
        let result = new F205CalcDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lDelta"] = this.lDelta !== undefined ? this.lDelta : <any>null;
        data["pAverage"] = this.pAverage !== undefined ? this.pAverage : <any>null;
        data["tAverage"] = this.tAverage !== undefined ? this.tAverage : <any>null;
        data["insideDiameter"] = this.insideDiameter !== undefined ? this.insideDiameter : <any>null;
        data["tangent"] = this.tangent !== undefined ? this.tangent : <any>null;
        data["l1minusL2"] = this.l1minusL2 !== undefined ? this.l1minusL2 : <any>null;
        data["l2minusBottomLine"] = this.l2minusBottomLine !== undefined ? this.l2minusBottomLine : <any>null;
        if (Array.isArray(this.intermediateVals)) {
            data["intermediateVals"] = [];
            for (let item of this.intermediateVals)
                data["intermediateVals"].push(item);
        }
        data["heightOfLiquid"] = this.heightOfLiquid !== undefined ? this.heightOfLiquid : <any>null;
        data["cylindricalVolume"] = this.cylindricalVolume !== undefined ? this.cylindricalVolume : <any>null;
        data["numsOpenings"] = this.numsOpenings !== undefined ? this.numsOpenings : <any>null;
        data["headVolume"] = this.headVolume !== undefined ? this.headVolume : <any>null;
        data["volumeLiquid"] = this.volumeLiquid !== undefined ? this.volumeLiquid : <any>null;
        return data;
    }
}

export interface IF205CalcDTO {
    lDelta: number;
    pAverage: number;
    tAverage: number;
    insideDiameter: number;
    tangent: number;
    l1minusL2: number;
    l2minusBottomLine: number;
    intermediateVals: number[];
    heightOfLiquid: number;
    cylindricalVolume: number;
    numsOpenings: number;
    headVolume: number;
    volumeLiquid: number;
}

export class F205TotalCalcDTO implements IF205TotalCalcDTO {
    totalLiqVolume!: number;
    liquidN!: number;
    liquidFromF205!: number;
    massDensity!: number;
    molarFlow!: number;
    gasMolarFlow!: number;
    gasN!: number;
    volumeOfFlaredGaskNm3!: number;
    molWeightOfFlaredGas!: number;
    massOfFlaredGasTon!: number;

    constructor(data?: IF205TotalCalcDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLiqVolume = _data["totalLiqVolume"] !== undefined ? _data["totalLiqVolume"] : <any>null;
            this.liquidN = _data["liquidN"] !== undefined ? _data["liquidN"] : <any>null;
            this.liquidFromF205 = _data["liquidFromF205"] !== undefined ? _data["liquidFromF205"] : <any>null;
            this.massDensity = _data["massDensity"] !== undefined ? _data["massDensity"] : <any>null;
            this.molarFlow = _data["molarFlow"] !== undefined ? _data["molarFlow"] : <any>null;
            this.gasMolarFlow = _data["gasMolarFlow"] !== undefined ? _data["gasMolarFlow"] : <any>null;
            this.gasN = _data["gasN"] !== undefined ? _data["gasN"] : <any>null;
            this.volumeOfFlaredGaskNm3 = _data["volumeOfFlaredGaskNm3"] !== undefined ? _data["volumeOfFlaredGaskNm3"] : <any>null;
            this.molWeightOfFlaredGas = _data["molWeightOfFlaredGas"] !== undefined ? _data["molWeightOfFlaredGas"] : <any>null;
            this.massOfFlaredGasTon = _data["massOfFlaredGasTon"] !== undefined ? _data["massOfFlaredGasTon"] : <any>null;
        }
    }

    static fromJS(data: any): F205TotalCalcDTO {
        data = typeof data === 'object' ? data : {};
        let result = new F205TotalCalcDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLiqVolume"] = this.totalLiqVolume !== undefined ? this.totalLiqVolume : <any>null;
        data["liquidN"] = this.liquidN !== undefined ? this.liquidN : <any>null;
        data["liquidFromF205"] = this.liquidFromF205 !== undefined ? this.liquidFromF205 : <any>null;
        data["massDensity"] = this.massDensity !== undefined ? this.massDensity : <any>null;
        data["molarFlow"] = this.molarFlow !== undefined ? this.molarFlow : <any>null;
        data["gasMolarFlow"] = this.gasMolarFlow !== undefined ? this.gasMolarFlow : <any>null;
        data["gasN"] = this.gasN !== undefined ? this.gasN : <any>null;
        data["volumeOfFlaredGaskNm3"] = this.volumeOfFlaredGaskNm3 !== undefined ? this.volumeOfFlaredGaskNm3 : <any>null;
        data["molWeightOfFlaredGas"] = this.molWeightOfFlaredGas !== undefined ? this.molWeightOfFlaredGas : <any>null;
        data["massOfFlaredGasTon"] = this.massOfFlaredGasTon !== undefined ? this.massOfFlaredGasTon : <any>null;
        return data;
    }
}

export interface IF205TotalCalcDTO {
    totalLiqVolume: number;
    liquidN: number;
    liquidFromF205: number;
    massDensity: number;
    molarFlow: number;
    gasMolarFlow: number;
    gasN: number;
    volumeOfFlaredGaskNm3: number;
    molWeightOfFlaredGas: number;
    massOfFlaredGasTon: number;
}

export class DailyReportDTO implements IDailyReportDTO {
    report!: ReportDTO[];
    totalVolume!: number;
    totalMass!: number;

    constructor(data?: IDailyReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.report = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["report"])) {
                this.report = [] as any;
                for (let item of _data["report"])
                    this.report!.push(ReportDTO.fromJS(item));
            }
            else {
                this.report = <any>null;
            }
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
        }
    }

    static fromJS(data: any): DailyReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailyReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.report)) {
            data["report"] = [];
            for (let item of this.report)
                data["report"].push(item ? item.toJSON() : <any>null);
        }
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        return data;
    }
}

export interface IDailyReportDTO {
    report: ReportDTO[];
    totalVolume: number;
    totalMass: number;
}

export class ReportDTO implements IReportDTO {
    streamId!: number;
    streamName!: string;
    function!: string;
    flareName!: string;
    gasType!: string;
    groupType!: string;
    startTime!: Date;
    endTime?: Date | null;
    timeStamp!: Date;
    onStreamTime!: number;
    totalVolume!: number;
    totalMass!: number;
    inputCategory!: string;
    inputComment!: string;
    inputReason!: string;
    state!: string;
    bypassable!: boolean;
    bypassed!: boolean;
    childStreams!: ReportDTO[];

    constructor(data?: IReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.childStreams = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.function = _data["function"] !== undefined ? _data["function"] : <any>null;
            this.flareName = _data["flareName"] !== undefined ? _data["flareName"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.groupType = _data["groupType"] !== undefined ? _data["groupType"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.onStreamTime = _data["onStreamTime"] !== undefined ? _data["onStreamTime"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.bypassable = _data["bypassable"] !== undefined ? _data["bypassable"] : <any>null;
            this.bypassed = _data["bypassed"] !== undefined ? _data["bypassed"] : <any>null;
            if (Array.isArray(_data["childStreams"])) {
                this.childStreams = [] as any;
                for (let item of _data["childStreams"])
                    this.childStreams!.push(ReportDTO.fromJS(item));
            }
            else {
                this.childStreams = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["function"] = this.function !== undefined ? this.function : <any>null;
        data["flareName"] = this.flareName !== undefined ? this.flareName : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["groupType"] = this.groupType !== undefined ? this.groupType : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["onStreamTime"] = this.onStreamTime !== undefined ? this.onStreamTime : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["bypassable"] = this.bypassable !== undefined ? this.bypassable : <any>null;
        data["bypassed"] = this.bypassed !== undefined ? this.bypassed : <any>null;
        if (Array.isArray(this.childStreams)) {
            data["childStreams"] = [];
            for (let item of this.childStreams)
                data["childStreams"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IReportDTO {
    streamId: number;
    streamName: string;
    function: string;
    flareName: string;
    gasType: string;
    groupType: string;
    startTime: Date;
    endTime?: Date | null;
    timeStamp: Date;
    onStreamTime: number;
    totalVolume: number;
    totalMass: number;
    inputCategory: string;
    inputComment: string;
    inputReason: string;
    state: string;
    bypassable: boolean;
    bypassed: boolean;
    childStreams: ReportDTO[];
}

export class PagedListOfInputHistoryDTO implements IPagedListOfInputHistoryDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: InputHistoryDTO[];

    constructor(data?: IPagedListOfInputHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InputHistoryDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfInputHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfInputHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfInputHistoryDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: InputHistoryDTO[];
}

export class CCBase implements ICCBase {
    mw!: number;
    c1!: number;
    c2!: number;
    c2H5SH!: number;
    c3!: number;
    c4H9SH!: number;
    c6Plus!: number;
    cH3SH!: number;
    cO2!: number;
    cos!: number;
    h2O!: number;
    h2S!: number;
    iC3H7SH!: number;
    iC4!: number;
    iC5!: number;
    n2!: number;
    nC3H7SH!: number;
    nC4!: number;
    nC5!: number;
    o2!: number;

    constructor(data?: ICCBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.c4H9SH = _data["c4H9SH"] !== undefined ? _data["c4H9SH"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.iC3H7SH = _data["iC3H7SH"] !== undefined ? _data["iC3H7SH"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
        }
    }

    static fromJS(data: any): CCBase {
        data = typeof data === 'object' ? data : {};
        let result = new CCBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["c4H9SH"] = this.c4H9SH !== undefined ? this.c4H9SH : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["iC3H7SH"] = this.iC3H7SH !== undefined ? this.iC3H7SH : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        return data;
    }
}

export interface ICCBase {
    mw: number;
    c1: number;
    c2: number;
    c2H5SH: number;
    c3: number;
    c4H9SH: number;
    c6Plus: number;
    cH3SH: number;
    cO2: number;
    cos: number;
    h2O: number;
    h2S: number;
    iC3H7SH: number;
    iC4: number;
    iC5: number;
    n2: number;
    nC3H7SH: number;
    nC4: number;
    nC5: number;
    o2: number;
}

export class CCBaseKTLSGP extends CCBase implements ICCBaseKTLSGP {
    c2H5SSC2H5!: number;
    c3H7SSC3H7!: number;
    cH3SSCH3!: number;
    c4H9SSC4H9!: number;
    h2!: number;
    co!: number;

    constructor(data?: ICCBaseKTLSGP) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.c2H5SSC2H5 = _data["c2H5SSC2H5"] !== undefined ? _data["c2H5SSC2H5"] : <any>null;
            this.c3H7SSC3H7 = _data["c3H7SSC3H7"] !== undefined ? _data["c3H7SSC3H7"] : <any>null;
            this.cH3SSCH3 = _data["cH3SSCH3"] !== undefined ? _data["cH3SSCH3"] : <any>null;
            this.c4H9SSC4H9 = _data["c4H9SSC4H9"] !== undefined ? _data["c4H9SSC4H9"] : <any>null;
            this.h2 = _data["h2"] !== undefined ? _data["h2"] : <any>null;
            this.co = _data["co"] !== undefined ? _data["co"] : <any>null;
        }
    }

    static override fromJS(data: any): CCBaseKTLSGP {
        data = typeof data === 'object' ? data : {};
        let result = new CCBaseKTLSGP();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c2H5SSC2H5"] = this.c2H5SSC2H5 !== undefined ? this.c2H5SSC2H5 : <any>null;
        data["c3H7SSC3H7"] = this.c3H7SSC3H7 !== undefined ? this.c3H7SSC3H7 : <any>null;
        data["cH3SSCH3"] = this.cH3SSCH3 !== undefined ? this.cH3SSCH3 : <any>null;
        data["c4H9SSC4H9"] = this.c4H9SSC4H9 !== undefined ? this.c4H9SSC4H9 : <any>null;
        data["h2"] = this.h2 !== undefined ? this.h2 : <any>null;
        data["co"] = this.co !== undefined ? this.co : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICCBaseKTLSGP extends ICCBase {
    c2H5SSC2H5: number;
    c3H7SSC3H7: number;
    cH3SSCH3: number;
    c4H9SSC4H9: number;
    h2: number;
    co: number;
}

export class InputHistoryDTO extends CCBaseKTLSGP implements IInputHistoryDTO {
    id!: number;
    streamId!: number;
    streamName!: string;
    flareName!: string;
    function!: string;
    gasType!: string;
    startTime!: Date;
    endTime?: Date | null;
    inputCategory!: string;
    inputComment!: string;
    inputReason!: string;
    active!: number;
    totalVolume!: number;
    totalMass!: number;
    logged!: Date;
    user!: string;
    inputType!: string;
    isPermitForm!: boolean;
    isUsingCC!: number;

    constructor(data?: IInputHistoryDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.flareName = _data["flareName"] !== undefined ? _data["flareName"] : <any>null;
            this.function = _data["function"] !== undefined ? _data["function"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.isPermitForm = _data["isPermitForm"] !== undefined ? _data["isPermitForm"] : <any>null;
            this.isUsingCC = _data["isUsingCC"] !== undefined ? _data["isUsingCC"] : <any>null;
        }
    }

    static override fromJS(data: any): InputHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InputHistoryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["flareName"] = this.flareName !== undefined ? this.flareName : <any>null;
        data["function"] = this.function !== undefined ? this.function : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["isPermitForm"] = this.isPermitForm !== undefined ? this.isPermitForm : <any>null;
        data["isUsingCC"] = this.isUsingCC !== undefined ? this.isUsingCC : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInputHistoryDTO extends ICCBaseKTLSGP {
    id: number;
    streamId: number;
    streamName: string;
    flareName: string;
    function: string;
    gasType: string;
    startTime: Date;
    endTime?: Date | null;
    inputCategory: string;
    inputComment: string;
    inputReason: string;
    active: number;
    totalVolume: number;
    totalMass: number;
    logged: Date;
    user: string;
    inputType: string;
    isPermitForm: boolean;
    isUsingCC: number;
}

export class ChemicalCompoundsDTO extends CCBaseKTLSGP implements IChemicalCompoundsDTO {
    id!: number;
    stream!: string;
    gasType!: string;

    constructor(data?: IChemicalCompoundsDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.stream = _data["stream"] !== undefined ? _data["stream"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
        }
    }

    static override fromJS(data: any): ChemicalCompoundsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCompoundsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["stream"] = this.stream !== undefined ? this.stream : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IChemicalCompoundsDTO extends ICCBaseKTLSGP {
    id: number;
    stream: string;
    gasType: string;
}

export class ChemicalCompoundsEquipmentDTO implements IChemicalCompoundsEquipmentDTO {
    id!: number;
    equipment!: string;
    volume!: number;
    mass!: number;
    gasType!: string;
    sourceComposition!: string;
    mw!: number;
    n2!: number;
    cO2!: number;
    c1!: number;
    c2!: number;
    c3!: number;
    iC4!: number;
    nC4!: number;
    iC5!: number;
    nC5!: number;
    c6Plus!: number;
    h2S!: number;
    cH3SH!: number;
    c2H5SH!: number;
    iC3H7SH!: number;
    nC3H7SH!: number;
    c4H9SH!: number;
    h2O!: number;
    cos!: number;
    o2!: number;
    blowingReasonType?: BlowingReasonType | null;
    collectorType?: CollectorType | null;
    trains?: string | null;
    unit?: UnitList | null;
    equipmentCategory?: PermitTargetInputCategory | null;

    constructor(data?: IChemicalCompoundsEquipmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.equipment = _data["equipment"] !== undefined ? _data["equipment"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.sourceComposition = _data["sourceComposition"] !== undefined ? _data["sourceComposition"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.iC3H7SH = _data["iC3H7SH"] !== undefined ? _data["iC3H7SH"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.c4H9SH = _data["c4H9SH"] !== undefined ? _data["c4H9SH"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.blowingReasonType = _data["blowingReasonType"] !== undefined ? _data["blowingReasonType"] : <any>null;
            this.collectorType = _data["collectorType"] !== undefined ? _data["collectorType"] : <any>null;
            this.trains = _data["trains"] !== undefined ? _data["trains"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.equipmentCategory = _data["equipmentCategory"] !== undefined ? _data["equipmentCategory"] : <any>null;
        }
    }

    static fromJS(data: any): ChemicalCompoundsEquipmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCompoundsEquipmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["equipment"] = this.equipment !== undefined ? this.equipment : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["sourceComposition"] = this.sourceComposition !== undefined ? this.sourceComposition : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["iC3H7SH"] = this.iC3H7SH !== undefined ? this.iC3H7SH : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["c4H9SH"] = this.c4H9SH !== undefined ? this.c4H9SH : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["blowingReasonType"] = this.blowingReasonType !== undefined ? this.blowingReasonType : <any>null;
        data["collectorType"] = this.collectorType !== undefined ? this.collectorType : <any>null;
        data["trains"] = this.trains !== undefined ? this.trains : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["equipmentCategory"] = this.equipmentCategory !== undefined ? this.equipmentCategory : <any>null;
        return data;
    }
}

export interface IChemicalCompoundsEquipmentDTO {
    id: number;
    equipment: string;
    volume: number;
    mass: number;
    gasType: string;
    sourceComposition: string;
    mw: number;
    n2: number;
    cO2: number;
    c1: number;
    c2: number;
    c3: number;
    iC4: number;
    nC4: number;
    iC5: number;
    nC5: number;
    c6Plus: number;
    h2S: number;
    cH3SH: number;
    c2H5SH: number;
    iC3H7SH: number;
    nC3H7SH: number;
    c4H9SH: number;
    h2O: number;
    cos: number;
    o2: number;
    blowingReasonType?: BlowingReasonType | null;
    collectorType?: CollectorType | null;
    trains?: string | null;
    unit?: UnitList | null;
    equipmentCategory?: PermitTargetInputCategory | null;
}

export enum BlowingReasonType {
    FilterReplacement = 0,
    HeavyHCDrainage = 1,
    Maintenance = 2,
    Other = 3,
}

export enum CollectorType {
    BD = 0,
    BF = 1,
    BFH = 2,
    DHC = 3,
    BDBF = 4,
}

export enum PermitTargetInputCategory {
    V6 = 0,
    V7 = 1,
    V8 = 2,
    V9 = 3,
}

export enum TrainList {
    KtlTrainOne = 1,
    KtlTrainTwo = 2,
    KtlTrainThree = 3,
    KtlTrainFour = 4,
    KtlTrainFive = 5,
    KTLTrainOneAndTwo = 6,
    KTLTrainThreeAndFour = 7,
}

export class ValueTupleOfIntegerAndString implements IValueTupleOfIntegerAndString {

    constructor(data?: IValueTupleOfIntegerAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueTupleOfIntegerAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfIntegerAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueTupleOfIntegerAndString {
}

export class KTLSGPGasBalanceDTO implements IKTLSGPGasBalanceDTO {
    gasBalance!: number;
    rateTotal!: number;
    difference!: number;
    differencePct!: number;

    constructor(data?: IKTLSGPGasBalanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gasBalance = _data["gasBalance"] !== undefined ? _data["gasBalance"] : <any>null;
            this.rateTotal = _data["rateTotal"] !== undefined ? _data["rateTotal"] : <any>null;
            this.difference = _data["difference"] !== undefined ? _data["difference"] : <any>null;
            this.differencePct = _data["differencePct"] !== undefined ? _data["differencePct"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPGasBalanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPGasBalanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gasBalance"] = this.gasBalance !== undefined ? this.gasBalance : <any>null;
        data["rateTotal"] = this.rateTotal !== undefined ? this.rateTotal : <any>null;
        data["difference"] = this.difference !== undefined ? this.difference : <any>null;
        data["differencePct"] = this.differencePct !== undefined ? this.differencePct : <any>null;
        return data;
    }
}

export interface IKTLSGPGasBalanceDTO {
    gasBalance: number;
    rateTotal: number;
    difference: number;
    differencePct: number;
}

export class ChemicalCompoundRecord implements IChemicalCompoundRecord {
    name!: string;
    cc!: ChemicalCompounds;
    timeStamp!: Date;

    constructor(data?: IChemicalCompoundRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cc = new ChemicalCompounds();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.cc = _data["cc"] ? ChemicalCompounds.fromJS(_data["cc"]) : new ChemicalCompounds();
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ChemicalCompoundRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCompoundRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["cc"] = this.cc ? this.cc.toJSON() : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        return data;
    }
}

export interface IChemicalCompoundRecord {
    name: string;
    cc: ChemicalCompounds;
    timeStamp: Date;
}

export class GetGURDTO implements IGetGURDTO {
    hrsgOpc!: string;
    hrsgTpc!: string;
    pUpc!: string;
    gtOpc!: string;
    gtTpc!: string;
    gur!: GURDTO[];

    constructor(data?: IGetGURDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.gur = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hrsgOpc = _data["hrsgOpc"] !== undefined ? _data["hrsgOpc"] : <any>null;
            this.hrsgTpc = _data["hrsgTpc"] !== undefined ? _data["hrsgTpc"] : <any>null;
            this.pUpc = _data["pUpc"] !== undefined ? _data["pUpc"] : <any>null;
            this.gtOpc = _data["gtOpc"] !== undefined ? _data["gtOpc"] : <any>null;
            this.gtTpc = _data["gtTpc"] !== undefined ? _data["gtTpc"] : <any>null;
            if (Array.isArray(_data["gur"])) {
                this.gur = [] as any;
                for (let item of _data["gur"])
                    this.gur!.push(GURDTO.fromJS(item));
            }
            else {
                this.gur = <any>null;
            }
        }
    }

    static fromJS(data: any): GetGURDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetGURDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hrsgOpc"] = this.hrsgOpc !== undefined ? this.hrsgOpc : <any>null;
        data["hrsgTpc"] = this.hrsgTpc !== undefined ? this.hrsgTpc : <any>null;
        data["pUpc"] = this.pUpc !== undefined ? this.pUpc : <any>null;
        data["gtOpc"] = this.gtOpc !== undefined ? this.gtOpc : <any>null;
        data["gtTpc"] = this.gtTpc !== undefined ? this.gtTpc : <any>null;
        if (Array.isArray(this.gur)) {
            data["gur"] = [];
            for (let item of this.gur)
                data["gur"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IGetGURDTO {
    hrsgOpc: string;
    hrsgTpc: string;
    pUpc: string;
    gtOpc: string;
    gtTpc: string;
    gur: GURDTO[];
}

export class GURDTO implements IGURDTO {
    timeStamp!: string;
    /** KTL + SGP, Volume Credibles Daily */
    measuredGas!: number;
    measuredGas21!: number;
    /** GT1 Allocated Volume */
    gtoVolume!: number;
    /** GT2 Allocated Volume */
    gtTwVolume!: number;
    /** GT1 Run time */
    gtoRuntime!: number;
    /** GT2 Run time */
    gttRuntime!: number;
    /** HRSG-1 Allocated Volume */
    hrsgoVolume!: number;
    /** HRSG-2 Allocated Volume */
    hrsgtVolume!: number;
    /** HRSG-1 Run time */
    hrsgoRuntime!: number;
    /** HRSG-2 Run time */
    hrsgtRuntime!: number;
    buranBoilerVolume!: number;
    /** PU-9147 Allocated Volume */
    puVolume!: number;
    /** PU-9147 Run time */
    puRuntime!: number;
    /** KTL Volume */
    fGtoPPKTL!: number;
    /** SGP Volume */
    fGtoPPSGP!: number;
    pilotVolume!: number;
    purgedVolume!: number;
    /** Volume Measured Daily */
    fGtoPP!: number;
    /** Credible-Measured Deviation */
    ktlfGtoPP!: number;

    constructor(data?: IGURDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] !== undefined ? _data["timeStamp"] : <any>null;
            this.measuredGas = _data["measuredGas"] !== undefined ? _data["measuredGas"] : <any>null;
            this.measuredGas21 = _data["measuredGas21"] !== undefined ? _data["measuredGas21"] : <any>null;
            this.gtoVolume = _data["gtoVolume"] !== undefined ? _data["gtoVolume"] : <any>null;
            this.gtTwVolume = _data["gtTwVolume"] !== undefined ? _data["gtTwVolume"] : <any>null;
            this.gtoRuntime = _data["gtoRuntime"] !== undefined ? _data["gtoRuntime"] : <any>null;
            this.gttRuntime = _data["gttRuntime"] !== undefined ? _data["gttRuntime"] : <any>null;
            this.hrsgoVolume = _data["hrsgoVolume"] !== undefined ? _data["hrsgoVolume"] : <any>null;
            this.hrsgtVolume = _data["hrsgtVolume"] !== undefined ? _data["hrsgtVolume"] : <any>null;
            this.hrsgoRuntime = _data["hrsgoRuntime"] !== undefined ? _data["hrsgoRuntime"] : <any>null;
            this.hrsgtRuntime = _data["hrsgtRuntime"] !== undefined ? _data["hrsgtRuntime"] : <any>null;
            this.buranBoilerVolume = _data["buranBoilerVolume"] !== undefined ? _data["buranBoilerVolume"] : <any>null;
            this.puVolume = _data["puVolume"] !== undefined ? _data["puVolume"] : <any>null;
            this.puRuntime = _data["puRuntime"] !== undefined ? _data["puRuntime"] : <any>null;
            this.fGtoPPKTL = _data["fGtoPPKTL"] !== undefined ? _data["fGtoPPKTL"] : <any>null;
            this.fGtoPPSGP = _data["fGtoPPSGP"] !== undefined ? _data["fGtoPPSGP"] : <any>null;
            this.pilotVolume = _data["pilotVolume"] !== undefined ? _data["pilotVolume"] : <any>null;
            this.purgedVolume = _data["purgedVolume"] !== undefined ? _data["purgedVolume"] : <any>null;
            this.fGtoPP = _data["fGtoPP"] !== undefined ? _data["fGtoPP"] : <any>null;
            this.ktlfGtoPP = _data["ktlfGtoPP"] !== undefined ? _data["ktlfGtoPP"] : <any>null;
        }
    }

    static fromJS(data: any): GURDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GURDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp !== undefined ? this.timeStamp : <any>null;
        data["measuredGas"] = this.measuredGas !== undefined ? this.measuredGas : <any>null;
        data["measuredGas21"] = this.measuredGas21 !== undefined ? this.measuredGas21 : <any>null;
        data["gtoVolume"] = this.gtoVolume !== undefined ? this.gtoVolume : <any>null;
        data["gtTwVolume"] = this.gtTwVolume !== undefined ? this.gtTwVolume : <any>null;
        data["gtoRuntime"] = this.gtoRuntime !== undefined ? this.gtoRuntime : <any>null;
        data["gttRuntime"] = this.gttRuntime !== undefined ? this.gttRuntime : <any>null;
        data["hrsgoVolume"] = this.hrsgoVolume !== undefined ? this.hrsgoVolume : <any>null;
        data["hrsgtVolume"] = this.hrsgtVolume !== undefined ? this.hrsgtVolume : <any>null;
        data["hrsgoRuntime"] = this.hrsgoRuntime !== undefined ? this.hrsgoRuntime : <any>null;
        data["hrsgtRuntime"] = this.hrsgtRuntime !== undefined ? this.hrsgtRuntime : <any>null;
        data["buranBoilerVolume"] = this.buranBoilerVolume !== undefined ? this.buranBoilerVolume : <any>null;
        data["puVolume"] = this.puVolume !== undefined ? this.puVolume : <any>null;
        data["puRuntime"] = this.puRuntime !== undefined ? this.puRuntime : <any>null;
        data["fGtoPPKTL"] = this.fGtoPPKTL !== undefined ? this.fGtoPPKTL : <any>null;
        data["fGtoPPSGP"] = this.fGtoPPSGP !== undefined ? this.fGtoPPSGP : <any>null;
        data["pilotVolume"] = this.pilotVolume !== undefined ? this.pilotVolume : <any>null;
        data["purgedVolume"] = this.purgedVolume !== undefined ? this.purgedVolume : <any>null;
        data["fGtoPP"] = this.fGtoPP !== undefined ? this.fGtoPP : <any>null;
        data["ktlfGtoPP"] = this.ktlfGtoPP !== undefined ? this.ktlfGtoPP : <any>null;
        return data;
    }
}

export interface IGURDTO {
    timeStamp: string;
    /** KTL + SGP, Volume Credibles Daily */
    measuredGas: number;
    measuredGas21: number;
    /** GT1 Allocated Volume */
    gtoVolume: number;
    /** GT2 Allocated Volume */
    gtTwVolume: number;
    /** GT1 Run time */
    gtoRuntime: number;
    /** GT2 Run time */
    gttRuntime: number;
    /** HRSG-1 Allocated Volume */
    hrsgoVolume: number;
    /** HRSG-2 Allocated Volume */
    hrsgtVolume: number;
    /** HRSG-1 Run time */
    hrsgoRuntime: number;
    /** HRSG-2 Run time */
    hrsgtRuntime: number;
    buranBoilerVolume: number;
    /** PU-9147 Allocated Volume */
    puVolume: number;
    /** PU-9147 Run time */
    puRuntime: number;
    /** KTL Volume */
    fGtoPPKTL: number;
    /** SGP Volume */
    fGtoPPSGP: number;
    pilotVolume: number;
    purgedVolume: number;
    /** Volume Measured Daily */
    fGtoPP: number;
    /** Credible-Measured Deviation */
    ktlfGtoPP: number;
}

export class GURInputRecordDTO implements IGURInputRecordDTO {
    id!: number;
    startTime!: Date;
    value!: number;
    type!: GURInputRecordType;
    runtime!: number;
    isdelete!: boolean;

    constructor(data?: IGURInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.runtime = _data["runtime"] !== undefined ? _data["runtime"] : <any>null;
            this.isdelete = _data["isdelete"] !== undefined ? _data["isdelete"] : <any>null;
        }
    }

    static fromJS(data: any): GURInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GURInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["runtime"] = this.runtime !== undefined ? this.runtime : <any>null;
        data["isdelete"] = this.isdelete !== undefined ? this.isdelete : <any>null;
        return data;
    }
}

export interface IGURInputRecordDTO {
    id: number;
    startTime: Date;
    value: number;
    type: GURInputRecordType;
    runtime: number;
    isdelete: boolean;
}

export enum GURInputRecordType {
    GTO = 0,
    GTT = 1,
    HRSGO = 2,
    HRSGT = 3,
    PURuntime = 4,
    FGKTL = 5,
    FGSGP = 6,
    VolumeBB = 7,
}

export class KTLSGPPermitTargetInputDTO implements IKTLSGPPermitTargetInputDTO {
    id!: number;
    startTime!: Date;
    targetPermitType!: PermitTargetInputType;
    plant!: Plant;
    inputType!: PermitTargetInput;
    inputValue!: PermitTargetInputValue;
    year?: number | null;
    jan?: number | null;
    feb?: number | null;
    mar?: number | null;
    apr?: number | null;
    may?: number | null;
    jun?: number | null;
    jul?: number | null;
    aug?: number | null;
    sep?: number | null;
    oct?: number | null;
    nov?: number | null;
    dec?: number | null;
    properties!: { [key: string]: any; };

    constructor(data?: IKTLSGPPermitTargetInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.targetPermitType = _data["targetPermitType"] !== undefined ? _data["targetPermitType"] : <any>null;
            this.plant = _data["plant"] !== undefined ? _data["plant"] : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.inputValue = _data["inputValue"] !== undefined ? _data["inputValue"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.jan = _data["jan"] !== undefined ? _data["jan"] : <any>null;
            this.feb = _data["feb"] !== undefined ? _data["feb"] : <any>null;
            this.mar = _data["mar"] !== undefined ? _data["mar"] : <any>null;
            this.apr = _data["apr"] !== undefined ? _data["apr"] : <any>null;
            this.may = _data["may"] !== undefined ? _data["may"] : <any>null;
            this.jun = _data["jun"] !== undefined ? _data["jun"] : <any>null;
            this.jul = _data["jul"] !== undefined ? _data["jul"] : <any>null;
            this.aug = _data["aug"] !== undefined ? _data["aug"] : <any>null;
            this.sep = _data["sep"] !== undefined ? _data["sep"] : <any>null;
            this.oct = _data["oct"] !== undefined ? _data["oct"] : <any>null;
            this.nov = _data["nov"] !== undefined ? _data["nov"] : <any>null;
            this.dec = _data["dec"] !== undefined ? _data["dec"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): KTLSGPPermitTargetInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPPermitTargetInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["targetPermitType"] = this.targetPermitType !== undefined ? this.targetPermitType : <any>null;
        data["plant"] = this.plant !== undefined ? this.plant : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["inputValue"] = this.inputValue !== undefined ? this.inputValue : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["jan"] = this.jan !== undefined ? this.jan : <any>null;
        data["feb"] = this.feb !== undefined ? this.feb : <any>null;
        data["mar"] = this.mar !== undefined ? this.mar : <any>null;
        data["apr"] = this.apr !== undefined ? this.apr : <any>null;
        data["may"] = this.may !== undefined ? this.may : <any>null;
        data["jun"] = this.jun !== undefined ? this.jun : <any>null;
        data["jul"] = this.jul !== undefined ? this.jul : <any>null;
        data["aug"] = this.aug !== undefined ? this.aug : <any>null;
        data["sep"] = this.sep !== undefined ? this.sep : <any>null;
        data["oct"] = this.oct !== undefined ? this.oct : <any>null;
        data["nov"] = this.nov !== undefined ? this.nov : <any>null;
        data["dec"] = this.dec !== undefined ? this.dec : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IKTLSGPPermitTargetInputDTO {
    id: number;
    startTime: Date;
    targetPermitType: PermitTargetInputType;
    plant: Plant;
    inputType: PermitTargetInput;
    inputValue: PermitTargetInputValue;
    year?: number | null;
    jan?: number | null;
    feb?: number | null;
    mar?: number | null;
    apr?: number | null;
    may?: number | null;
    jun?: number | null;
    jul?: number | null;
    aug?: number | null;
    sep?: number | null;
    oct?: number | null;
    nov?: number | null;
    dec?: number | null;
    properties: { [key: string]: any; };
}

export enum PermitTargetInput {
    Category = 0,
    Total = 1,
    Flares = 2,
    GasType = 3,
    F750 = 4,
    SO2Emissions = 5,
    Leakage = 6,
}

export enum PermitTargetInputValue {
    V6 = 0,
    V7 = 1,
    V8 = 2,
    V9 = 3,
    Total = 4,
    HP = 5,
    LP = 6,
    T200 = 7,
    T201 = 8,
    T1 = 9,
    T2 = 10,
    T3 = 11,
    T4 = 12,
    T5 = 13,
    ACID = 14,
    BUTANE = 15,
    DRY = 16,
    PROPANE = 17,
    SOUR = 18,
    SWEET = 19,
    F750 = 20,
    SO2Emissions = 21,
    KTL1Emissions = 22,
    KTL2Emissions = 23,
    LeakageTotal = 24,
    LPReserve = 25,
}

export class PagedListOfKTLSGPStreamMWDTO implements IPagedListOfKTLSGPStreamMWDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: KTLSGPStreamMWDTO[];

    constructor(data?: IPagedListOfKTLSGPStreamMWDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KTLSGPStreamMWDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfKTLSGPStreamMWDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfKTLSGPStreamMWDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfKTLSGPStreamMWDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: KTLSGPStreamMWDTO[];
}

export class KTLSGPStreamMWDTO implements IKTLSGPStreamMWDTO {
    id!: number;
    streamName!: string;
    mwValue!: number;

    constructor(data?: IKTLSGPStreamMWDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.mwValue = _data["mwValue"] !== undefined ? _data["mwValue"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPStreamMWDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPStreamMWDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["mwValue"] = this.mwValue !== undefined ? this.mwValue : <any>null;
        return data;
    }
}

export interface IKTLSGPStreamMWDTO {
    id: number;
    streamName: string;
    mwValue: number;
}

export class KTLSGPStreamDTO implements IKTLSGPStreamDTO {
    id!: number;
    streamName!: string;
    flareName!: string;
    function!: string;
    gasType!: string;
    isVolumeFirst!: boolean;
    inputType!: KTLSGPStreamInputType;
    groupType!: StreamGroupType;
    limsType!: LIMSType;
    ccId?: number | null;
    defaultMW!: number;
    switchable!: boolean;
    bypassable!: boolean;

    constructor(data?: IKTLSGPStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.flareName = _data["flareName"] !== undefined ? _data["flareName"] : <any>null;
            this.function = _data["function"] !== undefined ? _data["function"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.isVolumeFirst = _data["isVolumeFirst"] !== undefined ? _data["isVolumeFirst"] : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.groupType = _data["groupType"] !== undefined ? _data["groupType"] : <any>null;
            this.limsType = _data["limsType"] !== undefined ? _data["limsType"] : <any>null;
            this.ccId = _data["ccId"] !== undefined ? _data["ccId"] : <any>null;
            this.defaultMW = _data["defaultMW"] !== undefined ? _data["defaultMW"] : <any>null;
            this.switchable = _data["switchable"] !== undefined ? _data["switchable"] : <any>null;
            this.bypassable = _data["bypassable"] !== undefined ? _data["bypassable"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["flareName"] = this.flareName !== undefined ? this.flareName : <any>null;
        data["function"] = this.function !== undefined ? this.function : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["isVolumeFirst"] = this.isVolumeFirst !== undefined ? this.isVolumeFirst : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["groupType"] = this.groupType !== undefined ? this.groupType : <any>null;
        data["limsType"] = this.limsType !== undefined ? this.limsType : <any>null;
        data["ccId"] = this.ccId !== undefined ? this.ccId : <any>null;
        data["defaultMW"] = this.defaultMW !== undefined ? this.defaultMW : <any>null;
        data["switchable"] = this.switchable !== undefined ? this.switchable : <any>null;
        data["bypassable"] = this.bypassable !== undefined ? this.bypassable : <any>null;
        return data;
    }
}

export interface IKTLSGPStreamDTO {
    id: number;
    streamName: string;
    flareName: string;
    function: string;
    gasType: string;
    isVolumeFirst: boolean;
    inputType: KTLSGPStreamInputType;
    groupType: StreamGroupType;
    limsType: LIMSType;
    ccId?: number | null;
    defaultMW: number;
    switchable: boolean;
    bypassable: boolean;
}

export enum KTLSGPStreamInputType {
    Flaring = 0,
    Leakage = 1,
    Constant = 2,
}

export enum StreamGroupType {
    Standalone = 0,
    Parent = 1,
    Child = 2,
    NotShown = 3,
}

export enum LIMSType {
    KTL1 = 0,
    KTL2 = 1,
    KTL3 = 2,
    KTLAvg = 3,
    SGP = 4,
    Propane = 5,
    Butane = 6,
    Nothing = 7,
}

export class CalculatedStreamInputRecordDTO extends CCBaseKTLSGP implements ICalculatedStreamInputRecordDTO {
    streamId!: number;
    streamName!: string;
    flareName!: string;
    function!: string;
    gasType!: string;
    startTime!: Date;
    endTime?: Date | null;
    timeStamp!: Date;
    totalVolume!: number;
    totalMass!: number;
    inputCategory!: string;
    inputComment!: string;
    inputReason!: string;
    isConfirmed!: boolean;
    isApproved!: boolean;
    isPermitForm!: boolean;
    state!: string;

    constructor(data?: ICalculatedStreamInputRecordDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.flareName = _data["flareName"] !== undefined ? _data["flareName"] : <any>null;
            this.function = _data["function"] !== undefined ? _data["function"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.inputCategory = _data["inputCategory"] !== undefined ? _data["inputCategory"] : <any>null;
            this.inputComment = _data["inputComment"] !== undefined ? _data["inputComment"] : <any>null;
            this.inputReason = _data["inputReason"] !== undefined ? _data["inputReason"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
            this.isPermitForm = _data["isPermitForm"] !== undefined ? _data["isPermitForm"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
        }
    }

    static override fromJS(data: any): CalculatedStreamInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedStreamInputRecordDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["flareName"] = this.flareName !== undefined ? this.flareName : <any>null;
        data["function"] = this.function !== undefined ? this.function : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["inputCategory"] = this.inputCategory !== undefined ? this.inputCategory : <any>null;
        data["inputComment"] = this.inputComment !== undefined ? this.inputComment : <any>null;
        data["inputReason"] = this.inputReason !== undefined ? this.inputReason : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        data["isPermitForm"] = this.isPermitForm !== undefined ? this.isPermitForm : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICalculatedStreamInputRecordDTO extends ICCBaseKTLSGP {
    streamId: number;
    streamName: string;
    flareName: string;
    function: string;
    gasType: string;
    startTime: Date;
    endTime?: Date | null;
    timeStamp: Date;
    totalVolume: number;
    totalMass: number;
    inputCategory: string;
    inputComment: string;
    inputReason: string;
    isConfirmed: boolean;
    isApproved: boolean;
    isPermitForm: boolean;
    state: string;
}

export class PagedListOfGetKTLOperatorDTO implements IPagedListOfGetKTLOperatorDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: GetKTLOperatorDTO[];

    constructor(data?: IPagedListOfGetKTLOperatorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetKTLOperatorDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfGetKTLOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetKTLOperatorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfGetKTLOperatorDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: GetKTLOperatorDTO[];
}

export class BaseKTLOperatorDTO implements IBaseKTLOperatorDTO {
    startTime!: Date;
    endTime!: Date;
    train!: TrainList;
    unitName!: UnitList;
    environmentType!: EnvironmentType;
    collectorType!: CollectorType;
    valvePosition!: ValvePosition;
    gasType?: OperatorGasType | null;
    liquidType?: KTLSGPLiquidType | null;
    startPressureValue?: number | null;
    endPressureValue?: number | null;
    startTemperatureValue?: number | null;
    endTemperatureValue?: number | null;
    multiplicity!: number;
    blowingReasonType!: BlowingReasonType;
    notes?: string | null;
    equipmentCategory?: PermitTargetInputCategory | null;

    constructor(data?: IBaseKTLOperatorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.train = _data["train"] !== undefined ? _data["train"] : <any>null;
            this.unitName = _data["unitName"] !== undefined ? _data["unitName"] : <any>null;
            this.environmentType = _data["environmentType"] !== undefined ? _data["environmentType"] : <any>null;
            this.collectorType = _data["collectorType"] !== undefined ? _data["collectorType"] : <any>null;
            this.valvePosition = _data["valvePosition"] !== undefined ? _data["valvePosition"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.liquidType = _data["liquidType"] !== undefined ? _data["liquidType"] : <any>null;
            this.startPressureValue = _data["startPressureValue"] !== undefined ? _data["startPressureValue"] : <any>null;
            this.endPressureValue = _data["endPressureValue"] !== undefined ? _data["endPressureValue"] : <any>null;
            this.startTemperatureValue = _data["startTemperatureValue"] !== undefined ? _data["startTemperatureValue"] : <any>null;
            this.endTemperatureValue = _data["endTemperatureValue"] !== undefined ? _data["endTemperatureValue"] : <any>null;
            this.multiplicity = _data["multiplicity"] !== undefined ? _data["multiplicity"] : <any>null;
            this.blowingReasonType = _data["blowingReasonType"] !== undefined ? _data["blowingReasonType"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.equipmentCategory = _data["equipmentCategory"] !== undefined ? _data["equipmentCategory"] : <any>null;
        }
    }

    static fromJS(data: any): BaseKTLOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseKTLOperatorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["train"] = this.train !== undefined ? this.train : <any>null;
        data["unitName"] = this.unitName !== undefined ? this.unitName : <any>null;
        data["environmentType"] = this.environmentType !== undefined ? this.environmentType : <any>null;
        data["collectorType"] = this.collectorType !== undefined ? this.collectorType : <any>null;
        data["valvePosition"] = this.valvePosition !== undefined ? this.valvePosition : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["liquidType"] = this.liquidType !== undefined ? this.liquidType : <any>null;
        data["startPressureValue"] = this.startPressureValue !== undefined ? this.startPressureValue : <any>null;
        data["endPressureValue"] = this.endPressureValue !== undefined ? this.endPressureValue : <any>null;
        data["startTemperatureValue"] = this.startTemperatureValue !== undefined ? this.startTemperatureValue : <any>null;
        data["endTemperatureValue"] = this.endTemperatureValue !== undefined ? this.endTemperatureValue : <any>null;
        data["multiplicity"] = this.multiplicity !== undefined ? this.multiplicity : <any>null;
        data["blowingReasonType"] = this.blowingReasonType !== undefined ? this.blowingReasonType : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["equipmentCategory"] = this.equipmentCategory !== undefined ? this.equipmentCategory : <any>null;
        return data;
    }
}

export interface IBaseKTLOperatorDTO {
    startTime: Date;
    endTime: Date;
    train: TrainList;
    unitName: UnitList;
    environmentType: EnvironmentType;
    collectorType: CollectorType;
    valvePosition: ValvePosition;
    gasType?: OperatorGasType | null;
    liquidType?: KTLSGPLiquidType | null;
    startPressureValue?: number | null;
    endPressureValue?: number | null;
    startTemperatureValue?: number | null;
    endTemperatureValue?: number | null;
    multiplicity: number;
    blowingReasonType: BlowingReasonType;
    notes?: string | null;
    equipmentCategory?: PermitTargetInputCategory | null;
}

export class KTLOperatorDTO extends BaseKTLOperatorDTO implements IKTLOperatorDTO {
    id?: number | null;
    chemicalCompoundsEquipmentId?: number | null;
    chemicalCompoundsEquipmentName?: string | null;
    customName?: string | null;

    constructor(data?: IKTLOperatorDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.chemicalCompoundsEquipmentId = _data["chemicalCompoundsEquipmentId"] !== undefined ? _data["chemicalCompoundsEquipmentId"] : <any>null;
            this.chemicalCompoundsEquipmentName = _data["chemicalCompoundsEquipmentName"] !== undefined ? _data["chemicalCompoundsEquipmentName"] : <any>null;
            this.customName = _data["customName"] !== undefined ? _data["customName"] : <any>null;
        }
    }

    static override fromJS(data: any): KTLOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLOperatorDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["chemicalCompoundsEquipmentId"] = this.chemicalCompoundsEquipmentId !== undefined ? this.chemicalCompoundsEquipmentId : <any>null;
        data["chemicalCompoundsEquipmentName"] = this.chemicalCompoundsEquipmentName !== undefined ? this.chemicalCompoundsEquipmentName : <any>null;
        data["customName"] = this.customName !== undefined ? this.customName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IKTLOperatorDTO extends IBaseKTLOperatorDTO {
    id?: number | null;
    chemicalCompoundsEquipmentId?: number | null;
    chemicalCompoundsEquipmentName?: string | null;
    customName?: string | null;
}

export class GetKTLOperatorDTO extends KTLOperatorDTO implements IGetKTLOperatorDTO {
    volume?: number | null;
    mass?: number | null;
    loggedBy!: string;
    dateTime?: Date | null;

    constructor(data?: IGetKTLOperatorDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.loggedBy = _data["loggedBy"] !== undefined ? _data["loggedBy"] : <any>null;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): GetKTLOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetKTLOperatorDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["loggedBy"] = this.loggedBy !== undefined ? this.loggedBy : <any>null;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetKTLOperatorDTO extends IKTLOperatorDTO {
    volume?: number | null;
    mass?: number | null;
    loggedBy: string;
    dateTime?: Date | null;
}

export enum EnvironmentType {
    GAS = 0,
    LIQUID = 1,
}

export enum ValvePosition {
    Manual = 0,
    Other = 1,
}

export enum OperatorGasType {
    NITROGEN = 0,
    BUTANE = 1,
    DRY = 2,
    PROPANE = 3,
    SOUR = 4,
    SWEET = 5,
    FUEL = 6,
    OTHER = 7,
    ACID = 8,
}

export enum KTLSGPLiquidType {
    OIL = 0,
    PROPANE = 1,
    BUTANE = 2,
    ACID = 3,
    WFLH = 4,
    OTHER = 5,
}

export class CreateKTLOperatorDTO extends BaseKTLOperatorDTO implements ICreateKTLOperatorDTO {
    chemicalCompoundsEquipmentId?: number | null;
    customName?: string | null;

    constructor(data?: ICreateKTLOperatorDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chemicalCompoundsEquipmentId = _data["chemicalCompoundsEquipmentId"] !== undefined ? _data["chemicalCompoundsEquipmentId"] : <any>null;
            this.customName = _data["customName"] !== undefined ? _data["customName"] : <any>null;
        }
    }

    static override fromJS(data: any): CreateKTLOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKTLOperatorDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chemicalCompoundsEquipmentId"] = this.chemicalCompoundsEquipmentId !== undefined ? this.chemicalCompoundsEquipmentId : <any>null;
        data["customName"] = this.customName !== undefined ? this.customName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateKTLOperatorDTO extends IBaseKTLOperatorDTO {
    chemicalCompoundsEquipmentId?: number | null;
    customName?: string | null;
}

export class PagedListOfGetSGPOperatorDTO implements IPagedListOfGetSGPOperatorDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: GetSGPOperatorDTO[];

    constructor(data?: IPagedListOfGetSGPOperatorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSGPOperatorDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfGetSGPOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetSGPOperatorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfGetSGPOperatorDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: GetSGPOperatorDTO[];
}

export class SGPOperatorDTO implements ISGPOperatorDTO {
    startTime!: Date;
    endTime!: Date;
    environmentType!: EnvironmentType;
    collectorType!: SGPCollectorType;
    gasType?: SGPGasType | null;
    liquidType?: SGPLiquidType | null;
    multiplicityType!: MultiplicityType;
    valvePosition!: string;
    equipmentAndLineName!: string;
    startPressureValue?: number | null;
    endPressureValue?: number | null;
    startTemperatureValue?: number | null;
    endTemperatureValue?: number | null;
    blowingReasonType!: string;
    notes?: string | null;

    constructor(data?: ISGPOperatorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.environmentType = _data["environmentType"] !== undefined ? _data["environmentType"] : <any>null;
            this.collectorType = _data["collectorType"] !== undefined ? _data["collectorType"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.liquidType = _data["liquidType"] !== undefined ? _data["liquidType"] : <any>null;
            this.multiplicityType = _data["multiplicityType"] !== undefined ? _data["multiplicityType"] : <any>null;
            this.valvePosition = _data["valvePosition"] !== undefined ? _data["valvePosition"] : <any>null;
            this.equipmentAndLineName = _data["equipmentAndLineName"] !== undefined ? _data["equipmentAndLineName"] : <any>null;
            this.startPressureValue = _data["startPressureValue"] !== undefined ? _data["startPressureValue"] : <any>null;
            this.endPressureValue = _data["endPressureValue"] !== undefined ? _data["endPressureValue"] : <any>null;
            this.startTemperatureValue = _data["startTemperatureValue"] !== undefined ? _data["startTemperatureValue"] : <any>null;
            this.endTemperatureValue = _data["endTemperatureValue"] !== undefined ? _data["endTemperatureValue"] : <any>null;
            this.blowingReasonType = _data["blowingReasonType"] !== undefined ? _data["blowingReasonType"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): SGPOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGPOperatorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["environmentType"] = this.environmentType !== undefined ? this.environmentType : <any>null;
        data["collectorType"] = this.collectorType !== undefined ? this.collectorType : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["liquidType"] = this.liquidType !== undefined ? this.liquidType : <any>null;
        data["multiplicityType"] = this.multiplicityType !== undefined ? this.multiplicityType : <any>null;
        data["valvePosition"] = this.valvePosition !== undefined ? this.valvePosition : <any>null;
        data["equipmentAndLineName"] = this.equipmentAndLineName !== undefined ? this.equipmentAndLineName : <any>null;
        data["startPressureValue"] = this.startPressureValue !== undefined ? this.startPressureValue : <any>null;
        data["endPressureValue"] = this.endPressureValue !== undefined ? this.endPressureValue : <any>null;
        data["startTemperatureValue"] = this.startTemperatureValue !== undefined ? this.startTemperatureValue : <any>null;
        data["endTemperatureValue"] = this.endTemperatureValue !== undefined ? this.endTemperatureValue : <any>null;
        data["blowingReasonType"] = this.blowingReasonType !== undefined ? this.blowingReasonType : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface ISGPOperatorDTO {
    startTime: Date;
    endTime: Date;
    environmentType: EnvironmentType;
    collectorType: SGPCollectorType;
    gasType?: SGPGasType | null;
    liquidType?: SGPLiquidType | null;
    multiplicityType: MultiplicityType;
    valvePosition: string;
    equipmentAndLineName: string;
    startPressureValue?: number | null;
    endPressureValue?: number | null;
    startTemperatureValue?: number | null;
    endTemperatureValue?: number | null;
    blowingReasonType: string;
    notes?: string | null;
}

export class GetSGPOperatorDTO extends SGPOperatorDTO implements IGetSGPOperatorDTO {
    id!: number;
    createdBy?: string | null;
    logged?: Date | null;

    constructor(data?: IGetSGPOperatorDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): GetSGPOperatorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetSGPOperatorDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSGPOperatorDTO extends ISGPOperatorDTO {
    id: number;
    createdBy?: string | null;
    logged?: Date | null;
}

export enum SGPCollectorType {
    BD = 0,
    BFH = 1,
    BFL = 2,
    DHC = 3,
    DMD = 4,
}

export enum SGPGasType {
    Sour = 0,
    Fuel = 1,
    Nitrogen = 2,
    Acid = 3,
    Sweet = 4,
    Propane = 5,
    Butane = 6,
    SpentAir = 7,
    LPG = 8,
    Reg = 9,
}

export enum SGPLiquidType {
    CrudeOil = 0,
    Prone = 1,
    Butane = 2,
    SourWater = 3,
    WSLH = 4,
    PLG = 5,
    RinseWater = 6,
    HCLiquids = 7,
}

export enum MultiplicityType {
    One = 0,
    Two = 1,
    Three = 2,
    Four = 3,
    Five = 4,
    Constant = 5,
    Repeated = 6,
    Periodic = 7,
}

export class PagedListOfGetDiagnosticianScreenHistoryDTO implements IPagedListOfGetDiagnosticianScreenHistoryDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: GetDiagnosticianScreenHistoryDTO[];

    constructor(data?: IPagedListOfGetDiagnosticianScreenHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDiagnosticianScreenHistoryDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfGetDiagnosticianScreenHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfGetDiagnosticianScreenHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfGetDiagnosticianScreenHistoryDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: GetDiagnosticianScreenHistoryDTO[];
}

export class GetDiagnosticianHistoryChildDTO implements IGetDiagnosticianHistoryChildDTO {
    createdBy!: string;
    logged?: Date | null;
    inletSize?: number | null;
    isGateValve?: boolean | null;
    isBallValve?: boolean | null;
    startTime!: Date;
    pressureDifference?: number | null;
    temperature?: number | null;
    signalLevel?: number | null;
    coefficient?: number | null;
    leakLMin?: number | null;
    leakSCMH?: number | null;
    flowRate?: number | null;
    comments?: string | null;
    id?: number | null;

    constructor(data?: IGetDiagnosticianHistoryChildDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.inletSize = _data["inletSize"] !== undefined ? _data["inletSize"] : <any>null;
            this.isGateValve = _data["isGateValve"] !== undefined ? _data["isGateValve"] : <any>null;
            this.isBallValve = _data["isBallValve"] !== undefined ? _data["isBallValve"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.pressureDifference = _data["pressureDifference"] !== undefined ? _data["pressureDifference"] : <any>null;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
            this.signalLevel = _data["signalLevel"] !== undefined ? _data["signalLevel"] : <any>null;
            this.coefficient = _data["coefficient"] !== undefined ? _data["coefficient"] : <any>null;
            this.leakLMin = _data["leakLMin"] !== undefined ? _data["leakLMin"] : <any>null;
            this.leakSCMH = _data["leakSCMH"] !== undefined ? _data["leakSCMH"] : <any>null;
            this.flowRate = _data["flowRate"] !== undefined ? _data["flowRate"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): GetDiagnosticianHistoryChildDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiagnosticianHistoryChildDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["inletSize"] = this.inletSize !== undefined ? this.inletSize : <any>null;
        data["isGateValve"] = this.isGateValve !== undefined ? this.isGateValve : <any>null;
        data["isBallValve"] = this.isBallValve !== undefined ? this.isBallValve : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["pressureDifference"] = this.pressureDifference !== undefined ? this.pressureDifference : <any>null;
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        data["signalLevel"] = this.signalLevel !== undefined ? this.signalLevel : <any>null;
        data["coefficient"] = this.coefficient !== undefined ? this.coefficient : <any>null;
        data["leakLMin"] = this.leakLMin !== undefined ? this.leakLMin : <any>null;
        data["leakSCMH"] = this.leakSCMH !== undefined ? this.leakSCMH : <any>null;
        data["flowRate"] = this.flowRate !== undefined ? this.flowRate : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IGetDiagnosticianHistoryChildDTO {
    createdBy: string;
    logged?: Date | null;
    inletSize?: number | null;
    isGateValve?: boolean | null;
    isBallValve?: boolean | null;
    startTime: Date;
    pressureDifference?: number | null;
    temperature?: number | null;
    signalLevel?: number | null;
    coefficient?: number | null;
    leakLMin?: number | null;
    leakSCMH?: number | null;
    flowRate?: number | null;
    comments?: string | null;
    id?: number | null;
}

export class GetDiagnosticianScreenHistoryDTO extends GetDiagnosticianHistoryChildDTO implements IGetDiagnosticianScreenHistoryDTO {
    valveName!: string;
    unitName!: string;
    facility?: KTLTrains | null;
    diagnosticianConstantId!: number;

    constructor(data?: IGetDiagnosticianScreenHistoryDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valveName = _data["valveName"] !== undefined ? _data["valveName"] : <any>null;
            this.unitName = _data["unitName"] !== undefined ? _data["unitName"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.diagnosticianConstantId = _data["diagnosticianConstantId"] !== undefined ? _data["diagnosticianConstantId"] : <any>null;
        }
    }

    static override fromJS(data: any): GetDiagnosticianScreenHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiagnosticianScreenHistoryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveName"] = this.valveName !== undefined ? this.valveName : <any>null;
        data["unitName"] = this.unitName !== undefined ? this.unitName : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["diagnosticianConstantId"] = this.diagnosticianConstantId !== undefined ? this.diagnosticianConstantId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDiagnosticianScreenHistoryDTO extends IGetDiagnosticianHistoryChildDTO {
    valveName: string;
    unitName: string;
    facility?: KTLTrains | null;
    diagnosticianConstantId: number;
}

export class GetDiagnosticianScreenInputDTO extends GetDiagnosticianHistoryChildDTO implements IGetDiagnosticianScreenInputDTO {
    valveName!: string;
    unitName!: string;
    facility?: KTLTrains | null;
    diagnosticianConstantId!: number;

    constructor(data?: IGetDiagnosticianScreenInputDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valveName = _data["valveName"] !== undefined ? _data["valveName"] : <any>null;
            this.unitName = _data["unitName"] !== undefined ? _data["unitName"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.diagnosticianConstantId = _data["diagnosticianConstantId"] !== undefined ? _data["diagnosticianConstantId"] : <any>null;
        }
    }

    static override fromJS(data: any): GetDiagnosticianScreenInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiagnosticianScreenInputDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valveName"] = this.valveName !== undefined ? this.valveName : <any>null;
        data["unitName"] = this.unitName !== undefined ? this.unitName : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["diagnosticianConstantId"] = this.diagnosticianConstantId !== undefined ? this.diagnosticianConstantId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDiagnosticianScreenInputDTO extends IGetDiagnosticianHistoryChildDTO {
    valveName: string;
    unitName: string;
    facility?: KTLTrains | null;
    diagnosticianConstantId: number;
}

export class DiagnosticianScreenDTO implements IDiagnosticianScreenDTO {
    id?: number | null;
    pressureDifference?: number | null;
    temperature?: number | null;
    signalLevel?: number | null;
    coefficient?: number | null;
    leakLMin?: number | null;
    leakSCMH?: number | null;
    flowRate!: number;
    manualInletSize?: number | null;
    manualIsGateValve?: boolean | null;
    manualIsBallValve?: boolean | null;
    comments?: string | null;
    diagnosticianConstantId!: number;

    constructor(data?: IDiagnosticianScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.pressureDifference = _data["pressureDifference"] !== undefined ? _data["pressureDifference"] : <any>null;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
            this.signalLevel = _data["signalLevel"] !== undefined ? _data["signalLevel"] : <any>null;
            this.coefficient = _data["coefficient"] !== undefined ? _data["coefficient"] : <any>null;
            this.leakLMin = _data["leakLMin"] !== undefined ? _data["leakLMin"] : <any>null;
            this.leakSCMH = _data["leakSCMH"] !== undefined ? _data["leakSCMH"] : <any>null;
            this.flowRate = _data["flowRate"] !== undefined ? _data["flowRate"] : <any>null;
            this.manualInletSize = _data["manualInletSize"] !== undefined ? _data["manualInletSize"] : <any>null;
            this.manualIsGateValve = _data["manualIsGateValve"] !== undefined ? _data["manualIsGateValve"] : <any>null;
            this.manualIsBallValve = _data["manualIsBallValve"] !== undefined ? _data["manualIsBallValve"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.diagnosticianConstantId = _data["diagnosticianConstantId"] !== undefined ? _data["diagnosticianConstantId"] : <any>null;
        }
    }

    static fromJS(data: any): DiagnosticianScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticianScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["pressureDifference"] = this.pressureDifference !== undefined ? this.pressureDifference : <any>null;
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        data["signalLevel"] = this.signalLevel !== undefined ? this.signalLevel : <any>null;
        data["coefficient"] = this.coefficient !== undefined ? this.coefficient : <any>null;
        data["leakLMin"] = this.leakLMin !== undefined ? this.leakLMin : <any>null;
        data["leakSCMH"] = this.leakSCMH !== undefined ? this.leakSCMH : <any>null;
        data["flowRate"] = this.flowRate !== undefined ? this.flowRate : <any>null;
        data["manualInletSize"] = this.manualInletSize !== undefined ? this.manualInletSize : <any>null;
        data["manualIsGateValve"] = this.manualIsGateValve !== undefined ? this.manualIsGateValve : <any>null;
        data["manualIsBallValve"] = this.manualIsBallValve !== undefined ? this.manualIsBallValve : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["diagnosticianConstantId"] = this.diagnosticianConstantId !== undefined ? this.diagnosticianConstantId : <any>null;
        return data;
    }
}

export interface IDiagnosticianScreenDTO {
    id?: number | null;
    pressureDifference?: number | null;
    temperature?: number | null;
    signalLevel?: number | null;
    coefficient?: number | null;
    leakLMin?: number | null;
    leakSCMH?: number | null;
    flowRate: number;
    manualInletSize?: number | null;
    manualIsGateValve?: boolean | null;
    manualIsBallValve?: boolean | null;
    comments?: string | null;
    diagnosticianConstantId: number;
}

export class CreateDiagnosticianInputDTO extends DiagnosticianScreenDTO implements ICreateDiagnosticianInputDTO {
    startTime!: Date;
    facility!: KTLTrains;
    unitName!: UnitList;

    constructor(data?: ICreateDiagnosticianInputDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.unitName = _data["unitName"] !== undefined ? _data["unitName"] : <any>null;
        }
    }

    static override fromJS(data: any): CreateDiagnosticianInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiagnosticianInputDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["unitName"] = this.unitName !== undefined ? this.unitName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDiagnosticianInputDTO extends IDiagnosticianScreenDTO {
    startTime: Date;
    facility: KTLTrains;
    unitName: UnitList;
}

export class DiagnosticianRelationFacilityDTO implements IDiagnosticianRelationFacilityDTO {
    faciltiy!: KTLTrains;
    units!: DiagnosticianRelationUnitDTO[];

    constructor(data?: IDiagnosticianRelationFacilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.units = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faciltiy = _data["faciltiy"] !== undefined ? _data["faciltiy"] : <any>null;
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(DiagnosticianRelationUnitDTO.fromJS(item));
            }
            else {
                this.units = <any>null;
            }
        }
    }

    static fromJS(data: any): DiagnosticianRelationFacilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticianRelationFacilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faciltiy"] = this.faciltiy !== undefined ? this.faciltiy : <any>null;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IDiagnosticianRelationFacilityDTO {
    faciltiy: KTLTrains;
    units: DiagnosticianRelationUnitDTO[];
}

export class DiagnosticianRelationUnitDTO implements IDiagnosticianRelationUnitDTO {
    unit!: string;
    valve!: DiagnosticianRelationValveDTO[];

    constructor(data?: IDiagnosticianRelationUnitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.valve = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            if (Array.isArray(_data["valve"])) {
                this.valve = [] as any;
                for (let item of _data["valve"])
                    this.valve!.push(DiagnosticianRelationValveDTO.fromJS(item));
            }
            else {
                this.valve = <any>null;
            }
        }
    }

    static fromJS(data: any): DiagnosticianRelationUnitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticianRelationUnitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        if (Array.isArray(this.valve)) {
            data["valve"] = [];
            for (let item of this.valve)
                data["valve"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IDiagnosticianRelationUnitDTO {
    unit: string;
    valve: DiagnosticianRelationValveDTO[];
}

export class DiagnosticianRelationValveDTO implements IDiagnosticianRelationValveDTO {
    title!: string;
    value!: string;

    constructor(data?: IDiagnosticianRelationValveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): DiagnosticianRelationValveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticianRelationValveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IDiagnosticianRelationValveDTO {
    title: string;
    value: string;
}

export class PagedListOfLeakageScreenDTO implements IPagedListOfLeakageScreenDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: LeakageScreenDTO[];

    constructor(data?: IPagedListOfLeakageScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeakageScreenDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfLeakageScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfLeakageScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfLeakageScreenDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: LeakageScreenDTO[];
}

export class LeakageScreenDTO extends CCBaseKTLSGP implements ILeakageScreenDTO {
    id?: number | null;
    startTime!: Date;
    endTime?: Date | null;
    facility!: KTLTrains;
    unit!: UnitList;
    diagnosticianValveName!: string;
    gasType?: KTLSGPGasType | null;
    flare?: TrainList | null;
    volume!: number;
    mass!: number;
    comments?: string | null;
    loggedBy?: string | null;
    logged?: Date | null;
    updatedDate?: Date | null;
    diagnosticianInputId!: number;
    isManualValve!: boolean;
    isMatchWithDiagnostician!: boolean;

    constructor(data?: ILeakageScreenDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.diagnosticianValveName = _data["diagnosticianValveName"] !== undefined ? _data["diagnosticianValveName"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.flare = _data["flare"] !== undefined ? _data["flare"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.loggedBy = _data["loggedBy"] !== undefined ? _data["loggedBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.diagnosticianInputId = _data["diagnosticianInputId"] !== undefined ? _data["diagnosticianInputId"] : <any>null;
            this.isManualValve = _data["isManualValve"] !== undefined ? _data["isManualValve"] : <any>null;
            this.isMatchWithDiagnostician = _data["isMatchWithDiagnostician"] !== undefined ? _data["isMatchWithDiagnostician"] : <any>null;
        }
    }

    static override fromJS(data: any): LeakageScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LeakageScreenDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["diagnosticianValveName"] = this.diagnosticianValveName !== undefined ? this.diagnosticianValveName : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["flare"] = this.flare !== undefined ? this.flare : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["loggedBy"] = this.loggedBy !== undefined ? this.loggedBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["diagnosticianInputId"] = this.diagnosticianInputId !== undefined ? this.diagnosticianInputId : <any>null;
        data["isManualValve"] = this.isManualValve !== undefined ? this.isManualValve : <any>null;
        data["isMatchWithDiagnostician"] = this.isMatchWithDiagnostician !== undefined ? this.isMatchWithDiagnostician : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILeakageScreenDTO extends ICCBaseKTLSGP {
    id?: number | null;
    startTime: Date;
    endTime?: Date | null;
    facility: KTLTrains;
    unit: UnitList;
    diagnosticianValveName: string;
    gasType?: KTLSGPGasType | null;
    flare?: TrainList | null;
    volume: number;
    mass: number;
    comments?: string | null;
    loggedBy?: string | null;
    logged?: Date | null;
    updatedDate?: Date | null;
    diagnosticianInputId: number;
    isManualValve: boolean;
    isMatchWithDiagnostician: boolean;
}

export enum KTLSGPGasType {
    ACID = 0,
    BUTANE = 1,
    DRY = 2,
    PROPANE = 3,
    SOUR = 4,
    SWEET = 5,
}

export class KTLSGPDataRecoveryInputDTO implements IKTLSGPDataRecoveryInputDTO {
    streams!: StreamDTO[];
    records!: KTLSGPRecoveredInputDTO[];

    constructor(data?: IKTLSGPDataRecoveryInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.streams = [];
            this.records = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["streams"])) {
                this.streams = [] as any;
                for (let item of _data["streams"])
                    this.streams!.push(StreamDTO.fromJS(item));
            }
            else {
                this.streams = <any>null;
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(KTLSGPRecoveredInputDTO.fromJS(item));
            }
            else {
                this.records = <any>null;
            }
        }
    }

    static fromJS(data: any): KTLSGPDataRecoveryInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPDataRecoveryInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.streams)) {
            data["streams"] = [];
            for (let item of this.streams)
                data["streams"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IKTLSGPDataRecoveryInputDTO {
    streams: StreamDTO[];
    records: KTLSGPRecoveredInputDTO[];
}

export class StreamDTO implements IStreamDTO {
    gasType!: string;
    streamName!: string[];

    constructor(data?: IStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.streamName = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            if (Array.isArray(_data["streamName"])) {
                this.streamName = [] as any;
                for (let item of _data["streamName"])
                    this.streamName!.push(item);
            }
            else {
                this.streamName = <any>null;
            }
        }
    }

    static fromJS(data: any): StreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        if (Array.isArray(this.streamName)) {
            data["streamName"] = [];
            for (let item of this.streamName)
                data["streamName"].push(item);
        }
        return data;
    }
}

export interface IStreamDTO {
    gasType: string;
    streamName: string[];
}

export class KTLSGPRecoveredInputDTO implements IKTLSGPRecoveredInputDTO {
    timeStamp!: Date;
    streamName!: string;
    gasType!: string;
    highlightColor!: HighlightColorType;
    comments!: string;

    constructor(data?: IKTLSGPRecoveredInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.highlightColor = _data["highlightColor"] !== undefined ? _data["highlightColor"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPRecoveredInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPRecoveredInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["highlightColor"] = this.highlightColor !== undefined ? this.highlightColor : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        return data;
    }
}

export interface IKTLSGPRecoveredInputDTO {
    timeStamp: Date;
    streamName: string;
    gasType: string;
    highlightColor: HighlightColorType;
    comments: string;
}

export enum HighlightColorType {
    Green = 0,
    Yellow = 1,
    Red = 2,
    Blue = 3,
    Purple = 4,
    Orange = 5,
    None = 6,
}

export class KTLSGPDataRecoveryValueDTO implements IKTLSGPDataRecoveryValueDTO {
    timestamp!: Date;
    originalValue!: string;
    recoveredValue!: number;

    constructor(data?: IKTLSGPDataRecoveryValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>null;
            this.originalValue = _data["originalValue"] !== undefined ? _data["originalValue"] : <any>null;
            this.recoveredValue = _data["recoveredValue"] !== undefined ? _data["recoveredValue"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPDataRecoveryValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPDataRecoveryValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["originalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
        data["recoveredValue"] = this.recoveredValue !== undefined ? this.recoveredValue : <any>null;
        return data;
    }
}

export interface IKTLSGPDataRecoveryValueDTO {
    timestamp: Date;
    originalValue: string;
    recoveredValue: number;
}

export class KTLSGPDataRecoveryTagDTO implements IKTLSGPDataRecoveryTagDTO {
    tagName!: string;

    constructor(data?: IKTLSGPDataRecoveryTagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagName = _data["tagName"] !== undefined ? _data["tagName"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPDataRecoveryTagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPDataRecoveryTagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagName"] = this.tagName !== undefined ? this.tagName : <any>null;
        return data;
    }
}

export interface IKTLSGPDataRecoveryTagDTO {
    tagName: string;
}

export class UpdateTagInputsDTO implements IUpdateTagInputsDTO {
    date!: Date;
    streamName!: string;
    tagName!: string;
    values?: KTLSGPDataRecoveryValueDTO[] | null;

    constructor(data?: IUpdateTagInputsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.streamName = _data["streamName"] !== undefined ? _data["streamName"] : <any>null;
            this.tagName = _data["tagName"] !== undefined ? _data["tagName"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(KTLSGPDataRecoveryValueDTO.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateTagInputsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTagInputsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["streamName"] = this.streamName !== undefined ? this.streamName : <any>null;
        data["tagName"] = this.tagName !== undefined ? this.tagName : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IUpdateTagInputsDTO {
    date: Date;
    streamName: string;
    tagName: string;
    values?: KTLSGPDataRecoveryValueDTO[] | null;
}

export class LPGOperatorInputDTO implements ILPGOperatorInputDTO {
    id!: number;
    startTime!: Date;
    endTime!: Date;
    lpgPark!: LPGPark;
    gasType!: LPGGasType;
    bullet!: string;
    reason!: string;
    createdBy?: string | null;
    updatedBy?: string | null;
    other?: string | null;
    techComments?: string | null;
    isOperator!: boolean;
    properties!: { [key: string]: any; };

    constructor(data?: ILPGOperatorInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.lpgPark = _data["lpgPark"] !== undefined ? _data["lpgPark"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.bullet = _data["bullet"] !== undefined ? _data["bullet"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.techComments = _data["techComments"] !== undefined ? _data["techComments"] : <any>null;
            this.isOperator = _data["isOperator"] !== undefined ? _data["isOperator"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGOperatorInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGOperatorInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["lpgPark"] = this.lpgPark !== undefined ? this.lpgPark : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["bullet"] = this.bullet !== undefined ? this.bullet : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["techComments"] = this.techComments !== undefined ? this.techComments : <any>null;
        data["isOperator"] = this.isOperator !== undefined ? this.isOperator : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ILPGOperatorInputDTO {
    id: number;
    startTime: Date;
    endTime: Date;
    lpgPark: LPGPark;
    gasType: LPGGasType;
    bullet: string;
    reason: string;
    createdBy?: string | null;
    updatedBy?: string | null;
    other?: string | null;
    techComments?: string | null;
    isOperator: boolean;
    properties: { [key: string]: any; };
}

export enum LPGPark {
    OldParkKTL = 0,
    NewParkSGP = 1,
}

export enum LPGGasType {
    Dry = 0,
    Propane = 1,
    Butane = 2,
}

export class LPGPEInputDTO implements ILPGPEInputDTO {
    id!: number;
    startTime!: Date;
    endTime!: Date;
    lpgPark!: LPGPark;
    gasType!: LPGGasType;
    purpose!: LPGPurpose;
    isAuto!: boolean;
    bullet!: string;
    other?: string | null;
    techComments?: string | null;
    mwSelectionPoint!: LPGStreamCCType;
    category?: PermitTargetInputCategory | null;
    volume!: number;
    mass!: number;
    reason!: string;
    isFlowmeter!: boolean;
    isManual!: boolean;
    flaringAvgFrom!: Date;
    flaringAvgTo!: Date;
    flaringAvgVolume!: number;
    flaringStartTime!: Date;
    flaringEndTime!: Date;
    flaredVolume!: number;
    flaredMass!: number;
    seeq?: string | null;
    createdBy?: string | null;
    updatedBy?: string | null;
    logged!: Date;
    properties!: { [key: string]: any; };

    constructor(data?: ILPGPEInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.lpgPark = _data["lpgPark"] !== undefined ? _data["lpgPark"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.purpose = _data["purpose"] !== undefined ? _data["purpose"] : <any>null;
            this.isAuto = _data["isAuto"] !== undefined ? _data["isAuto"] : <any>null;
            this.bullet = _data["bullet"] !== undefined ? _data["bullet"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.techComments = _data["techComments"] !== undefined ? _data["techComments"] : <any>null;
            this.mwSelectionPoint = _data["mwSelectionPoint"] !== undefined ? _data["mwSelectionPoint"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.isFlowmeter = _data["isFlowmeter"] !== undefined ? _data["isFlowmeter"] : <any>null;
            this.isManual = _data["isManual"] !== undefined ? _data["isManual"] : <any>null;
            this.flaringAvgFrom = _data["flaringAvgFrom"] ? new Date(_data["flaringAvgFrom"].toString()) : <any>null;
            this.flaringAvgTo = _data["flaringAvgTo"] ? new Date(_data["flaringAvgTo"].toString()) : <any>null;
            this.flaringAvgVolume = _data["flaringAvgVolume"] !== undefined ? _data["flaringAvgVolume"] : <any>null;
            this.flaringStartTime = _data["flaringStartTime"] ? new Date(_data["flaringStartTime"].toString()) : <any>null;
            this.flaringEndTime = _data["flaringEndTime"] ? new Date(_data["flaringEndTime"].toString()) : <any>null;
            this.flaredVolume = _data["flaredVolume"] !== undefined ? _data["flaredVolume"] : <any>null;
            this.flaredMass = _data["flaredMass"] !== undefined ? _data["flaredMass"] : <any>null;
            this.seeq = _data["seeq"] !== undefined ? _data["seeq"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGPEInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGPEInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["lpgPark"] = this.lpgPark !== undefined ? this.lpgPark : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["purpose"] = this.purpose !== undefined ? this.purpose : <any>null;
        data["isAuto"] = this.isAuto !== undefined ? this.isAuto : <any>null;
        data["bullet"] = this.bullet !== undefined ? this.bullet : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["techComments"] = this.techComments !== undefined ? this.techComments : <any>null;
        data["mwSelectionPoint"] = this.mwSelectionPoint !== undefined ? this.mwSelectionPoint : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["isFlowmeter"] = this.isFlowmeter !== undefined ? this.isFlowmeter : <any>null;
        data["isManual"] = this.isManual !== undefined ? this.isManual : <any>null;
        data["flaringAvgFrom"] = this.flaringAvgFrom ? this.flaringAvgFrom.toISOString() : <any>null;
        data["flaringAvgTo"] = this.flaringAvgTo ? this.flaringAvgTo.toISOString() : <any>null;
        data["flaringAvgVolume"] = this.flaringAvgVolume !== undefined ? this.flaringAvgVolume : <any>null;
        data["flaringStartTime"] = this.flaringStartTime ? this.flaringStartTime.toISOString() : <any>null;
        data["flaringEndTime"] = this.flaringEndTime ? this.flaringEndTime.toISOString() : <any>null;
        data["flaredVolume"] = this.flaredVolume !== undefined ? this.flaredVolume : <any>null;
        data["flaredMass"] = this.flaredMass !== undefined ? this.flaredMass : <any>null;
        data["seeq"] = this.seeq !== undefined ? this.seeq : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ILPGPEInputDTO {
    id: number;
    startTime: Date;
    endTime: Date;
    lpgPark: LPGPark;
    gasType: LPGGasType;
    purpose: LPGPurpose;
    isAuto: boolean;
    bullet: string;
    other?: string | null;
    techComments?: string | null;
    mwSelectionPoint: LPGStreamCCType;
    category?: PermitTargetInputCategory | null;
    volume: number;
    mass: number;
    reason: string;
    isFlowmeter: boolean;
    isManual: boolean;
    flaringAvgFrom: Date;
    flaringAvgTo: Date;
    flaringAvgVolume: number;
    flaringStartTime: Date;
    flaringEndTime: Date;
    flaredVolume: number;
    flaredMass: number;
    seeq?: string | null;
    createdBy?: string | null;
    updatedBy?: string | null;
    logged: Date;
    properties: { [key: string]: any; };
}

export enum LPGPurpose {
    Flared = 0,
    Leakage = 1,
}

export enum LPGStreamCCType {
    Nothing = 0,
    Korolev = 1,
    KTL1 = 2,
    KTL2 = 3,
    KTL23 = 4,
    KTLAvg = 5,
    E902 = 6,
    F3501 = 7,
    F3502 = 8,
    F3503 = 9,
    OldParkAvgPropane = 10,
    NewParkAvgPropane = 11,
    PropaneAvg = 12,
    E901 = 13,
    F3511 = 14,
    F3512 = 15,
    F3513 = 16,
    OldParkAvgButane = 17,
    NewParkAvgButane = 18,
    ButaneAvg = 19,
}

export class LPGMonthlyInputRecordDTO implements ILPGMonthlyInputRecordDTO {
    id!: number;
    type!: LPGMonthlyInputRecordType;
    volume?: number | null;
    pilotGasRate?: number | null;
    purgeRate?: number | null;
    purgeRate2?: number | null;
    numberOfFuelGasLine?: number | null;
    comment?: string | null;
    isAuto!: boolean;
    createdBy?: string | null;
    updatedBy?: string | null;
    startTime!: Date;
    logged!: Date;
    properties!: { [key: string]: any; };

    constructor(data?: ILPGMonthlyInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.pilotGasRate = _data["pilotGasRate"] !== undefined ? _data["pilotGasRate"] : <any>null;
            this.purgeRate = _data["purgeRate"] !== undefined ? _data["purgeRate"] : <any>null;
            this.purgeRate2 = _data["purgeRate2"] !== undefined ? _data["purgeRate2"] : <any>null;
            this.numberOfFuelGasLine = _data["numberOfFuelGasLine"] !== undefined ? _data["numberOfFuelGasLine"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.isAuto = _data["isAuto"] !== undefined ? _data["isAuto"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGMonthlyInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGMonthlyInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["pilotGasRate"] = this.pilotGasRate !== undefined ? this.pilotGasRate : <any>null;
        data["purgeRate"] = this.purgeRate !== undefined ? this.purgeRate : <any>null;
        data["purgeRate2"] = this.purgeRate2 !== undefined ? this.purgeRate2 : <any>null;
        data["numberOfFuelGasLine"] = this.numberOfFuelGasLine !== undefined ? this.numberOfFuelGasLine : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["isAuto"] = this.isAuto !== undefined ? this.isAuto : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ILPGMonthlyInputRecordDTO {
    id: number;
    type: LPGMonthlyInputRecordType;
    volume?: number | null;
    pilotGasRate?: number | null;
    purgeRate?: number | null;
    purgeRate2?: number | null;
    numberOfFuelGasLine?: number | null;
    comment?: string | null;
    isAuto: boolean;
    createdBy?: string | null;
    updatedBy?: string | null;
    startTime: Date;
    logged: Date;
    properties: { [key: string]: any; };
}

export enum LPGMonthlyInputRecordType {
    Smokeless = 0,
    Smoke = 1,
    Pilot = 2,
    FlareHeader = 3,
}

export enum LPGFlowmeterCalculateType {
    Average = 0,
    Volume = 1,
    Mass = 2,
}

export class LPGAnalystInputDTO implements ILPGAnalystInputDTO {
    id!: number;
    startTime!: Date;
    oldPropane!: number;
    oldButane!: number;
    newPropane!: number;
    newButane!: number;
    comment?: string | null;
    createdBy?: string | null;
    updatedBy?: string | null;
    logged!: Date;
    properties!: { [key: string]: any; };

    constructor(data?: ILPGAnalystInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.oldPropane = _data["oldPropane"] !== undefined ? _data["oldPropane"] : <any>null;
            this.oldButane = _data["oldButane"] !== undefined ? _data["oldButane"] : <any>null;
            this.newPropane = _data["newPropane"] !== undefined ? _data["newPropane"] : <any>null;
            this.newButane = _data["newButane"] !== undefined ? _data["newButane"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGAnalystInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGAnalystInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["oldPropane"] = this.oldPropane !== undefined ? this.oldPropane : <any>null;
        data["oldButane"] = this.oldButane !== undefined ? this.oldButane : <any>null;
        data["newPropane"] = this.newPropane !== undefined ? this.newPropane : <any>null;
        data["newButane"] = this.newButane !== undefined ? this.newButane : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ILPGAnalystInputDTO {
    id: number;
    startTime: Date;
    oldPropane: number;
    oldButane: number;
    newPropane: number;
    newButane: number;
    comment?: string | null;
    createdBy?: string | null;
    updatedBy?: string | null;
    logged: Date;
    properties: { [key: string]: any; };
}

export class LPGDataForAnalystDTO implements ILPGDataForAnalystDTO {
    elementName!: string;
    gasType!: LPGGasType;
    totalVolume!: number;
    totalVolumekSm3!: number;
    totalMass!: number;

    constructor(data?: ILPGDataForAnalystDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalVolumekSm3 = _data["totalVolumekSm3"] !== undefined ? _data["totalVolumekSm3"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
        }
    }

    static fromJS(data: any): LPGDataForAnalystDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGDataForAnalystDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalVolumekSm3"] = this.totalVolumekSm3 !== undefined ? this.totalVolumekSm3 : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        return data;
    }
}

export interface ILPGDataForAnalystDTO {
    elementName: string;
    gasType: LPGGasType;
    totalVolume: number;
    totalVolumekSm3: number;
    totalMass: number;
}

export class LPGFlowmeterGraphDTO implements ILPGFlowmeterGraphDTO {
    title!: string;
    values!: LPGFlowmeterValuesDTO[];

    constructor(data?: ILPGFlowmeterGraphDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(LPGFlowmeterValuesDTO.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGFlowmeterGraphDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFlowmeterGraphDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ILPGFlowmeterGraphDTO {
    title: string;
    values: LPGFlowmeterValuesDTO[];
}

export class LPGFlowmeterValuesDTO implements ILPGFlowmeterValuesDTO {
    timeStamp!: Date;
    value!: number;

    constructor(data?: ILPGFlowmeterValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): LPGFlowmeterValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFlowmeterValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ILPGFlowmeterValuesDTO {
    timeStamp: Date;
    value: number;
}

export enum LPGFlowmeterGraphTypes {
    Smokeless = 0,
    Smoke = 1,
    FlaredGasFlowmeter = 2,
}

export class LPGFuelGasFlaringReportDTO implements ILPGFuelGasFlaringReportDTO {
    timeStamp!: Date;
    monthlyGasFlaringReport!: LPGMonthlyGasFlaringReportDTO[];
    fuelGasFlaring!: LPGFuelGasFlaringDTO[];

    constructor(data?: ILPGFuelGasFlaringReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.monthlyGasFlaringReport = [];
            this.fuelGasFlaring = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            if (Array.isArray(_data["monthlyGasFlaringReport"])) {
                this.monthlyGasFlaringReport = [] as any;
                for (let item of _data["monthlyGasFlaringReport"])
                    this.monthlyGasFlaringReport!.push(LPGMonthlyGasFlaringReportDTO.fromJS(item));
            }
            else {
                this.monthlyGasFlaringReport = <any>null;
            }
            if (Array.isArray(_data["fuelGasFlaring"])) {
                this.fuelGasFlaring = [] as any;
                for (let item of _data["fuelGasFlaring"])
                    this.fuelGasFlaring!.push(LPGFuelGasFlaringDTO.fromJS(item));
            }
            else {
                this.fuelGasFlaring = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGFuelGasFlaringReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFuelGasFlaringReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        if (Array.isArray(this.monthlyGasFlaringReport)) {
            data["monthlyGasFlaringReport"] = [];
            for (let item of this.monthlyGasFlaringReport)
                data["monthlyGasFlaringReport"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.fuelGasFlaring)) {
            data["fuelGasFlaring"] = [];
            for (let item of this.fuelGasFlaring)
                data["fuelGasFlaring"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ILPGFuelGasFlaringReportDTO {
    timeStamp: Date;
    monthlyGasFlaringReport: LPGMonthlyGasFlaringReportDTO[];
    fuelGasFlaring: LPGFuelGasFlaringDTO[];
}

export class LPGMonthlyGasFlaringReportDTO implements ILPGMonthlyGasFlaringReportDTO {
    elementName!: string;
    totalVolume!: number;
    totalVolumekSm3!: number;
    totalMass!: number;

    constructor(data?: ILPGMonthlyGasFlaringReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.totalVolumekSm3 = _data["totalVolumekSm3"] !== undefined ? _data["totalVolumekSm3"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
        }
    }

    static fromJS(data: any): LPGMonthlyGasFlaringReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGMonthlyGasFlaringReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["totalVolumekSm3"] = this.totalVolumekSm3 !== undefined ? this.totalVolumekSm3 : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        return data;
    }
}

export interface ILPGMonthlyGasFlaringReportDTO {
    elementName: string;
    totalVolume: number;
    totalVolumekSm3: number;
    totalMass: number;
}

export class LPGFuelGasFlaringDTO implements ILPGFuelGasFlaringDTO {
    timeStamp!: Date;
    totalMass!: number;
    totalVolume!: number;
    comment?: string | null;
    createdBy?: string | null;
    updatedBy?: string | null;
    elementName!: string;
    type!: LPGMonthlyInputRecordType;
    status!: string;

    constructor(data?: ILPGFuelGasFlaringDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): LPGFuelGasFlaringDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFuelGasFlaringDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface ILPGFuelGasFlaringDTO {
    timeStamp: Date;
    totalMass: number;
    totalVolume: number;
    comment?: string | null;
    createdBy?: string | null;
    updatedBy?: string | null;
    elementName: string;
    type: LPGMonthlyInputRecordType;
    status: string;
}

export class LPGFuelGasFlaringDefaultDTO implements ILPGFuelGasFlaringDefaultDTO {
    pilotGasRate?: number | null;
    purgeRate?: number | null;
    purgeRate2?: number | null;
    numberOfFuelGasLine?: number | null;

    constructor(data?: ILPGFuelGasFlaringDefaultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pilotGasRate = _data["pilotGasRate"] !== undefined ? _data["pilotGasRate"] : <any>null;
            this.purgeRate = _data["purgeRate"] !== undefined ? _data["purgeRate"] : <any>null;
            this.purgeRate2 = _data["purgeRate2"] !== undefined ? _data["purgeRate2"] : <any>null;
            this.numberOfFuelGasLine = _data["numberOfFuelGasLine"] !== undefined ? _data["numberOfFuelGasLine"] : <any>null;
        }
    }

    static fromJS(data: any): LPGFuelGasFlaringDefaultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFuelGasFlaringDefaultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pilotGasRate"] = this.pilotGasRate !== undefined ? this.pilotGasRate : <any>null;
        data["purgeRate"] = this.purgeRate !== undefined ? this.purgeRate : <any>null;
        data["purgeRate2"] = this.purgeRate2 !== undefined ? this.purgeRate2 : <any>null;
        data["numberOfFuelGasLine"] = this.numberOfFuelGasLine !== undefined ? this.numberOfFuelGasLine : <any>null;
        return data;
    }
}

export interface ILPGFuelGasFlaringDefaultDTO {
    pilotGasRate?: number | null;
    purgeRate?: number | null;
    purgeRate2?: number | null;
    numberOfFuelGasLine?: number | null;
}

export class LPGDataDTO implements ILPGDataDTO {
    year!: number;
    lpgData!: LPGCalculatedStreamDTO[];
    forAnalysts!: LPGDataForAnalystDTO[];
    bulletsEntry!: LPGDataBulletsEntryDTO[];

    constructor(data?: ILPGDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lpgData = [];
            this.forAnalysts = [];
            this.bulletsEntry = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            if (Array.isArray(_data["lpgData"])) {
                this.lpgData = [] as any;
                for (let item of _data["lpgData"])
                    this.lpgData!.push(LPGCalculatedStreamDTO.fromJS(item));
            }
            else {
                this.lpgData = <any>null;
            }
            if (Array.isArray(_data["forAnalysts"])) {
                this.forAnalysts = [] as any;
                for (let item of _data["forAnalysts"])
                    this.forAnalysts!.push(LPGDataForAnalystDTO.fromJS(item));
            }
            else {
                this.forAnalysts = <any>null;
            }
            if (Array.isArray(_data["bulletsEntry"])) {
                this.bulletsEntry = [] as any;
                for (let item of _data["bulletsEntry"])
                    this.bulletsEntry!.push(LPGDataBulletsEntryDTO.fromJS(item));
            }
            else {
                this.bulletsEntry = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : <any>null;
        if (Array.isArray(this.lpgData)) {
            data["lpgData"] = [];
            for (let item of this.lpgData)
                data["lpgData"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.forAnalysts)) {
            data["forAnalysts"] = [];
            for (let item of this.forAnalysts)
                data["forAnalysts"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.bulletsEntry)) {
            data["bulletsEntry"] = [];
            for (let item of this.bulletsEntry)
                data["bulletsEntry"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ILPGDataDTO {
    year: number;
    lpgData: LPGCalculatedStreamDTO[];
    forAnalysts: LPGDataForAnalystDTO[];
    bulletsEntry: LPGDataBulletsEntryDTO[];
}

export class LPGCalculatedStreamDTO implements ILPGCalculatedStreamDTO {
    timeStamp!: Date;
    isApproved!: boolean;
    isConfirmed!: boolean;
    totalMass!: number;
    totalVolume!: number;
    elementName!: string;
    status!: string;
    gasType!: LPGGasType;

    constructor(data?: ILPGCalculatedStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
        }
    }

    static fromJS(data: any): LPGCalculatedStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGCalculatedStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        return data;
    }
}

export interface ILPGCalculatedStreamDTO {
    timeStamp: Date;
    isApproved: boolean;
    isConfirmed: boolean;
    totalMass: number;
    totalVolume: number;
    elementName: string;
    status: string;
    gasType: LPGGasType;
}

export class LPGDataBulletsEntryDTO implements ILPGDataBulletsEntryDTO {
    timeStamp!: Date;
    propane!: number;
    butane!: number;
    elementName!: string;

    constructor(data?: ILPGDataBulletsEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.propane = _data["propane"] !== undefined ? _data["propane"] : <any>null;
            this.butane = _data["butane"] !== undefined ? _data["butane"] : <any>null;
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
        }
    }

    static fromJS(data: any): LPGDataBulletsEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGDataBulletsEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["propane"] = this.propane !== undefined ? this.propane : <any>null;
        data["butane"] = this.butane !== undefined ? this.butane : <any>null;
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        return data;
    }
}

export interface ILPGDataBulletsEntryDTO {
    timeStamp: Date;
    propane: number;
    butane: number;
    elementName: string;
}

export class LPGFlaringReportDTO implements ILPGFlaringReportDTO {
    elementsType!: LPGFlaringReportElementsType;
    items!: LPGFlaringReportItemDTO[];

    constructor(data?: ILPGFlaringReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementsType = _data["elementsType"] !== undefined ? _data["elementsType"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LPGFlaringReportItemDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGFlaringReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFlaringReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementsType"] = this.elementsType !== undefined ? this.elementsType : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ILPGFlaringReportDTO {
    elementsType: LPGFlaringReportElementsType;
    items: LPGFlaringReportItemDTO[];
}

export enum LPGFlaringReportElementsType {
    GasMixture = 0,
    DryGas = 1,
    Propane = 2,
    Butane = 3,
}

export class LPGFlaringReportItemDTO implements ILPGFlaringReportItemDTO {
    order!: number;
    value!: number;
    name!: string;

    constructor(data?: ILPGFlaringReportItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): LPGFlaringReportItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGFlaringReportItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ILPGFlaringReportItemDTO {
    order: number;
    value: number;
    name: string;
}

export class LPGTargetPermitInputDTO implements ILPGTargetPermitInputDTO {
    id!: number;
    limit!: PermitTargetInputType;
    category!: PermitTargetInputCategory;
    gasType?: LPGGasType | null;
    year!: number;
    january!: number;
    february!: number;
    march!: number;
    april!: number;
    may!: number;
    june!: number;
    july!: number;
    august!: number;
    september!: number;
    october!: number;
    november!: number;
    december!: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    logged!: Date;
    properties!: { [key: string]: any; };

    constructor(data?: ILPGTargetPermitInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.january = _data["january"] !== undefined ? _data["january"] : <any>null;
            this.february = _data["february"] !== undefined ? _data["february"] : <any>null;
            this.march = _data["march"] !== undefined ? _data["march"] : <any>null;
            this.april = _data["april"] !== undefined ? _data["april"] : <any>null;
            this.may = _data["may"] !== undefined ? _data["may"] : <any>null;
            this.june = _data["june"] !== undefined ? _data["june"] : <any>null;
            this.july = _data["july"] !== undefined ? _data["july"] : <any>null;
            this.august = _data["august"] !== undefined ? _data["august"] : <any>null;
            this.september = _data["september"] !== undefined ? _data["september"] : <any>null;
            this.october = _data["october"] !== undefined ? _data["october"] : <any>null;
            this.november = _data["november"] !== undefined ? _data["november"] : <any>null;
            this.december = _data["december"] !== undefined ? _data["december"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): LPGTargetPermitInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LPGTargetPermitInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["january"] = this.january !== undefined ? this.january : <any>null;
        data["february"] = this.february !== undefined ? this.february : <any>null;
        data["march"] = this.march !== undefined ? this.march : <any>null;
        data["april"] = this.april !== undefined ? this.april : <any>null;
        data["may"] = this.may !== undefined ? this.may : <any>null;
        data["june"] = this.june !== undefined ? this.june : <any>null;
        data["july"] = this.july !== undefined ? this.july : <any>null;
        data["august"] = this.august !== undefined ? this.august : <any>null;
        data["september"] = this.september !== undefined ? this.september : <any>null;
        data["october"] = this.october !== undefined ? this.october : <any>null;
        data["november"] = this.november !== undefined ? this.november : <any>null;
        data["december"] = this.december !== undefined ? this.december : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ILPGTargetPermitInputDTO {
    id: number;
    limit: PermitTargetInputType;
    category: PermitTargetInputCategory;
    gasType?: LPGGasType | null;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    createdBy?: string | null;
    updatedBy?: string | null;
    logged: Date;
    properties: { [key: string]: any; };
}

export class SGIInputRecordDTO implements ISGIInputRecordDTO {
    id!: number;
    startTime!: Date;
    ignoreFI26001!: boolean;
    eGlycolFiredHeaterInService!: boolean;
    ejectorInService!: boolean;
    weeklyWasteOilDrainedToF1054!: boolean;
    useComprAndSGTotalizerTags!: boolean;
    pV415HoursToFlare!: number;
    pV415HoursToFeed!: number;
    leakageSour?: number | null;
    leakageFuel?: number | null;
    overallBalanceBasis!: OverallBalanceBasis;
    sgiInputRecordWells!: SGIInputRecordWellDTO[];
    sgiGasCompositions!: SGIGasCompositionDTO[];
    properties!: { [key: string]: any; };

    constructor(data?: ISGIInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sgiInputRecordWells = [];
            this.sgiGasCompositions = [];
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.ignoreFI26001 = _data["ignoreFI26001"] !== undefined ? _data["ignoreFI26001"] : <any>null;
            this.eGlycolFiredHeaterInService = _data["eGlycolFiredHeaterInService"] !== undefined ? _data["eGlycolFiredHeaterInService"] : <any>null;
            this.ejectorInService = _data["ejectorInService"] !== undefined ? _data["ejectorInService"] : <any>null;
            this.weeklyWasteOilDrainedToF1054 = _data["weeklyWasteOilDrainedToF1054"] !== undefined ? _data["weeklyWasteOilDrainedToF1054"] : <any>null;
            this.useComprAndSGTotalizerTags = _data["useComprAndSGTotalizerTags"] !== undefined ? _data["useComprAndSGTotalizerTags"] : <any>null;
            this.pV415HoursToFlare = _data["pV415HoursToFlare"] !== undefined ? _data["pV415HoursToFlare"] : <any>null;
            this.pV415HoursToFeed = _data["pV415HoursToFeed"] !== undefined ? _data["pV415HoursToFeed"] : <any>null;
            this.leakageSour = _data["leakageSour"] !== undefined ? _data["leakageSour"] : <any>null;
            this.leakageFuel = _data["leakageFuel"] !== undefined ? _data["leakageFuel"] : <any>null;
            this.overallBalanceBasis = _data["overallBalanceBasis"] !== undefined ? _data["overallBalanceBasis"] : <any>null;
            if (Array.isArray(_data["sgiInputRecordWells"])) {
                this.sgiInputRecordWells = [] as any;
                for (let item of _data["sgiInputRecordWells"])
                    this.sgiInputRecordWells!.push(SGIInputRecordWellDTO.fromJS(item));
            }
            else {
                this.sgiInputRecordWells = <any>null;
            }
            if (Array.isArray(_data["sgiGasCompositions"])) {
                this.sgiGasCompositions = [] as any;
                for (let item of _data["sgiGasCompositions"])
                    this.sgiGasCompositions!.push(SGIGasCompositionDTO.fromJS(item));
            }
            else {
                this.sgiGasCompositions = <any>null;
            }
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): SGIInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["ignoreFI26001"] = this.ignoreFI26001 !== undefined ? this.ignoreFI26001 : <any>null;
        data["eGlycolFiredHeaterInService"] = this.eGlycolFiredHeaterInService !== undefined ? this.eGlycolFiredHeaterInService : <any>null;
        data["ejectorInService"] = this.ejectorInService !== undefined ? this.ejectorInService : <any>null;
        data["weeklyWasteOilDrainedToF1054"] = this.weeklyWasteOilDrainedToF1054 !== undefined ? this.weeklyWasteOilDrainedToF1054 : <any>null;
        data["useComprAndSGTotalizerTags"] = this.useComprAndSGTotalizerTags !== undefined ? this.useComprAndSGTotalizerTags : <any>null;
        data["pV415HoursToFlare"] = this.pV415HoursToFlare !== undefined ? this.pV415HoursToFlare : <any>null;
        data["pV415HoursToFeed"] = this.pV415HoursToFeed !== undefined ? this.pV415HoursToFeed : <any>null;
        data["leakageSour"] = this.leakageSour !== undefined ? this.leakageSour : <any>null;
        data["leakageFuel"] = this.leakageFuel !== undefined ? this.leakageFuel : <any>null;
        data["overallBalanceBasis"] = this.overallBalanceBasis !== undefined ? this.overallBalanceBasis : <any>null;
        if (Array.isArray(this.sgiInputRecordWells)) {
            data["sgiInputRecordWells"] = [];
            for (let item of this.sgiInputRecordWells)
                data["sgiInputRecordWells"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.sgiGasCompositions)) {
            data["sgiGasCompositions"] = [];
            for (let item of this.sgiGasCompositions)
                data["sgiGasCompositions"].push(item ? item.toJSON() : <any>null);
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISGIInputRecordDTO {
    id: number;
    startTime: Date;
    ignoreFI26001: boolean;
    eGlycolFiredHeaterInService: boolean;
    ejectorInService: boolean;
    weeklyWasteOilDrainedToF1054: boolean;
    useComprAndSGTotalizerTags: boolean;
    pV415HoursToFlare: number;
    pV415HoursToFeed: number;
    leakageSour?: number | null;
    leakageFuel?: number | null;
    overallBalanceBasis: OverallBalanceBasis;
    sgiInputRecordWells: SGIInputRecordWellDTO[];
    sgiGasCompositions: SGIGasCompositionDTO[];
    properties: { [key: string]: any; };
}

export enum OverallBalanceBasis {
    SGPSourGasFeedMeterToSGI = 0,
    InjectionCompressorFeedMeter = 1,
    WellInjectionMeters = 2,
}

export class SGIInputRecordWellDTO implements ISGIInputRecordWellDTO {
    id!: number;
    name!: string;
    wellInService!: boolean;
    useManualFlowCalc!: boolean;
    useTotalizerTags!: boolean;

    constructor(data?: ISGIInputRecordWellDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.wellInService = _data["wellInService"] !== undefined ? _data["wellInService"] : <any>null;
            this.useManualFlowCalc = _data["useManualFlowCalc"] !== undefined ? _data["useManualFlowCalc"] : <any>null;
            this.useTotalizerTags = _data["useTotalizerTags"] !== undefined ? _data["useTotalizerTags"] : <any>null;
        }
    }

    static fromJS(data: any): SGIInputRecordWellDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIInputRecordWellDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["wellInService"] = this.wellInService !== undefined ? this.wellInService : <any>null;
        data["useManualFlowCalc"] = this.useManualFlowCalc !== undefined ? this.useManualFlowCalc : <any>null;
        data["useTotalizerTags"] = this.useTotalizerTags !== undefined ? this.useTotalizerTags : <any>null;
        return data;
    }
}

export interface ISGIInputRecordWellDTO {
    id: number;
    name: string;
    wellInService: boolean;
    useManualFlowCalc: boolean;
    useTotalizerTags: boolean;
}

export class SGIGasCompositionDTO implements ISGIGasCompositionDTO {
    n2!: number;
    cO2!: number;
    c1!: number;
    c2!: number;
    c3!: number;
    iC4!: number;
    nC4!: number;
    iC5!: number;
    nC5!: number;
    c6Plus!: number;
    h2S!: number;
    cH3SH!: number;
    c2H5SH!: number;
    c2H7SH!: number;
    nC3H7SH!: number;
    nC4H9SH!: number;
    cos!: number;
    h2O!: number;
    o2!: number;
    h2!: number;
    he!: number;
    mw!: number;
    gasType!: SGIGasCompositionType;

    constructor(data?: ISGIGasCompositionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c2H7SH = _data["c2H7SH"] !== undefined ? _data["c2H7SH"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4H9SH = _data["nC4H9SH"] !== undefined ? _data["nC4H9SH"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.h2 = _data["h2"] !== undefined ? _data["h2"] : <any>null;
            this.he = _data["he"] !== undefined ? _data["he"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
        }
    }

    static fromJS(data: any): SGIGasCompositionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIGasCompositionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c2H7SH"] = this.c2H7SH !== undefined ? this.c2H7SH : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4H9SH"] = this.nC4H9SH !== undefined ? this.nC4H9SH : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["h2"] = this.h2 !== undefined ? this.h2 : <any>null;
        data["he"] = this.he !== undefined ? this.he : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        return data;
    }
}

export interface ISGIGasCompositionDTO {
    n2: number;
    cO2: number;
    c1: number;
    c2: number;
    c3: number;
    iC4: number;
    nC4: number;
    iC5: number;
    nC5: number;
    c6Plus: number;
    h2S: number;
    cH3SH: number;
    c2H5SH: number;
    c2H7SH: number;
    nC3H7SH: number;
    nC4H9SH: number;
    cos: number;
    h2O: number;
    o2: number;
    h2: number;
    he: number;
    mw: number;
    gasType: SGIGasCompositionType;
}

export enum SGIGasCompositionType {
    Sour = 0,
    Sweet = 1,
    Fuel = 2,
}

export class SGIEditOverrideDTO implements ISGIEditOverrideDTO {
    startTime!: Date;
    elementName!: string;
    value!: number;
    type!: SGIValueType;
    properties!: { [key: string]: any; };

    constructor(data?: ISGIEditOverrideDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): SGIEditOverrideDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIEditOverrideDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISGIEditOverrideDTO {
    startTime: Date;
    elementName: string;
    value: number;
    type: SGIValueType;
    properties: { [key: string]: any; };
}

export enum SGIValueType {
    Volume = 0,
    Duration = 1,
}

export class SGIBlowdownInputRecordDTO implements ISGIBlowdownInputRecordDTO {
    id!: number;
    startTime!: Date;
    category!: PermitTargetInputCategory;
    gasType!: SGIGasCompositionType;
    reason!: string;
    equipment!: string;
    volume!: number;
    mass!: number;
    sgiGasComposition!: SGIGasComposition;
    properties!: { [key: string]: any; };

    constructor(data?: ISGIBlowdownInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sgiGasComposition = new SGIGasComposition();
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.equipment = _data["equipment"] !== undefined ? _data["equipment"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.sgiGasComposition = _data["sgiGasComposition"] ? SGIGasComposition.fromJS(_data["sgiGasComposition"]) : new SGIGasComposition();
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): SGIBlowdownInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIBlowdownInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["equipment"] = this.equipment !== undefined ? this.equipment : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["sgiGasComposition"] = this.sgiGasComposition ? this.sgiGasComposition.toJSON() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISGIBlowdownInputRecordDTO {
    id: number;
    startTime: Date;
    category: PermitTargetInputCategory;
    gasType: SGIGasCompositionType;
    reason: string;
    equipment: string;
    volume: number;
    mass: number;
    sgiGasComposition: SGIGasComposition;
    properties: { [key: string]: any; };
}

export class SGIGasComposition implements ISGIGasComposition {
    id!: number;
    n2!: number;
    cO2!: number;
    c1!: number;
    c2!: number;
    c3!: number;
    iC4!: number;
    nC4!: number;
    iC5!: number;
    nC5!: number;
    c6Plus!: number;
    h2S!: number;
    cH3SH!: number;
    c2H5SH!: number;
    c2H7SH!: number;
    nC3H7SH!: number;
    nC4H9SH!: number;
    cos!: number;
    h2O!: number;
    o2!: number;
    h2!: number;
    he!: number;
    mw!: number;
    gasType!: SGIGasCompositionType;
    sgiBlowdownInputRecordId?: number | null;
    sgiBlowdownInputRecord?: SGIBlowdownInputRecord | null;
    sgiInputRecordId?: number | null;
    sgiInputRecord?: SGIInputRecord | null;

    constructor(data?: ISGIGasComposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.n2 = _data["n2"] !== undefined ? _data["n2"] : <any>null;
            this.cO2 = _data["cO2"] !== undefined ? _data["cO2"] : <any>null;
            this.c1 = _data["c1"] !== undefined ? _data["c1"] : <any>null;
            this.c2 = _data["c2"] !== undefined ? _data["c2"] : <any>null;
            this.c3 = _data["c3"] !== undefined ? _data["c3"] : <any>null;
            this.iC4 = _data["iC4"] !== undefined ? _data["iC4"] : <any>null;
            this.nC4 = _data["nC4"] !== undefined ? _data["nC4"] : <any>null;
            this.iC5 = _data["iC5"] !== undefined ? _data["iC5"] : <any>null;
            this.nC5 = _data["nC5"] !== undefined ? _data["nC5"] : <any>null;
            this.c6Plus = _data["c6Plus"] !== undefined ? _data["c6Plus"] : <any>null;
            this.h2S = _data["h2S"] !== undefined ? _data["h2S"] : <any>null;
            this.cH3SH = _data["cH3SH"] !== undefined ? _data["cH3SH"] : <any>null;
            this.c2H5SH = _data["c2H5SH"] !== undefined ? _data["c2H5SH"] : <any>null;
            this.c2H7SH = _data["c2H7SH"] !== undefined ? _data["c2H7SH"] : <any>null;
            this.nC3H7SH = _data["nC3H7SH"] !== undefined ? _data["nC3H7SH"] : <any>null;
            this.nC4H9SH = _data["nC4H9SH"] !== undefined ? _data["nC4H9SH"] : <any>null;
            this.cos = _data["cos"] !== undefined ? _data["cos"] : <any>null;
            this.h2O = _data["h2O"] !== undefined ? _data["h2O"] : <any>null;
            this.o2 = _data["o2"] !== undefined ? _data["o2"] : <any>null;
            this.h2 = _data["h2"] !== undefined ? _data["h2"] : <any>null;
            this.he = _data["he"] !== undefined ? _data["he"] : <any>null;
            this.mw = _data["mw"] !== undefined ? _data["mw"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.sgiBlowdownInputRecordId = _data["sgiBlowdownInputRecordId"] !== undefined ? _data["sgiBlowdownInputRecordId"] : <any>null;
            this.sgiBlowdownInputRecord = _data["sgiBlowdownInputRecord"] ? SGIBlowdownInputRecord.fromJS(_data["sgiBlowdownInputRecord"]) : <any>null;
            this.sgiInputRecordId = _data["sgiInputRecordId"] !== undefined ? _data["sgiInputRecordId"] : <any>null;
            this.sgiInputRecord = _data["sgiInputRecord"] ? SGIInputRecord.fromJS(_data["sgiInputRecord"]) : <any>null;
        }
    }

    static fromJS(data: any): SGIGasComposition {
        data = typeof data === 'object' ? data : {};
        let result = new SGIGasComposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["n2"] = this.n2 !== undefined ? this.n2 : <any>null;
        data["cO2"] = this.cO2 !== undefined ? this.cO2 : <any>null;
        data["c1"] = this.c1 !== undefined ? this.c1 : <any>null;
        data["c2"] = this.c2 !== undefined ? this.c2 : <any>null;
        data["c3"] = this.c3 !== undefined ? this.c3 : <any>null;
        data["iC4"] = this.iC4 !== undefined ? this.iC4 : <any>null;
        data["nC4"] = this.nC4 !== undefined ? this.nC4 : <any>null;
        data["iC5"] = this.iC5 !== undefined ? this.iC5 : <any>null;
        data["nC5"] = this.nC5 !== undefined ? this.nC5 : <any>null;
        data["c6Plus"] = this.c6Plus !== undefined ? this.c6Plus : <any>null;
        data["h2S"] = this.h2S !== undefined ? this.h2S : <any>null;
        data["cH3SH"] = this.cH3SH !== undefined ? this.cH3SH : <any>null;
        data["c2H5SH"] = this.c2H5SH !== undefined ? this.c2H5SH : <any>null;
        data["c2H7SH"] = this.c2H7SH !== undefined ? this.c2H7SH : <any>null;
        data["nC3H7SH"] = this.nC3H7SH !== undefined ? this.nC3H7SH : <any>null;
        data["nC4H9SH"] = this.nC4H9SH !== undefined ? this.nC4H9SH : <any>null;
        data["cos"] = this.cos !== undefined ? this.cos : <any>null;
        data["h2O"] = this.h2O !== undefined ? this.h2O : <any>null;
        data["o2"] = this.o2 !== undefined ? this.o2 : <any>null;
        data["h2"] = this.h2 !== undefined ? this.h2 : <any>null;
        data["he"] = this.he !== undefined ? this.he : <any>null;
        data["mw"] = this.mw !== undefined ? this.mw : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["sgiBlowdownInputRecordId"] = this.sgiBlowdownInputRecordId !== undefined ? this.sgiBlowdownInputRecordId : <any>null;
        data["sgiBlowdownInputRecord"] = this.sgiBlowdownInputRecord ? this.sgiBlowdownInputRecord.toJSON() : <any>null;
        data["sgiInputRecordId"] = this.sgiInputRecordId !== undefined ? this.sgiInputRecordId : <any>null;
        data["sgiInputRecord"] = this.sgiInputRecord ? this.sgiInputRecord.toJSON() : <any>null;
        return data;
    }
}

export interface ISGIGasComposition {
    id: number;
    n2: number;
    cO2: number;
    c1: number;
    c2: number;
    c3: number;
    iC4: number;
    nC4: number;
    iC5: number;
    nC5: number;
    c6Plus: number;
    h2S: number;
    cH3SH: number;
    c2H5SH: number;
    c2H7SH: number;
    nC3H7SH: number;
    nC4H9SH: number;
    cos: number;
    h2O: number;
    o2: number;
    h2: number;
    he: number;
    mw: number;
    gasType: SGIGasCompositionType;
    sgiBlowdownInputRecordId?: number | null;
    sgiBlowdownInputRecord?: SGIBlowdownInputRecord | null;
    sgiInputRecordId?: number | null;
    sgiInputRecord?: SGIInputRecord | null;
}

export class SGIBlowdownInputRecord implements ISGIBlowdownInputRecord {
    id!: number;
    startTime!: Date;
    category!: PermitTargetInputCategory;
    gasType!: SGIGasCompositionType;
    reason?: string | null;
    equipment?: string | null;
    volume!: number;
    mass!: number;
    sgiGasComposition?: SGIGasComposition | null;

    constructor(data?: ISGIBlowdownInputRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.equipment = _data["equipment"] !== undefined ? _data["equipment"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.mass = _data["mass"] !== undefined ? _data["mass"] : <any>null;
            this.sgiGasComposition = _data["sgiGasComposition"] ? SGIGasComposition.fromJS(_data["sgiGasComposition"]) : <any>null;
        }
    }

    static fromJS(data: any): SGIBlowdownInputRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SGIBlowdownInputRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["equipment"] = this.equipment !== undefined ? this.equipment : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["mass"] = this.mass !== undefined ? this.mass : <any>null;
        data["sgiGasComposition"] = this.sgiGasComposition ? this.sgiGasComposition.toJSON() : <any>null;
        return data;
    }
}

export interface ISGIBlowdownInputRecord {
    id: number;
    startTime: Date;
    category: PermitTargetInputCategory;
    gasType: SGIGasCompositionType;
    reason?: string | null;
    equipment?: string | null;
    volume: number;
    mass: number;
    sgiGasComposition?: SGIGasComposition | null;
}

export class SGIInputRecord implements ISGIInputRecord {
    id!: number;
    startTime!: Date;
    ignoreFI26001!: boolean;
    eGlycolFiredHeaterInService!: boolean;
    ejectorInService!: boolean;
    weeklyWasteOilDrainedToF1054!: boolean;
    useComprAndSGTotalizerTags!: boolean;
    pV415HoursToFlare!: number;
    pV415HoursToFeed!: number;
    leakageSour!: number;
    leakageFuel!: number;
    overallBalanceBasis!: OverallBalanceBasis;
    sgiInputRecordWells?: SGIInputRecordWell[] | null;
    sgiGasCompositions?: SGIGasComposition[] | null;

    constructor(data?: ISGIInputRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.ignoreFI26001 = _data["ignoreFI26001"] !== undefined ? _data["ignoreFI26001"] : <any>null;
            this.eGlycolFiredHeaterInService = _data["eGlycolFiredHeaterInService"] !== undefined ? _data["eGlycolFiredHeaterInService"] : <any>null;
            this.ejectorInService = _data["ejectorInService"] !== undefined ? _data["ejectorInService"] : <any>null;
            this.weeklyWasteOilDrainedToF1054 = _data["weeklyWasteOilDrainedToF1054"] !== undefined ? _data["weeklyWasteOilDrainedToF1054"] : <any>null;
            this.useComprAndSGTotalizerTags = _data["useComprAndSGTotalizerTags"] !== undefined ? _data["useComprAndSGTotalizerTags"] : <any>null;
            this.pV415HoursToFlare = _data["pV415HoursToFlare"] !== undefined ? _data["pV415HoursToFlare"] : <any>null;
            this.pV415HoursToFeed = _data["pV415HoursToFeed"] !== undefined ? _data["pV415HoursToFeed"] : <any>null;
            this.leakageSour = _data["leakageSour"] !== undefined ? _data["leakageSour"] : <any>null;
            this.leakageFuel = _data["leakageFuel"] !== undefined ? _data["leakageFuel"] : <any>null;
            this.overallBalanceBasis = _data["overallBalanceBasis"] !== undefined ? _data["overallBalanceBasis"] : <any>null;
            if (Array.isArray(_data["sgiInputRecordWells"])) {
                this.sgiInputRecordWells = [] as any;
                for (let item of _data["sgiInputRecordWells"])
                    this.sgiInputRecordWells!.push(SGIInputRecordWell.fromJS(item));
            }
            else {
                this.sgiInputRecordWells = <any>null;
            }
            if (Array.isArray(_data["sgiGasCompositions"])) {
                this.sgiGasCompositions = [] as any;
                for (let item of _data["sgiGasCompositions"])
                    this.sgiGasCompositions!.push(SGIGasComposition.fromJS(item));
            }
            else {
                this.sgiGasCompositions = <any>null;
            }
        }
    }

    static fromJS(data: any): SGIInputRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SGIInputRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["ignoreFI26001"] = this.ignoreFI26001 !== undefined ? this.ignoreFI26001 : <any>null;
        data["eGlycolFiredHeaterInService"] = this.eGlycolFiredHeaterInService !== undefined ? this.eGlycolFiredHeaterInService : <any>null;
        data["ejectorInService"] = this.ejectorInService !== undefined ? this.ejectorInService : <any>null;
        data["weeklyWasteOilDrainedToF1054"] = this.weeklyWasteOilDrainedToF1054 !== undefined ? this.weeklyWasteOilDrainedToF1054 : <any>null;
        data["useComprAndSGTotalizerTags"] = this.useComprAndSGTotalizerTags !== undefined ? this.useComprAndSGTotalizerTags : <any>null;
        data["pV415HoursToFlare"] = this.pV415HoursToFlare !== undefined ? this.pV415HoursToFlare : <any>null;
        data["pV415HoursToFeed"] = this.pV415HoursToFeed !== undefined ? this.pV415HoursToFeed : <any>null;
        data["leakageSour"] = this.leakageSour !== undefined ? this.leakageSour : <any>null;
        data["leakageFuel"] = this.leakageFuel !== undefined ? this.leakageFuel : <any>null;
        data["overallBalanceBasis"] = this.overallBalanceBasis !== undefined ? this.overallBalanceBasis : <any>null;
        if (Array.isArray(this.sgiInputRecordWells)) {
            data["sgiInputRecordWells"] = [];
            for (let item of this.sgiInputRecordWells)
                data["sgiInputRecordWells"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.sgiGasCompositions)) {
            data["sgiGasCompositions"] = [];
            for (let item of this.sgiGasCompositions)
                data["sgiGasCompositions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ISGIInputRecord {
    id: number;
    startTime: Date;
    ignoreFI26001: boolean;
    eGlycolFiredHeaterInService: boolean;
    ejectorInService: boolean;
    weeklyWasteOilDrainedToF1054: boolean;
    useComprAndSGTotalizerTags: boolean;
    pV415HoursToFlare: number;
    pV415HoursToFeed: number;
    leakageSour: number;
    leakageFuel: number;
    overallBalanceBasis: OverallBalanceBasis;
    sgiInputRecordWells?: SGIInputRecordWell[] | null;
    sgiGasCompositions?: SGIGasComposition[] | null;
}

export class SGIInputRecordWell implements ISGIInputRecordWell {
    id!: number;
    name?: string | null;
    wellInService!: boolean;
    useManualFlowCalc!: boolean;
    useTotalizerTags!: boolean;
    sgiInputRecord?: SGIInputRecord | null;
    sgiInputRecordId!: number;

    constructor(data?: ISGIInputRecordWell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.wellInService = _data["wellInService"] !== undefined ? _data["wellInService"] : <any>null;
            this.useManualFlowCalc = _data["useManualFlowCalc"] !== undefined ? _data["useManualFlowCalc"] : <any>null;
            this.useTotalizerTags = _data["useTotalizerTags"] !== undefined ? _data["useTotalizerTags"] : <any>null;
            this.sgiInputRecord = _data["sgiInputRecord"] ? SGIInputRecord.fromJS(_data["sgiInputRecord"]) : <any>null;
            this.sgiInputRecordId = _data["sgiInputRecordId"] !== undefined ? _data["sgiInputRecordId"] : <any>null;
        }
    }

    static fromJS(data: any): SGIInputRecordWell {
        data = typeof data === 'object' ? data : {};
        let result = new SGIInputRecordWell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["wellInService"] = this.wellInService !== undefined ? this.wellInService : <any>null;
        data["useManualFlowCalc"] = this.useManualFlowCalc !== undefined ? this.useManualFlowCalc : <any>null;
        data["useTotalizerTags"] = this.useTotalizerTags !== undefined ? this.useTotalizerTags : <any>null;
        data["sgiInputRecord"] = this.sgiInputRecord ? this.sgiInputRecord.toJSON() : <any>null;
        data["sgiInputRecordId"] = this.sgiInputRecordId !== undefined ? this.sgiInputRecordId : <any>null;
        return data;
    }
}

export interface ISGIInputRecordWell {
    id: number;
    name?: string | null;
    wellInService: boolean;
    useManualFlowCalc: boolean;
    useTotalizerTags: boolean;
    sgiInputRecord?: SGIInputRecord | null;
    sgiInputRecordId: number;
}

export class SGIPermitTargetInputDTO implements ISGIPermitTargetInputDTO {
    id!: number;
    year!: Date;
    logged!: Date;
    user!: string;
    gasType!: SGIPermitTargetInputGasType;
    inputType!: SGIPermitTargetInputType;
    category?: PermitTargetInputCategory | null;
    sgiPermitTargetMonthVolumes!: SGIPermitTargetMonthVolumeDTO;
    properties!: { [key: string]: any; };

    constructor(data?: ISGIPermitTargetInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sgiPermitTargetMonthVolumes = new SGIPermitTargetMonthVolumeDTO();
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.year = _data["year"] ? new Date(_data["year"].toString()) : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.gasType = _data["gasType"] !== undefined ? _data["gasType"] : <any>null;
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.sgiPermitTargetMonthVolumes = _data["sgiPermitTargetMonthVolumes"] ? SGIPermitTargetMonthVolumeDTO.fromJS(_data["sgiPermitTargetMonthVolumes"]) : new SGIPermitTargetMonthVolumeDTO();
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): SGIPermitTargetInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIPermitTargetInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["year"] = this.year ? this.year.toISOString() : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["gasType"] = this.gasType !== undefined ? this.gasType : <any>null;
        data["inputType"] = this.inputType !== undefined ? this.inputType : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["sgiPermitTargetMonthVolumes"] = this.sgiPermitTargetMonthVolumes ? this.sgiPermitTargetMonthVolumes.toJSON() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISGIPermitTargetInputDTO {
    id: number;
    year: Date;
    logged: Date;
    user: string;
    gasType: SGIPermitTargetInputGasType;
    inputType: SGIPermitTargetInputType;
    category?: PermitTargetInputCategory | null;
    sgiPermitTargetMonthVolumes: SGIPermitTargetMonthVolumeDTO;
    properties: { [key: string]: any; };
}

export enum SGIPermitTargetInputGasType {
    Sour = 0,
    Fuel = 1,
    GasTurbine = 2,
    PU9257 = 3,
    Sweet = 4,
}

export enum SGIPermitTargetInputType {
    Permit = 0,
    Target = 1,
    FuelGasUsage = 2,
}

export class SGIPermitTargetMonthVolumeDTO implements ISGIPermitTargetMonthVolumeDTO {
    june!: number;
    july!: number;
    august!: number;
    september!: number;
    october!: number;
    november!: number;
    december!: number;
    january!: number;
    february!: number;
    march!: number;
    april!: number;
    may!: number;

    constructor(data?: ISGIPermitTargetMonthVolumeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.june = _data["june"] !== undefined ? _data["june"] : <any>null;
            this.july = _data["july"] !== undefined ? _data["july"] : <any>null;
            this.august = _data["august"] !== undefined ? _data["august"] : <any>null;
            this.september = _data["september"] !== undefined ? _data["september"] : <any>null;
            this.october = _data["october"] !== undefined ? _data["october"] : <any>null;
            this.november = _data["november"] !== undefined ? _data["november"] : <any>null;
            this.december = _data["december"] !== undefined ? _data["december"] : <any>null;
            this.january = _data["january"] !== undefined ? _data["january"] : <any>null;
            this.february = _data["february"] !== undefined ? _data["february"] : <any>null;
            this.march = _data["march"] !== undefined ? _data["march"] : <any>null;
            this.april = _data["april"] !== undefined ? _data["april"] : <any>null;
            this.may = _data["may"] !== undefined ? _data["may"] : <any>null;
        }
    }

    static fromJS(data: any): SGIPermitTargetMonthVolumeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGIPermitTargetMonthVolumeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["june"] = this.june !== undefined ? this.june : <any>null;
        data["july"] = this.july !== undefined ? this.july : <any>null;
        data["august"] = this.august !== undefined ? this.august : <any>null;
        data["september"] = this.september !== undefined ? this.september : <any>null;
        data["october"] = this.october !== undefined ? this.october : <any>null;
        data["november"] = this.november !== undefined ? this.november : <any>null;
        data["december"] = this.december !== undefined ? this.december : <any>null;
        data["january"] = this.january !== undefined ? this.january : <any>null;
        data["february"] = this.february !== undefined ? this.february : <any>null;
        data["march"] = this.march !== undefined ? this.march : <any>null;
        data["april"] = this.april !== undefined ? this.april : <any>null;
        data["may"] = this.may !== undefined ? this.may : <any>null;
        return data;
    }
}

export interface ISGIPermitTargetMonthVolumeDTO {
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
}

export class SGPFGDCalculatedDTO implements ISGPFGDCalculatedDTO {
    streamId!: number;
    type!: string;
    timeStamp!: Date;
    isApproved!: boolean;
    isConfirmed!: boolean;
    totalMass!: number;
    totalVolume!: number;
    elementName!: string;
    order!: number;
    status!: StreamStatuses;

    constructor(data?: ISGPFGDCalculatedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.totalMass = _data["totalMass"] !== undefined ? _data["totalMass"] : <any>null;
            this.totalVolume = _data["totalVolume"] !== undefined ? _data["totalVolume"] : <any>null;
            this.elementName = _data["elementName"] !== undefined ? _data["elementName"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): SGPFGDCalculatedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGPFGDCalculatedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["totalMass"] = this.totalMass !== undefined ? this.totalMass : <any>null;
        data["totalVolume"] = this.totalVolume !== undefined ? this.totalVolume : <any>null;
        data["elementName"] = this.elementName !== undefined ? this.elementName : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface ISGPFGDCalculatedDTO {
    streamId: number;
    type: string;
    timeStamp: Date;
    isApproved: boolean;
    isConfirmed: boolean;
    totalMass: number;
    totalVolume: number;
    elementName: string;
    order: number;
    status: StreamStatuses;
}

export class SGPFGDInputRecordDTO implements ISGPFGDInputRecordDTO {
    id!: number;
    startTime!: Date;
    propaneToExport!: boolean;
    butaneToExport!: boolean;
    producedDryGas!: boolean;
    salesGasToExport!: boolean;
    salesGasToSGI!: boolean;
    sourGasToSGI!: boolean;
    useMeter!: UseMeterSGPFGD;
    sgpSalesGasToPowerPlant!: boolean;
    ktlSalesGasToPowerPlant!: boolean;
    crudeToStorage!: number;
    crudeToCRL!: number;
    directCrudeExportToCPC!: number;
    propaneToExportNum!: number;
    butaneToExportNum!: number;
    sulfur!: number;
    salesGasFQI07018!: number;
    properties!: { [key: string]: any; };

    constructor(data?: ISGPFGDInputRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.propaneToExport = _data["propaneToExport"] !== undefined ? _data["propaneToExport"] : <any>null;
            this.butaneToExport = _data["butaneToExport"] !== undefined ? _data["butaneToExport"] : <any>null;
            this.producedDryGas = _data["producedDryGas"] !== undefined ? _data["producedDryGas"] : <any>null;
            this.salesGasToExport = _data["salesGasToExport"] !== undefined ? _data["salesGasToExport"] : <any>null;
            this.salesGasToSGI = _data["salesGasToSGI"] !== undefined ? _data["salesGasToSGI"] : <any>null;
            this.sourGasToSGI = _data["sourGasToSGI"] !== undefined ? _data["sourGasToSGI"] : <any>null;
            this.useMeter = _data["useMeter"] !== undefined ? _data["useMeter"] : <any>null;
            this.sgpSalesGasToPowerPlant = _data["sgpSalesGasToPowerPlant"] !== undefined ? _data["sgpSalesGasToPowerPlant"] : <any>null;
            this.ktlSalesGasToPowerPlant = _data["ktlSalesGasToPowerPlant"] !== undefined ? _data["ktlSalesGasToPowerPlant"] : <any>null;
            this.crudeToStorage = _data["crudeToStorage"] !== undefined ? _data["crudeToStorage"] : <any>null;
            this.crudeToCRL = _data["crudeToCRL"] !== undefined ? _data["crudeToCRL"] : <any>null;
            this.directCrudeExportToCPC = _data["directCrudeExportToCPC"] !== undefined ? _data["directCrudeExportToCPC"] : <any>null;
            this.propaneToExportNum = _data["propaneToExportNum"] !== undefined ? _data["propaneToExportNum"] : <any>null;
            this.butaneToExportNum = _data["butaneToExportNum"] !== undefined ? _data["butaneToExportNum"] : <any>null;
            this.sulfur = _data["sulfur"] !== undefined ? _data["sulfur"] : <any>null;
            this.salesGasFQI07018 = _data["salesGasFQI07018"] !== undefined ? _data["salesGasFQI07018"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): SGPFGDInputRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGPFGDInputRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["propaneToExport"] = this.propaneToExport !== undefined ? this.propaneToExport : <any>null;
        data["butaneToExport"] = this.butaneToExport !== undefined ? this.butaneToExport : <any>null;
        data["producedDryGas"] = this.producedDryGas !== undefined ? this.producedDryGas : <any>null;
        data["salesGasToExport"] = this.salesGasToExport !== undefined ? this.salesGasToExport : <any>null;
        data["salesGasToSGI"] = this.salesGasToSGI !== undefined ? this.salesGasToSGI : <any>null;
        data["sourGasToSGI"] = this.sourGasToSGI !== undefined ? this.sourGasToSGI : <any>null;
        data["useMeter"] = this.useMeter !== undefined ? this.useMeter : <any>null;
        data["sgpSalesGasToPowerPlant"] = this.sgpSalesGasToPowerPlant !== undefined ? this.sgpSalesGasToPowerPlant : <any>null;
        data["ktlSalesGasToPowerPlant"] = this.ktlSalesGasToPowerPlant !== undefined ? this.ktlSalesGasToPowerPlant : <any>null;
        data["crudeToStorage"] = this.crudeToStorage !== undefined ? this.crudeToStorage : <any>null;
        data["crudeToCRL"] = this.crudeToCRL !== undefined ? this.crudeToCRL : <any>null;
        data["directCrudeExportToCPC"] = this.directCrudeExportToCPC !== undefined ? this.directCrudeExportToCPC : <any>null;
        data["propaneToExportNum"] = this.propaneToExportNum !== undefined ? this.propaneToExportNum : <any>null;
        data["butaneToExportNum"] = this.butaneToExportNum !== undefined ? this.butaneToExportNum : <any>null;
        data["sulfur"] = this.sulfur !== undefined ? this.sulfur : <any>null;
        data["salesGasFQI07018"] = this.salesGasFQI07018 !== undefined ? this.salesGasFQI07018 : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISGPFGDInputRecordDTO {
    id: number;
    startTime: Date;
    propaneToExport: boolean;
    butaneToExport: boolean;
    producedDryGas: boolean;
    salesGasToExport: boolean;
    salesGasToSGI: boolean;
    sourGasToSGI: boolean;
    useMeter: UseMeterSGPFGD;
    sgpSalesGasToPowerPlant: boolean;
    ktlSalesGasToPowerPlant: boolean;
    crudeToStorage: number;
    crudeToCRL: number;
    directCrudeExportToCPC: number;
    propaneToExportNum: number;
    butaneToExportNum: number;
    sulfur: number;
    salesGasFQI07018: number;
    properties: { [key: string]: any; };
}

export enum UseMeterSGPFGD {
    UseMeter03029 = 0,
    UseMeter29402 = 1,
}

export class SGPFGDOverrideRecordDTO implements ISGPFGDOverrideRecordDTO {
    streamId!: number;
    startTime!: Date;
    value!: number;
    type!: ValueType;
    properties!: { [key: string]: any; };

    constructor(data?: ISGPFGDOverrideRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streamId = _data["streamId"] !== undefined ? _data["streamId"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): SGPFGDOverrideRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SGPFGDOverrideRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streamId"] = this.streamId !== undefined ? this.streamId : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISGPFGDOverrideRecordDTO {
    streamId: number;
    startTime: Date;
    value: number;
    type: ValueType;
    properties: { [key: string]: any; };
}

export enum ValueType {
    Volume = 0,
    Mass = 1,
}

export class KTLSGPSO2CalculatedReportDTO implements IKTLSGPSO2CalculatedReportDTO {
    timeStamp!: Date;
    totalVolumeSGP!: number;
    totalVolumeKTLTrain1!: number;
    totalVolumeKTLTrain2!: number;
    totalVolumeKTLTrain3!: number;
    totalVolumeKTLTrain4!: number;
    inputCommentSGP!: string;
    inputCommentKTLTrain1!: string;
    inputCommentKTLTrain2!: string;
    inputCommentKTLTrain3!: string;
    inputCommentKTLTrain4!: string;
    updatedKTL!: string;
    updatedSGP!: string;
    isConfirmed!: boolean;
    isApproved!: boolean;
    isBadKTLTrain1!: boolean;
    isBadKTLTrain2!: boolean;
    isBadKTLTrain3!: boolean;
    isBadKTLTrain4!: boolean;
    isBadSGP!: boolean;

    constructor(data?: IKTLSGPSO2CalculatedReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>null;
            this.totalVolumeSGP = _data["totalVolumeSGP"] !== undefined ? _data["totalVolumeSGP"] : <any>null;
            this.totalVolumeKTLTrain1 = _data["totalVolumeKTLTrain1"] !== undefined ? _data["totalVolumeKTLTrain1"] : <any>null;
            this.totalVolumeKTLTrain2 = _data["totalVolumeKTLTrain2"] !== undefined ? _data["totalVolumeKTLTrain2"] : <any>null;
            this.totalVolumeKTLTrain3 = _data["totalVolumeKTLTrain3"] !== undefined ? _data["totalVolumeKTLTrain3"] : <any>null;
            this.totalVolumeKTLTrain4 = _data["totalVolumeKTLTrain4"] !== undefined ? _data["totalVolumeKTLTrain4"] : <any>null;
            this.inputCommentSGP = _data["inputCommentSGP"] !== undefined ? _data["inputCommentSGP"] : <any>null;
            this.inputCommentKTLTrain1 = _data["inputCommentKTLTrain1"] !== undefined ? _data["inputCommentKTLTrain1"] : <any>null;
            this.inputCommentKTLTrain2 = _data["inputCommentKTLTrain2"] !== undefined ? _data["inputCommentKTLTrain2"] : <any>null;
            this.inputCommentKTLTrain3 = _data["inputCommentKTLTrain3"] !== undefined ? _data["inputCommentKTLTrain3"] : <any>null;
            this.inputCommentKTLTrain4 = _data["inputCommentKTLTrain4"] !== undefined ? _data["inputCommentKTLTrain4"] : <any>null;
            this.updatedKTL = _data["updatedKTL"] !== undefined ? _data["updatedKTL"] : <any>null;
            this.updatedSGP = _data["updatedSGP"] !== undefined ? _data["updatedSGP"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : <any>null;
            this.isBadKTLTrain1 = _data["isBadKTLTrain1"] !== undefined ? _data["isBadKTLTrain1"] : <any>null;
            this.isBadKTLTrain2 = _data["isBadKTLTrain2"] !== undefined ? _data["isBadKTLTrain2"] : <any>null;
            this.isBadKTLTrain3 = _data["isBadKTLTrain3"] !== undefined ? _data["isBadKTLTrain3"] : <any>null;
            this.isBadKTLTrain4 = _data["isBadKTLTrain4"] !== undefined ? _data["isBadKTLTrain4"] : <any>null;
            this.isBadSGP = _data["isBadSGP"] !== undefined ? _data["isBadSGP"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPSO2CalculatedReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPSO2CalculatedReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["totalVolumeSGP"] = this.totalVolumeSGP !== undefined ? this.totalVolumeSGP : <any>null;
        data["totalVolumeKTLTrain1"] = this.totalVolumeKTLTrain1 !== undefined ? this.totalVolumeKTLTrain1 : <any>null;
        data["totalVolumeKTLTrain2"] = this.totalVolumeKTLTrain2 !== undefined ? this.totalVolumeKTLTrain2 : <any>null;
        data["totalVolumeKTLTrain3"] = this.totalVolumeKTLTrain3 !== undefined ? this.totalVolumeKTLTrain3 : <any>null;
        data["totalVolumeKTLTrain4"] = this.totalVolumeKTLTrain4 !== undefined ? this.totalVolumeKTLTrain4 : <any>null;
        data["inputCommentSGP"] = this.inputCommentSGP !== undefined ? this.inputCommentSGP : <any>null;
        data["inputCommentKTLTrain1"] = this.inputCommentKTLTrain1 !== undefined ? this.inputCommentKTLTrain1 : <any>null;
        data["inputCommentKTLTrain2"] = this.inputCommentKTLTrain2 !== undefined ? this.inputCommentKTLTrain2 : <any>null;
        data["inputCommentKTLTrain3"] = this.inputCommentKTLTrain3 !== undefined ? this.inputCommentKTLTrain3 : <any>null;
        data["inputCommentKTLTrain4"] = this.inputCommentKTLTrain4 !== undefined ? this.inputCommentKTLTrain4 : <any>null;
        data["updatedKTL"] = this.updatedKTL !== undefined ? this.updatedKTL : <any>null;
        data["updatedSGP"] = this.updatedSGP !== undefined ? this.updatedSGP : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : <any>null;
        data["isBadKTLTrain1"] = this.isBadKTLTrain1 !== undefined ? this.isBadKTLTrain1 : <any>null;
        data["isBadKTLTrain2"] = this.isBadKTLTrain2 !== undefined ? this.isBadKTLTrain2 : <any>null;
        data["isBadKTLTrain3"] = this.isBadKTLTrain3 !== undefined ? this.isBadKTLTrain3 : <any>null;
        data["isBadKTLTrain4"] = this.isBadKTLTrain4 !== undefined ? this.isBadKTLTrain4 : <any>null;
        data["isBadSGP"] = this.isBadSGP !== undefined ? this.isBadSGP : <any>null;
        return data;
    }
}

export interface IKTLSGPSO2CalculatedReportDTO {
    timeStamp: Date;
    totalVolumeSGP: number;
    totalVolumeKTLTrain1: number;
    totalVolumeKTLTrain2: number;
    totalVolumeKTLTrain3: number;
    totalVolumeKTLTrain4: number;
    inputCommentSGP: string;
    inputCommentKTLTrain1: string;
    inputCommentKTLTrain2: string;
    inputCommentKTLTrain3: string;
    inputCommentKTLTrain4: string;
    updatedKTL: string;
    updatedSGP: string;
    isConfirmed: boolean;
    isApproved: boolean;
    isBadKTLTrain1: boolean;
    isBadKTLTrain2: boolean;
    isBadKTLTrain3: boolean;
    isBadKTLTrain4: boolean;
    isBadSGP: boolean;
}

export class KTLSGPSO2RecordDTO implements IKTLSGPSO2RecordDTO {
    startTime!: Date;
    totalVolumeSGP!: number;
    inputCommentSGP!: string;
    totalVolumeKTLTrain1!: number;
    totalVolumeKTLTrain2!: number;
    totalVolumeKTLTrain3!: number;
    totalVolumeKTLTrain4!: number;
    inputCommentKTLTrain1!: string;
    inputCommentKTLTrain2!: string;
    inputCommentKTLTrain3!: string;
    inputCommentKTLTrain4!: string;
    plant!: Plant;

    constructor(data?: IKTLSGPSO2RecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.totalVolumeSGP = _data["totalVolumeSGP"] !== undefined ? _data["totalVolumeSGP"] : <any>null;
            this.inputCommentSGP = _data["inputCommentSGP"] !== undefined ? _data["inputCommentSGP"] : <any>null;
            this.totalVolumeKTLTrain1 = _data["totalVolumeKTLTrain1"] !== undefined ? _data["totalVolumeKTLTrain1"] : <any>null;
            this.totalVolumeKTLTrain2 = _data["totalVolumeKTLTrain2"] !== undefined ? _data["totalVolumeKTLTrain2"] : <any>null;
            this.totalVolumeKTLTrain3 = _data["totalVolumeKTLTrain3"] !== undefined ? _data["totalVolumeKTLTrain3"] : <any>null;
            this.totalVolumeKTLTrain4 = _data["totalVolumeKTLTrain4"] !== undefined ? _data["totalVolumeKTLTrain4"] : <any>null;
            this.inputCommentKTLTrain1 = _data["inputCommentKTLTrain1"] !== undefined ? _data["inputCommentKTLTrain1"] : <any>null;
            this.inputCommentKTLTrain2 = _data["inputCommentKTLTrain2"] !== undefined ? _data["inputCommentKTLTrain2"] : <any>null;
            this.inputCommentKTLTrain3 = _data["inputCommentKTLTrain3"] !== undefined ? _data["inputCommentKTLTrain3"] : <any>null;
            this.inputCommentKTLTrain4 = _data["inputCommentKTLTrain4"] !== undefined ? _data["inputCommentKTLTrain4"] : <any>null;
            this.plant = _data["plant"] !== undefined ? _data["plant"] : <any>null;
        }
    }

    static fromJS(data: any): KTLSGPSO2RecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPSO2RecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["totalVolumeSGP"] = this.totalVolumeSGP !== undefined ? this.totalVolumeSGP : <any>null;
        data["inputCommentSGP"] = this.inputCommentSGP !== undefined ? this.inputCommentSGP : <any>null;
        data["totalVolumeKTLTrain1"] = this.totalVolumeKTLTrain1 !== undefined ? this.totalVolumeKTLTrain1 : <any>null;
        data["totalVolumeKTLTrain2"] = this.totalVolumeKTLTrain2 !== undefined ? this.totalVolumeKTLTrain2 : <any>null;
        data["totalVolumeKTLTrain3"] = this.totalVolumeKTLTrain3 !== undefined ? this.totalVolumeKTLTrain3 : <any>null;
        data["totalVolumeKTLTrain4"] = this.totalVolumeKTLTrain4 !== undefined ? this.totalVolumeKTLTrain4 : <any>null;
        data["inputCommentKTLTrain1"] = this.inputCommentKTLTrain1 !== undefined ? this.inputCommentKTLTrain1 : <any>null;
        data["inputCommentKTLTrain2"] = this.inputCommentKTLTrain2 !== undefined ? this.inputCommentKTLTrain2 : <any>null;
        data["inputCommentKTLTrain3"] = this.inputCommentKTLTrain3 !== undefined ? this.inputCommentKTLTrain3 : <any>null;
        data["inputCommentKTLTrain4"] = this.inputCommentKTLTrain4 !== undefined ? this.inputCommentKTLTrain4 : <any>null;
        data["plant"] = this.plant !== undefined ? this.plant : <any>null;
        return data;
    }
}

export interface IKTLSGPSO2RecordDTO {
    startTime: Date;
    totalVolumeSGP: number;
    inputCommentSGP: string;
    totalVolumeKTLTrain1: number;
    totalVolumeKTLTrain2: number;
    totalVolumeKTLTrain3: number;
    totalVolumeKTLTrain4: number;
    inputCommentKTLTrain1: string;
    inputCommentKTLTrain2: string;
    inputCommentKTLTrain3: string;
    inputCommentKTLTrain4: string;
    plant: Plant;
}

export class PagedListOfKTLSGPSO2ProjectedDataInputDTO implements IPagedListOfKTLSGPSO2ProjectedDataInputDTO {
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;
    items!: KTLSGPSO2ProjectedDataInputDTO[];

    constructor(data?: IPagedListOfKTLSGPSO2ProjectedDataInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.hasPreviousPage = _data["hasPreviousPage"] !== undefined ? _data["hasPreviousPage"] : <any>null;
            this.hasNextPage = _data["hasNextPage"] !== undefined ? _data["hasNextPage"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KTLSGPSO2ProjectedDataInputDTO.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PagedListOfKTLSGPSO2ProjectedDataInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfKTLSGPSO2ProjectedDataInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["hasPreviousPage"] = this.hasPreviousPage !== undefined ? this.hasPreviousPage : <any>null;
        data["hasNextPage"] = this.hasNextPage !== undefined ? this.hasNextPage : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPagedListOfKTLSGPSO2ProjectedDataInputDTO {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    items: KTLSGPSO2ProjectedDataInputDTO[];
}

export class KTLSGPSO2ProjectedDataInputDTO implements IKTLSGPSO2ProjectedDataInputDTO {
    id!: number;
    startTime!: Date;
    endTime!: Date;
    plant!: Plant;
    ktlTrains!: KTLTrains;
    volume!: number;
    user!: string;
    comment!: string;
    properties!: { [key: string]: any; };

    constructor(data?: IKTLSGPSO2ProjectedDataInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.plant = _data["plant"] !== undefined ? _data["plant"] : <any>null;
            this.ktlTrains = _data["ktlTrains"] !== undefined ? _data["ktlTrains"] : <any>null;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): KTLSGPSO2ProjectedDataInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPSO2ProjectedDataInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["plant"] = this.plant !== undefined ? this.plant : <any>null;
        data["ktlTrains"] = this.ktlTrains !== undefined ? this.ktlTrains : <any>null;
        data["volume"] = this.volume !== undefined ? this.volume : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IKTLSGPSO2ProjectedDataInputDTO {
    id: number;
    startTime: Date;
    endTime: Date;
    plant: Plant;
    ktlTrains: KTLTrains;
    volume: number;
    user: string;
    comment: string;
    properties: { [key: string]: any; };
}

export class SO2FlowmeterGraphDTO implements ISO2FlowmeterGraphDTO {
    title!: string;
    values!: SO2FlowmeterValuesDTO[];

    constructor(data?: ISO2FlowmeterGraphDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(SO2FlowmeterValuesDTO.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): SO2FlowmeterGraphDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SO2FlowmeterGraphDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ISO2FlowmeterGraphDTO {
    title: string;
    values: SO2FlowmeterValuesDTO[];
}

export class SO2FlowmeterValuesDTO implements ISO2FlowmeterValuesDTO {
    timespan!: Date;
    value!: number;

    constructor(data?: ISO2FlowmeterValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timespan = _data["timespan"] ? new Date(_data["timespan"].toString()) : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SO2FlowmeterValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SO2FlowmeterValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timespan"] = this.timespan ? this.timespan.toISOString() : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ISO2FlowmeterValuesDTO {
    timespan: Date;
    value: number;
}

export enum SO2StreamGroupChildrenTypes {
    KTLTrain1 = 0,
    KTLTrain2 = 1,
    KTLTrain3 = 2,
    KTLTrain4 = 3,
    SGP = 4,
}

export class KTLSGPSO2RecalculationRecordDTO implements IKTLSGPSO2RecalculationRecordDTO {
    id!: number;
    startTime!: Date;
    endTime!: Date;
    type!: DataRecoveryType;
    method!: RecoveryMethodType;
    ratioStartTime?: Date | null;
    ratioEndTime?: Date | null;
    margin!: number;
    average!: number;
    ratio41!: number;
    ratio38!: number;
    ratio26!: number;
    ratio0!: number;
    slopeInc!: number;
    interceptInc!: number;
    slopeDec!: number;
    interceptDec!: number;
    plantType!: Plant;
    area!: SO2StreamGroupChildrenTypes;
    user!: string;
    comment!: string;
    logged!: Date;
    properties!: { [key: string]: any; };

    constructor(data?: IKTLSGPSO2RecalculationRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.properties = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
            this.ratioStartTime = _data["ratioStartTime"] ? new Date(_data["ratioStartTime"].toString()) : <any>null;
            this.ratioEndTime = _data["ratioEndTime"] ? new Date(_data["ratioEndTime"].toString()) : <any>null;
            this.margin = _data["margin"] !== undefined ? _data["margin"] : <any>null;
            this.average = _data["average"] !== undefined ? _data["average"] : <any>null;
            this.ratio41 = _data["ratio41"] !== undefined ? _data["ratio41"] : <any>null;
            this.ratio38 = _data["ratio38"] !== undefined ? _data["ratio38"] : <any>null;
            this.ratio26 = _data["ratio26"] !== undefined ? _data["ratio26"] : <any>null;
            this.ratio0 = _data["ratio0"] !== undefined ? _data["ratio0"] : <any>null;
            this.slopeInc = _data["slopeInc"] !== undefined ? _data["slopeInc"] : <any>null;
            this.interceptInc = _data["interceptInc"] !== undefined ? _data["interceptInc"] : <any>null;
            this.slopeDec = _data["slopeDec"] !== undefined ? _data["slopeDec"] : <any>null;
            this.interceptDec = _data["interceptDec"] !== undefined ? _data["interceptDec"] : <any>null;
            this.plantType = _data["plantType"] !== undefined ? _data["plantType"] : <any>null;
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.user = _data["user"] !== undefined ? _data["user"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.logged = _data["logged"] ? new Date(_data["logged"].toString()) : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
        }
    }

    static fromJS(data: any): KTLSGPSO2RecalculationRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KTLSGPSO2RecalculationRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["ratioStartTime"] = this.ratioStartTime ? this.ratioStartTime.toISOString() : <any>null;
        data["ratioEndTime"] = this.ratioEndTime ? this.ratioEndTime.toISOString() : <any>null;
        data["margin"] = this.margin !== undefined ? this.margin : <any>null;
        data["average"] = this.average !== undefined ? this.average : <any>null;
        data["ratio41"] = this.ratio41 !== undefined ? this.ratio41 : <any>null;
        data["ratio38"] = this.ratio38 !== undefined ? this.ratio38 : <any>null;
        data["ratio26"] = this.ratio26 !== undefined ? this.ratio26 : <any>null;
        data["ratio0"] = this.ratio0 !== undefined ? this.ratio0 : <any>null;
        data["slopeInc"] = this.slopeInc !== undefined ? this.slopeInc : <any>null;
        data["interceptInc"] = this.interceptInc !== undefined ? this.interceptInc : <any>null;
        data["slopeDec"] = this.slopeDec !== undefined ? this.slopeDec : <any>null;
        data["interceptDec"] = this.interceptDec !== undefined ? this.interceptDec : <any>null;
        data["plantType"] = this.plantType !== undefined ? this.plantType : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["user"] = this.user !== undefined ? this.user : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["logged"] = this.logged ? this.logged.toISOString() : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IKTLSGPSO2RecalculationRecordDTO {
    id: number;
    startTime: Date;
    endTime: Date;
    type: DataRecoveryType;
    method: RecoveryMethodType;
    ratioStartTime?: Date | null;
    ratioEndTime?: Date | null;
    margin: number;
    average: number;
    ratio41: number;
    ratio38: number;
    ratio26: number;
    ratio0: number;
    slopeInc: number;
    interceptInc: number;
    slopeDec: number;
    interceptDec: number;
    plantType: Plant;
    area: SO2StreamGroupChildrenTypes;
    user: string;
    comment: string;
    logged: Date;
    properties: { [key: string]: any; };
}

export enum DataRecoveryType {
    SO2Concentration = 0,
    FlueGasFlowrate = 1,
    SO2EmissionsX501 = 2,
    SO2StackX501 = 3,
}

export enum RecoveryMethodType {
    Average20min = 0,
    Ratio = 1,
    Interpolation = 2,
}

export enum UserGroups {
    SuperUser_Support = 0,
    Chief_Technologist = 1,
    Read_OnlyUser = 2,
    KTL_Engineer = 3,
    KTL_Operator = 4,
    KTL_Diagnostic = 5,
    SGP_Engineer = 6,
    SGP_Operator = 7,
    SGP_Diagnostic = 8,
    SGI_Engineer = 9,
    SGI_Diagnositican = 10,
    Field_Engineer = 11,
    Field_Operator = 12,
    Field_Diagnositican = 13,
    Field_ProdPlanAnalyst = 14,
    LPG_Engineer = 15,
    LPG_Operator = 16,
    LPG_Diagnositican = 17,
    LPG_ProdPlanAnalyst = 18,
    SO2_Engineer = 19,
    IU_Engineer = 20,
    IU_Operator = 21,
    FGP_Engineer = 22,
    FGP_Operator = 23,
    FGI_Engineer = 24,
    FGI_Operator = 25,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}